<template lang="">
  <div v-if="this.loading">
    <pageLoader :msg='loadingMsg'/>
  </div>
  <div class="row justify-content-center" @click="closeErrorsContainer($event)">
    <div class="col-12 col-md-10 col-lg-11 col-xl-11 col-xxl-11">
      <div class="multi-quote">
        <div class="row position-relative justify-content-between gap-0">
          <div class="col-md-4 position-relative z-3 pt-0 mobile-view" >
            <p class="request_Id d-flex gap-1 p-3 mb-2 journeyId_container">
              <span class="cid_number">JID: </span>
              <strong>{{requestId}}</strong>
              <div class="copy_container">
                <img src="@/assets/images/copy-icon.svg" class="copy-icon p-0 m-0" @click="copyToClipboard" v-if="!copySuccess"/>
                <img src="@/assets/images/accept.png" class="copy-icon-tick m-0 p-0" v-if="copySuccess" />
                <p class="copy_tooltip px-2 py-1 rounded">{{ !copySuccess ? 'Copy' : 'Copied' }}</p>
              </div>
            </p>
            <div class="mq_left-panel">
              <div class="sq_errors-container d-flex flex-column align-items-start gap-1 p-2 mb-0" v-if="displayErrors.length > 0">
                <p class="w-100 d-flex gap-1 mb-0 d-flex justify-content-between" @click="toggleSQErrors()">
                  <span style="font-size: 15px">Single Quote Errors</span>
                  <img src="../../assets/images/minus.svg" class="plusminusicon" v-show="showSQErrors"/>
                  <img src="../../assets/images/plus.svg" class="plusminusicon" v-show="!showSQErrors"/>
                </p>
                <div v-show="showSQErrors" class="mt-2 singleQuote_errors">
                  <p v-for="(error, index) in displayErrors" :key="error" class="my-1">{{index+1}}&nbsp; {{error}}</p>
                </div>
              </div>
              <div>
                <div class="mq_cards-highlight headingcards mb-0 d-flex justify-content-between align-items-center vehicle_details-header mt-0">
                  <div>
                    <div class="mb-2 d-flex justify-content-between align-items-center">
                      <h6 class="mb-0">{{ motorProductType === '4W-Pvt' ? 'CAR DETAILS' : 'BIKE DETAILS' }}</h6>
                      <!-- <a href="" class="editform"  @click="openEditmodal"><img src="../../assets/images/edit.svg"  />Edit</a> -->                      
                      <button class="editform border-0" @click="openEditmodal" v-if="!isChangeFilter"><img src="@/assets/images/edit-pencil.png" width="24" height="24"/>Edit</button>
                    </div>
                    <p class="mb-0 d-flex flex-wrap gap-2" > 
                      <span>{{this.quoteCategory != 'New' ? this.userData?.vehicleNumber : 'NEW'}}&nbsp;&nbsp;|</span>
                      <span >{{this.userData.rtoCode || formCodesForVehicle.rtoCode}} ({{this.userData.city?.toUpperCase() || formCodesForVehicle.city?.toUpperCase()}})&nbsp;&nbsp;|</span>
                      <span >{{this.userData.carMake?.makeDescription.toUpperCase()}}&nbsp;&nbsp;|</span>
                      <span >{{this.userData.model?.modelDesc.toUpperCase()}}&nbsp;|</span> 
                      <span >{{this.userData.fuelType?.toUpperCase()}}&nbsp;&nbsp;|</span> 
                      <span >{{this.userData.variant?.variantDesc.toUpperCase()}}&nbsp;&nbsp;|</span>
                      <span >MFG. YEAR {{ this.userData?.MfgYear}} </span> 
                    </p>
                  </div>
                </div>
                <div class="filter" v-if="screenWidth < 768" @click="toggleContent">
                  <img src="../../assets/images/filtericon.svg"   />
                  <p class="filter-header mb-2">Sort & Filter</p>
                  <!-- <div class="counter  mb-2">{{this.quoteCategory==='Roll-Over' ? 3:2}}</div> -->
                </div>
              </div>
              <div class="formobilecotent" v-if="screenWidth >= 768 || showContent">
                <div class="flip-container mq_cards-highlight" :class="{ 'flipped': modifyDate, 'flip-container-new': this.quoteCategory == 'New', 'flip-container-tp': this.userData?.tpInsurerName && this.quoteCategory=='Roll-Over' && displayTPSection() }">
                  <div class="flip-inner">
                    <div class="headingcards front mt-0 p-3" v-show="!modifyDate">
                      <div class="d-flex gap-2 align-items-center justify-content-between" v-if="this.userData?.prevPolicyType != 'StandaloneTP(1)'">
                        <strong class="mb-0">IDV COVER (INSURED VALUE)</strong>
                        <p class="idvValue d-flex align-items-center gap-1 idv_hover" @click="openIDVModal()">
                          <span class="cardprice" v-if="hasValidIDV">&#8377; {{formatIndianCurrency(requestBody?.product?.idvDetails?.insuredDeclaredValue || 0)}}</span>
                          <span class="cardprice select_idv" v-else-if="requestBody?.product?.idvDetails?.insuredDeclaredValue === 0">SELECT IDV</span>
                          <span class="cardprice select_idv" v-else>SELECT IDV</span>
                          <img src="@/assets/images/right-arrow.svg" width="12" height="12" class="arrowicon" />

                          <div class="idvNot_Applicable p-2" v-if="loading2">
                            <strong class="mb-0">👆 Please wait for all the quotes to load</strong>
                          </div>
                        </p>
                      </div>
                      <div class="mt-3" v-if="this.quoteCategory=='Roll-Over' && this.userData?.prevPolicyType != 'StandaloneTP(1)'">
                        <div class="d-flex gap-2 align-items-center justify-content-between" v-if="this.userData?.previousPolicyExpired == 'false'">
                          <strong class="mb-0"> PREVIOUS NO CLAIM BONUS (NCB)%</strong>
                          <p class="idvValue d-flex align-items-center gap-1" @click="(!this.userData?.prePolicyGreaterThan90Days && ownershipTransferFlag != 'true') ? handleNCB() : $event.stopImmediatePropagation()" 
                          :class="{
                            'ncbValue_hover': this.userData?.prePolicyGreaterThan90Days || ownershipTransferFlag == 'true'
                          }"
                          v-if="this.userData.applicablePercentage !== undefined">
                            <span class="cardprice">{{!this.userData.applicablePercentage ? 0 : this.userData.applicablePercentage}}{{String(this.userData.applicablePercentage).includes('%') ? '' : '%'}}</span>
                            <img v-if="!this.userData?.prePolicyGreaterThan90Days && ownershipTransferFlag != 'true'" src="@/assets/images/right-arrow.svg" width="12" height="12" class="arrowicon"/>

                            <div class="ncbNot_Applicable p-2" v-if="this.userData?.prePolicyGreaterThan90Days && ownershipTransferFlag=='true'">
                              <strong class="mb-2">👆Not eligible for NCB</strong>
                              <p class="mb-0">NCB is set to 0% because previous policy expired more than 90 days ago and the {{ this.motorProductType && this.motorProductType == '2W-Pvt' ? 'bike' : 'car' }} was sold or transferred to a new owner within the last 12 months.</p>
                            </div>
                            <div class="ncbNot_Applicable p-2" v-else-if="this.userData?.prePolicyGreaterThan90Days">
                              <strong class="mb-2">👆Not eligible for NCB</strong>
                              <p class="mb-0">NCB is set to 0% because previous policy expired more than 90 days ago</p>
                            </div>
                            <div class="ncbNot_Applicable p-2" v-else-if="ownershipTransferFlag=='true'">
                              <strong class="mb-2">👆Not eligible for NCB</strong>
                              <p class="mb-0">The {{ this.motorProductType && this.motorProductType == '2W-Pvt' ? 'bike' : 'car' }} was sold or transferred to a new owner within the last 12 months.</p>
                            </div>
                          </p>
                        </div>
                      </div>
                      <div class="d-flex mt-3 gap-2 align-items-center justify-content-between" v-if="this.userData?.prevPolicyType && this.quoteCategory=='Roll-Over'">
                        <strong class="mb-0">PREVIOUS POLICY TYPE</strong>
                        <p class="mb-0" v-if="insurerInfo?.policyType">{{ insurerInfo?.policyType?.find(policy => policy.VALUE == this.userData?.prevPolicyType)?.NAME?.toLowerCase()?.replace('policy', '').toUpperCase() || "" }}</p>
                      </div>
                      <div class="d-flex mt-3 flex-wrap gap-1 align-items-center justify-content-between" v-if="this.userData?.prevInsurerName && this.quoteCategory=='Roll-Over'">
                        <strong class="mb-0">PREVIOUS INSURER NAME</strong>
                        <div class="d-flex gap-1 align-items-center prev_insurer-detail">
                          <p class="mb-0">{{ this.userData?.prevInsurerName || "" }}</p>
                          <img src="@/assets/images/info-extra.png" width="16" height="16"/>
                          <p class="mb-0 insurer_name">{{ this.insurerInfo?.insurerList.find(insurer => insurer.manufacturer_id == this.userData?.prevInsurerName)?.manufacturer_name || "" }}</p>
                        </div>
                      </div>
                      <div class="d-flex mt-3 gap-1 flex-wrap align-items-center justify-content-between" v-if="this.userData?.tpInsurerName && this.quoteCategory=='Roll-Over' && displayTPSection()">
                        <strong class="mb-0">TP INSURER NAME</strong>
                        <div class="d-flex gap-1 align-items-center prev_insurer-detail">
                          <p class="mb-0">{{ this.userData?.tpInsurerName || "" }}</p>
                          <img src="@/assets/images/info-extra.png" width="16" height="16"/>
                          <p class="mb-0 insurer_name">{{ this.insurerInfo?.insurerList.find(insurer => insurer.manufacturer_id == this.userData?.tpInsurerName)?.manufacturer_name || "" }}</p>
                        </div>
                      </div>
                      <template v-if="this.quoteCategory=='Roll-Over' && this.userData?.previousPolicyExpired == 'false'">
                        <div v-if="isPreviousExpiryDate() || isPackagePolicy()" class="mt-3">
                          <div class="d-flex flex-wrap gap-2 align-items-center justify-content-between">
                            <strong class="mb-0">PREVIOUS POLICY EXPIRY DATE</strong>
                            <p class="idvValue d-flex align-items-center gap-0" @click="handleDateChange(this.userData.OdDate, 'OdDate', 'Previous Policy Expiry Date')">
                              <span class="cardprice">{{formatDateToMonthString(this.userData.OdDate)}}</span>
                              <img src="@/assets/images/right-arrow.svg" width="12" height="12" class="arrowicon"/>
                            </p>
                          </div>
                        </div>
                        <div v-else class="mt-3">
                          <div class="d-flex flex-wrap gap-2 align-items-center justify-content-between">
                            <strong class="mb-0">OD POLICY EXPIRY DATE</strong>
                            <p class="idvValue d-flex align-items-center gap-1" @click="handleDateChange(this.userData.OdDate, 'OdDate', 'OD Policy Expiry Date')">
                              <span class="cardprice">{{formatDateToMonthString(this.userData.OdDate)}}</span>
                              <img src="@/assets/images/right-arrow.svg" width="12" height="12" class="arrowicon"/>
                            </p>
                          </div>
                        </div>
                        <div v-if="displayTPSection()" class="mt-3">
                          <div class="d-flex flex-wrap gap-2 align-items-center justify-content-between">
                            <strong class="mb-0">TP POLICY EXPIRY DATE</strong>
                            <p class="idvValue d-flex align-items-center gap-1" @click="handleDateChange(this.userData.TpDate, 'TpDate', 'TP Policy Expiry Date')">
                              <span class="cardprice">{{formatDateToMonthString(this.userData.TpDate)}}</span>
                              <img src="@/assets/images/right-arrow.svg" width="12" height="12" class="arrowicon"/>
                            </p>
                          </div>
                        </div>
                      </template>
          <div class="mt-3">
            <div class="d-flex gap-2 align-items-center justify-content-between">
              <strong class="mb-0">REGISTRATION DATE</strong>
              <span class="">{{formatDateToMonthString(this.userData.RegDate)}}</span>
            </div>
          </div>
          <div class="d-flex gap-2 align-items-center justify-content-between mt-3">
            <strong class="mb-0">POLICY HOLDER TYPE</strong>
            <select class="my-0 policy_holder-type" v-model="policyHolderType" @change="setUserType(true)">
              <option value="individual" selected>INDIVIDUAL</option>
              <option value="corporate">CORPORATE</option>
            </select>
          </div>
          <div class="mt-3 ownership_transfer_container" v-if="this.quoteCategory !== 'New'">
            <strong class="mb-0">OWNERSHIP CHANGED IN LAST 12 MONTHS ?</strong>
            <div class="d-flex align-items-center mt-2">
              <div class="form-check form-check-inline">
                <input
                  class="form-check-input"
                  type="radio"
                  id="ownership_yes"
                  name="ownership_transfer"
                  v-model="ownershipTransferFlag"
                  value="true"
                  @change="ownershipTransferChange()"
                >
                <label class="form-check-label mt-1" for="ownership_yes">YES</label>
              </div>

              <div class="form-check form-check-inline mb-0">
                <input
                  class="form-check-input"
                  type="radio"
                  id="ownership_no"
                  name="ownership_transfer"
                  v-model="ownershipTransferFlag"
                  value="false"
                  @change="ownershipTransferChange()"
                >
                <label class="form-check-label mt-1" for="ownership_no">NO</label>
              </div>
              <div class="mb-0 ncb_Discount-Message" v-if="ownershipTransferFlag=='true'">
                <p class="mb-0"> <img class="announcement" src="@/assets/images/announcement.png" width="20" height="20"/> NCB will be set to 0%</p>
              </div>
            </div>
          </div>
          </div>
          <div class="headingcards back d-flex flex-column" v-show="modifyDate">
            <div class="d-flex gap-2 align-items-center mb-3">
              <img src="@/assets/images/backarrow.svg" width="16" height="16" @click="notEditingDate()" class="arrowicon" />
              <strong class="date_heading">{{setDateText?.toUpperCase()}}</strong>
            </div>
            <div class="position-relative">
              <input type="date" class="form-control" v-model="modifyDateValue" @change="dateChangeOnMQ($event)"
                :max="modifyDate=='RegDate' ? calculateMaxDate() : modifyDate=='OdDate' ? maxOdTpDate() : modifyDate=='TpDate' ? maxTpDate() :'9999-12-31'"
                :min="modifyDate=='RegDate' ? calculateMinDate() :(modifyDate=='OdDate' || modifyDate=='TpDate') ? minOdDate() :'1900-01-01'" @input="limitYear"
                style="width: 100%; height: 32px !important" id="modifyDateValue" />
              <span class="data-placeholder" @click="openDatePicker('modifyDateValue')"
                v-if="isMobileView() && !modifyDateValue">dd-mm-yyyy</span>
              <img src="/images/date.svg" class="downarrowimage" />
              <small class="error-text idvError d-block mt-2" v-if="dateError">{{dateError}}</small>
            </div>
            <div class="d-flex align-items-center justify-content-end gap-2 mt-auto">
              <button class="btn mt-3 border" @click="notEditingDate()">Cancel</button>
              <!-- Apply button removed as requested -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="d-flex align-items-center gap-1 mt-3 motor_covers-header"><img src="@/assets/images/motor-shield.png" width="24" height="24"/>MOTOR COVERS & DISCOUNTS</div>
  <article v-for="(categoryData, categoryName) in uniqueAddons!=undefined && uniqueAddons" :key="categoryName"
      class="FilterAccordian headingcards mt-3 cursor-pointer mq_cards-highlight">
      <header class="d-flex justify-content-between align-items-center select-all" :class="{'mb-2': categoryData.expand}"
        @click="toggleCategory(categoryName)">
        <div class="d-flex gap-2 align-items-center">
          <h6 class="question-title mb-0">
            {{ formatCategoryName(categoryName) }}
          </h6>
          <label v-show="categoryData.expand" @click.stop :for="categoryName">
            <p class="d-flex align-items-center gap-2">
              <input type="checkbox" @change="selectAllAddons(categoryData, categoryName, $event.target.checked)" class="form-check-input"
                :id="categoryName" v-model="categoryData.selectAll" />
              <span style="font-size: 14px;">SELECT ALL</span>
            </p>
          </label>
        </div>
        <button class="btn p-0">
          <img src="../../assets/images/minus.svg" class="plusminusicon" v-show="categoryData.expand" />
          <img src="../../assets/images/plus.svg" class="plusminusicon" v-show="!categoryData.expand" />
        </button>
      </header>
      <transition mode="out-in" name="fadeAndSlide">
        <div v-show="categoryData.expand">
          <div>
            <div v-for="addon in categoryData.addon" :key="addon.optionName" class="individual-Addon py-2">
              <template v-if="!((addon.optionSelected === 'paCvr' && policyHolderType === 'corporate') 
              || (this.quoteCategory === 'New' && addon.optionSelected === 'payAsDrv'))">
                      <label class="d-block my-0" :for="addon.optionName+'-'+addon.policyType">
                        <div class="d-flex align-items-center gap-2 addon_name_desc">
                          <input :id="addon.optionName+'-'+addon.policyType" type="checkbox" :checked="isAddonSelected(addon)" @change="handleAddonSelection(categoryData, addon, $event.target.checked, categoryName)" class="form-check-input"/>
                          <span style="font-size: 14px;">{{ addon.optionName.toUpperCase() }}</span>
                        </div>
                      </label>
                          <!-- Text Input -->
                      <input  v-if="addon.type === 'Text' && selectedUniqueAddons.find(add => add.optionName == addon.optionName) != undefined" v-model="selectedUniqueAddons.find(add => add.optionName == addon.optionName).temp_price"  type="number"  step="1" min="0" @keydown="e => (e.key === '.' || e.key==='e' || e.key==='E' || e.key==='=' || e.key==='+' || e.key==='-') && e.preventDefault()" class="form-control my-2"  :class="{ 'errorField': (addon.type === 'Text' && selectedUniqueAddons.find(add => add.optionName == addon.optionName) != undefined) && errorContainerAndOthers.find(i => i.name == addon.optionName)?.errorMessage }"  @blur="handleFieldSelection(addon)" @input="setAddonInputValue(addon, $event.target.value)" :id="addon.optionName+'-'+addon.policyType" :placeholder="!selectedUniqueAddons.find(add => add.optionSelected == addon.optionSelected).temp_price && 'ENTER AMOUNT'"  />
                      <p class="error-text idvError mt-0 mb-2" v-if="(addon.type === 'Text' && selectedUniqueAddons.find(add => add.optionName == addon.optionName) != undefined) && errorContainerAndOthers.find(i => i.name == addon.optionName)?.errorMessage" v-html="errorMsgHtml(errorContainerAndOthers.find(i => i.name == addon.optionName)?.errorMessage)"/>
                          <!-- Select Input -->
                      <div class="position-relative" >
                        <select 
                          class="form-control my-2"
                          :class="{ 'errorField': (addon.type === 'Single-Select' && selectedUniqueAddons.find(add => add.optionName == addon.optionName) != undefined) && errorContainerAndOthers.find(i => i.name == addon.optionName)?.errorMessage }"
                          v-if="addon.type === 'Single-Select' && selectedUniqueAddons.find(add => add.optionName == addon.optionName) != undefined"
                          v-model="selectedUniqueAddons.find(add => add.optionSelected == addon.optionSelected).temp_price"
                          @blur="handleFieldSelection(addon)"
                          @input="setAddonInputValue(addon, $event.target.value)"
                          :id="addon.optionName+'-'+addon.policyType">
                        <option 
                          v-for="valueOfAddon in addon.values" 
                          :key="valueOfAddon.text"
                          :value="valueOfAddon.value" >
                          {{ addon.optionName === 'Pay as you Drive' ? '' : '₹' }}&nbsp;
                          {{ formatIndianCurrency(valueOfAddon.value) }}
                          {{ addon.optionName === 'PAY AS YOU DRIVE' ? 'KM/YR' : '' }}
                        </option>
                      </select>
                      <img v-if="addon.type =='Single-Select' && selectedUniqueAddons.find(add => add.optionName == addon.optionName) != undefined" src="/images/downarrow.svg" class="downarrowimage" >
                      </div>
                      <p class="error-text idvError mt-0 mb-2" v-if="(addon.type === 'Single-Select' && selectedUniqueAddons.find(add => add.optionName == addon.optionName && add.policyType == addon.policyType) != undefined && this.activePolicyType==addon.policyType) && errorContainerAndOthers.find(i => i.name == addon.optionName && i.policyType == addon.policyType)?.errorMessage" v-html="errorMsgHtml(errorContainerAndOthers.find(i => i.name == addon.optionName && i.policyType == addon.policyType)?.errorMessage)"/>
                      <div class="zeroDep_Selection mt-3 p-2 rounded my-2" v-show="quoteCategory !== 'New' && addon.optionSelected == 'zeroDep' && selectedUniqueAddons.find(add => add.optionName == addon.optionName) != undefined">
                        <div class="d-flex flex-column gap-2">
                          <strong>DO YOU HAVE ZERO DEP IN YOUR PREVIOUS POLICY?</strong>
                          <div class="d-flex align-items-center">
                            <div class="form-check form-switch pl-0">
                              <input
                                class="form-check-input"
                                type="checkbox"
                                id="zeroDep_toggle"
                                v-model="currentZeroDep"
                                @change="zeroDepCurrentChange()"
                              >
                              <label class="form-check-label" for="zeroDep_toggle">
                                {{ currentZeroDep ? 'YES' : 'NO' }}
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div v-if="addon.optionSelected == 'paCvr' && paOwnerDriverSelectionModel && selectedUniqueAddons.find(add => add.optionName == addon.optionName) == undefined" class="personal_accident-reason d-flex gap-2 my-2 px-2 py-1 rounded">
                        <strong class="reason_pacvr">Reason: </strong>
                        <strong class="reason_pacvr">{{paOwnerDriverSelection.find(obj => obj.code == paOwnerDriverSelectionModel).name}}</strong>
                      </div>
                    </template>
                <p class="hover-dispaly p-2"
                :class="{'set_hover-position': (addon.type === 'Single-Select' || addon.type === 'Text') && selectedUniqueAddons.find(add => add.optionName == addon.optionName) != undefined, 'set_zeroDep': addon.optionSelected == 'zeroDep' && selectedUniqueAddons.find(add => add.optionName == addon.optionName) != undefined}"
                style="font-size: 14px;"
                v-if="!((addon.optionSelected === 'paCvr' && policyHolderType === 'corporate') || (this.quoteCategory === 'New' && addon.optionSelected === 'payAsDrv'))">
                {{addon.optionDesc}}</p>
            </div>
          </div>
        </div>
      </transition>
    </article>
    <div class="errors-button d-flex flex-column align-items-end">
      <transition name="fade">
        <div class="error-display" v-if="errorListFlag && errors.length > 0" @click.stop="remainErrorsOpen">
          <div v-for="(manufacturer, index) in groupedErrors" :key="index" class="manufacturer-group my-1 p-2">
            <div class="manufacturer-header" @click.stop="toggleManufacturer(manufacturer.id)">
              <span class="toggle-icon">{{ manufacturer.isOpen ? '▼' : '▶' }}&nbsp;</span>{{ manufacturer.id
              }}&nbsp;({{manufacturer.products.length}})
            </div>
            <transition name="fade">
              <div v-if="manufacturer.isOpen" class="product-errors">
                <div v-for="product in manufacturer.products" :key="product.productId" class="product-error my-2">
                  <strong>{{ product.productId }}</strong>: {{ product.errorMessage }}
                </div>
              </div>
            </transition>
          </div>
        </div>
      </transition>
      <button @click.stop="openErrorList" class="d-flex align-items-center gap-2">
        <span>Errors</span>
        <div class="loader" v-if="pollapiflag"></div>
        <span v-if="!pollapiflag">{{errors.length}}</span>
      </button>
    </div>
</div>

<div class="col-md-8 formobileonly pl-0 position-relative">
  <nav class="mb-0 policyTypes_wrapper d-flex align-items-baseline justify-content-between">
    <div class="navigation-policytypes-wrapper" v-if="this.policyTypes.length > 1">
      <div class="navigation-policytypes d-flex align-items-center" id="nav-tab" role="tablist">
        <button v-for="(policyType, index) in this.policyTypes" :key="policyType.name" class="nav-link px-3 py-2"
          :class="{'active': activePolicyType == policyType.name}" :id="policyType.name"
          @click="setPolicyType(policyType.name)" v-show="this.responseData.filter(data =>data.insuranceAndProducts.policyType == policyType.name).length > 0"> {{policyType.description?.toUpperCase()}} [{{this.responseData.filter(data =>
          data.insuranceAndProducts.policyType == policyType.name).length}}]</button>
      </div>
    </div>
    <div class="dropdown custom-dropdown">
      <button class="btn btn-secondary dropdown-toggle" type="button" id="dropdownMenuButton"
        data-bs-toggle="dropdown" aria-expanded="false" :disabled="loading2">
        <img src="@/assets/images/sort-up.png" alt="sort icon" style="width: 12px; height: 12px;">
        SORT BY
      </button>
      <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton">
        <li><a class="dropdown-item" :class="{'highlight-sorting': sortOrder == 1}" href="#" @click.prevent="sortByLowestPremium()">Premium Low to High</a></li>
        <li><a class="dropdown-item" :class="{'highlight-sorting': sortOrder == 2}" href="#" @click.prevent="sortByHighestPremium()">Premium High to Low</a></li>
      </ul>
    </div>
  </nav>
  <div class="d-grid gap-3 multiquoteborder">
    <div v-if="responseData.length > 0">
      <div class="text-dark text-center mt-4">{{policylengthcheck(responseData,activePolicyType)}}</div>
      <div class="headingcards row justify-content-between mq_card-insurer"
        v-for="item in filteredAndSortedData"
        :key="item?.supportingData?.insCompanyLogo">
        <div class="col-md-3 col-12 mobile-content">
          <div class="img-container align-items-start p-1">
            <img :src="resolveImagePath(item?.supportingData?.insCompanyLogo)" alt="Bank Logo"
              class="quote-logo productImage" draggable="false" />
          </div>
        </div>
        <div class="col-md-8 col-12">
          <div class="row">
            <div class="col-md-10 col-10 px-0">
              <div class=""
                v-if="!['StandaloneTP(1)', 'StandaloneTP(3)', 'StandaloneTP(5)'].includes(item.insuranceAndProducts.policyType) && item.supportingData.insuredDeclaredValue.suggestedIDV">
                <div class="idvcolver d-flex justify-content-around gap-1 mt-0 text-center p-0">
                  <div class="text-start">
                    <span class="">IDV COVER </span>
                    <p>&#8377; {{item.insuranceAndProducts.policyType=='StandaloneTP(1)' ? 0 :
                      !item.supportingData.insuredDeclaredValue.suggestedIDV ? 0 :
                      this.formatIndianCurrency(item.supportingData.insuredDeclaredValue.suggestedIDV)}}</p>

                  </div>
                  <div class="text-start">
                    <span class="pl-0 mb-0  idv_values_mq">MIN IDV </span>
                    <p>&#8377; {{this.formatIndianCurrency(item.supportingData.insuredDeclaredValue.minimumIDV)}}</p>
                  </div>
                  <div class="text-start">
                    <span class="pl-0 mb-0  idv_values_mq">MAX IDV </span>
                    <p>&#8377; {{this.formatIndianCurrency(item.supportingData.insuredDeclaredValue.maximumIDV)}}</p>
                  </div>

                </div>
              </div>
            </div>
            <div class="col-md-2 col-2 p-1 ">
              <div class="">

                <div class="text-center mt-2 p-1" v-if="item.supportingData.Messages != undefined">
                  <a :href="item.supportingData.Messages.brochureLink" target="_blank" data-bs-toggle="tooltip"
                    class="downloadBroucher" data-bs-placement="top" title="Download Brochure">
                    <img src="../../assets/images/pdf.svg" class="pdficon" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="addons_selected_container py-2 px-3 rounded" v-if="sortedAddons(item.insuranceAndProducts.productCode, item).length > 0 && !loading2">
          <div class="d-flex align-items-center justify-content-between addons_selected_header pb-0" @click="expandAddons(item)">
            <strong class="mb-0">ALL SELECTED ADDONS</strong>
            <div class="d-flex align-items-center gap-1">
              <button class="btn p-0 highlight_text">{{ !item.addonView ? "SEE ALL" : "SEE LESS" }}</button>
              <img src="@/assets/images/up-arr-dbl.png" width="12" height="9" v-if="item.addonView"/>
              <img src="@/assets/images/down-arr-dbl.png" width="12" height="9" v-if="!item.addonView"/>
            </div>
          </div>
          <div class="col-md-12 col-12 addons_selected_body mt-2 pb-2" v-if="item.addonView">
            <div class="d-flex flex-wrap gap-2 mt-0"
              v-if="sortedAddons(item.insuranceAndProducts.productCode, item).length > 0 && !loading2">
              <div class="d-flex flex-wrap flex-column gap-1 align-items-start mt-2">
                <!-- Display Addons for the Matching Product Code -->
                <div
                  :id="'addons-'+item.insuranceAndProducts.productCode.toLowerCase().split('(')[0].replace(/[^a-z0-9]/g, '_')+'_'+item.insuranceAndProducts.policyType.toLowerCase().split('(')[0].replace(/[^a-z0-9]/g, '_')"
                  class="remove-expand d-flex gap-2 flex-wrap">
                  <!-- Addons List -->
                  <template v-for="addon in sortedAddons(item.insuranceAndProducts.productCode, item)"
                    :key="addon.addonName?.optionSelected || addon.addonName?.optionName || addon.addonName?.optionDescription"
                    v-show="!(addon?.addonName?.optionSelected=='paCvr' && (item.insuranceAndProducts.productCode=='GO2WOD' || item.insuranceAndProducts.productCode=='GO4WOD'))">
                    <div class="d-flex align-items-center gap-1 specifications" :class="{'addon_include': (addon.premium > 0 || getPremiumIncludedFlag(item, addon.addonName?.optionSelected)), 'addon_remove': !(addon.premium > 0 || getPremiumIncludedFlag(item, addon.addonName?.optionSelected))}" v-if="!((item.insuranceAndProducts.policyTypeDesc === 'Own Damage' || item.insuranceAndProducts.policyType === 'StandaloneOD(1)') && (addon.addonName?.optionName?.toLowerCase().includes('tp bi') || addon.addonName?.optionDescription?.toLowerCase().includes('tp bi')))">
                      <p>{{ (addon.addonName?.optionName || addon.addonName?.optionDescription || '').toLowerCase().replace(/\b\w/g, char => char.toUpperCase()) }}   </p>
                      <p v-if="Number(addon.premium) > 0 || getPremiumIncludedFlag(item, addon.addonName?.optionSelected)">
                        {{ getPremiumIncludedFlag(item, addon.addonName?.optionSelected) ? "- Included In Plan" : `${addon.addonName?.category=='Discounts' ? '-' : ''} ₹ ${formatIndianCurrency(Number(addon.premium).toFixed(2))}` }}</p><img :src="addon.premium > 0 || getPremiumIncludedFlag(item, addon.addonName?.optionSelected)  ? 'https://img.icons8.com/3d-fluency/94/checkmark.png' : 'https://img.icons8.com/3d-fluency/94/delete-sign.png'"  class="commonicon"/>
                    </div>
                  </template>
                </div>
                <!-- <button v-if="sortedAddons(item.insuranceAndProducts.productCode).length > 3"
                  class="btn close expansion-button"
                  :id="'btn-'+item.insuranceAndProducts.productCode.toLowerCase().split('(')[0].replace(/[^a-z0-9]/g, '_')+'_'+item.insuranceAndProducts.policyType.toLowerCase().split('(')[0].replace(/[^a-z0-9]/g, '_')"
                  type="button"
                  @click="this.expansionAddons(item, item.insuranceAndProducts.productCode, item.insuranceAndProducts.policyType)">{{!item.addonView
                  ? 'Show More' : 'Show Less' }}</button> -->
              </div>
            </div>
          </div>
        </div>



        <div class=" bottomalignment d-flex align-items-center gap-2" style="border-radius:0">
          <div v-if="handleCompareVisibility(item)">
            <label class="d-flex align-items-center flex-wrap gap-1 cursor-pointer">
              <input type="checkbox"
              class="form-check-input"
              :checked="isInCompareList(item)"
              @change="toggleCompare(item)">
              <span>ADD TO COMPARE</span>
            </label>
          </div>

          <p v-if="item.productDetails.inspectionDetails.isInspectionRequired"
            class="inspection_required-MQ has-breakin px-2 py-1 mb-0 highlight_text">
            <img v-if="motorProductType == '4W-Pvt'" src="@/assets/images/inspection-icon.png"/> 
            <img v-else src="@/assets/images/inspection-bike.png"/> 
            <span>INSPECTION REQUIRED</span>
          </p>

          <p
            class="d-flex align-items-center gap-2 download_quote px-2 py-1 mb-0 highlight_text" @click="handleQuotePDF(item)" :title="downloadStatus" v-if="isSendQuotes">
            <span class="d-flex align-items-center">
              <img class="w-4" src="@/assets/images/download-arw.png"/>
              <!-- <Loading />  -->
            </span>
            <span>DOWNLOAD QUOTE</span>
          </p>

          <div class="d-flex align-items-center gap-2 mq_breakup_premium">
            <span @click="showBreakupmodal(item)"
              class="show-breakup-link"
              style="font-size: 12px;">
              PREMIUM BREAKUP
            </span>

            <button class="clickbuttons justify-content-center  d-flex gap-3 align-items-center "
              @click="getPolicydetails(item)">&#8377;&nbsp;{{formatToINR(item.productDetails.totalPremiumDetails[0].totalPremiumWithTax)}}
              <img src="../../assets/images/multiquotearrow.svg" class="commonicon" />
            </button>
          </div>
        </div>

      </div>

      <h6>{{this.plansWithAddons[1]?.title}}</h6>
      <div class="headingcards row justify-content-between" v-for="item in this.plansWithAddons[1]?.plans"
        :key="item?.supportingData?.insCompanyLogo">
        <div class="col-md-4 col-6">
          <div class="img-container">
            <img :src="resolveImagePath(item?.supportingData?.insCompanyLogo)" alt="Bank Logo"
              class="quote-logo productImage" draggable="false" />
          </div>
          <div class="d-flex align-items-center flex-wrap justify-content-start gap-1 mt-1">
            <p>Policy type - </p>
            <span>{{item.insuranceAndProducts.policyType}}</span>
          </div>
          <div class="d-flex flex-wrap gap-2 mt-2">
            <div class="d-flex align-items-center gap-1 specifications"
              v-for=" usp in this.extractUSP(item?.supportingData)" :key="usp">
              <img src="../../assets/images/checksvg.svg" class="commonicon" />
              <p>{{ usp }}</p>
            </div>
          </div>
        </div>
        <div class="col-md-4 col-6 px-0">
          <button class="clickbuttons d-flex gap-3 align-items-center" @click="this.getPolicydetails(item)">
            &#8377;&nbsp;{{formatToINR(item.productDetails.totalPremiumDetails[0].totalPremiumWithTax)}}
            <img src="../../assets/images/multiquotearrow.svg" class="commonicon" />
          </button>
          <div class="d-flex align-items-center idvcolver flex-wrap justify-content-center gap-1 mt-1" v-if="!['StandaloneTP(1)', 'StandaloneTP(3)', 'StandaloneTP(5)'].includes(item.insuranceAndProducts.policyType)">
            <p class="d-flex align-items-center">IDV COVER
              <span>&#8377;{{item.insuranceAndProducts.policyType=='StandaloneTP(1)' ? 0 :
                !item.supportingData.insuredDeclaredValue.suggestedIDV ? 0 :
                this.formatIndianCurrency(item.supportingData.insuredDeclaredValue.suggestedIDV)}}</span>
            </p>
            <div class="d-flex align-items-center gap-2">
              <p class="mb-0 idv_values_mq px-2 py-1">MIN IDV
                <strong>{{this.formatIndianCurrency(item.supportingData.insuredDeclaredValue.minimumIDV)}}</strong>
              </p>
              <p class="mb-0 idv_values_mq px-2 py-1">MAX IDV
                <strong>{{this.formatIndianCurrency(item.supportingData.insuredDeclaredValue.maximumIDV)}}</strong>
              </p>
            </div>
          </div>
          <div class="text-end d-flex align-items-center flex-wrap justify-content-center gap-1 mt-1">
            <span @click="showBreakupmodal(item)" class="show-breakup-link"
              style="font-size: 12px;text-decoration: underline;">PREMIUM BREAKUP</span>
          </div>
          <div class="text-center mt-2" v-if="item.supportingData.Messages != undefined">
            <a :href="item.supportingData.Messages.brochureLink" target="_blank" data-bs-toggle="tooltip"
              data-bs-placement="top" title="Download Brochure">
              <img src="../../assets/images/pdf.svg" class="pdficon" />
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="set-page" style="" v-if="isChangeFilter">
      <!-- This button is shown when dates or other filters are changed -->
      <button class="btn commonButton apply-button" @click="getMultiQuote()"
        :disabled="checkAddonDisability || dateError!='' || isRefreshButtonDisabled"><span>Please click here to </span>
        REFRESH QUOTE</button>
    </div>
    <div v-if="displayErrorMessages">
      <p class="mt-3 errorMessage" :innerHTML="displayErrorMessages" />
    </div>
    <div class="data-not-found" v-if="this.responseData.length==0 && this.pollapiflag && !this.loading2">
      <div v-if="!this.loading2">
        <img src="/images/data-not-found.gif" />
        <p>No products available</p>
      </div>
    </div>
    <!-- <MultiquoteLoader/> -->
    <div v-if="this.loading2" class="text-center w-100">
      <img src="/images/multiquoteloader.gif" class="mt-5" style="width:40%" />
      <p class="loading-quote">Loading more quotes for you. This may take few minutes</p>
    </div>
  </div>
</div>
</div>
</div>
<div class="compare_error-overlay" v-if="this.compareErrror">
  <div class="compare_error d-flex flex-column p-3 align-items-center gap-4">
    <span class="close_icon cursor-pointer" @click="closeCompareQuoteMessage()">&times;</span>
    <span class="compare-error">{{compareErrror}}</span>
    <button class="btn px-5 py-2" @click="closeCompareQuoteMessage()">Close</button>
  </div>
</div>
<div>

</div>
<div class="ncbOverlay" v-if="changeNCB">
  <div class="p-3 overlay_container">
    <FilterAccordian :title="this.title" :info="this.info" @update:selected-item="handleSelectedItem"
      @clearCompareList="clearCompareList" v-if="this.quoteCategory==='Roll-Over'" @handleIdvClose="closeNCB()" />
  </div>
</div>
<div class="paCvrOverlay" v-if="handleAccidentalCoverDropDown">
  <div class="p-0 overlay_container">
    <div class="d-flex justify-content-between align-items-center header-pacvr">
      <strong>PA Owner Driver</strong>
      <button class="btn px-0 bg-transparent" @click="canclePaCvrSelection()"><span class="closeModal"
          style="font-size: 22px;">&times;</span></button>
    </div>
    <div class="p-3 body-pacvr">
      <p class="mb-4">Please opt this Compulsory Personal Accident Cover, only if you have valid driving license. You
        can skip this cover, if you have personal accident policy of Rs 15 Lakhs or have another motor insurance policy
        with "Compulsory Personal Accident Cover" of Rs 15 Lakhs sum insured. This is as per IRDAI mandate. Do you want
        to continue?</p>
      <select v-model="paOwnerDriverSelectionModel" class="w-full py-2" @change="handlePaCvrReason()">
        <option disabled value="">Select Reason</option>
        <option v-for="paOwnerDriver in paOwnerDriverSelection" :key="paOwnerDriver.name" :value="paOwnerDriver.code">
          {{paOwnerDriver.name}}</option>
      </select>
      <div class="d-flex justify-content-end gap-2 align-items-center mt-2 pt-2 border-top">
        <button class="btn submit-btn" @click="submitPaCvrSelection()"
          :disabled="!paOwnerDriverSelectionModel">YES</button>
        <button class="btn cancel-btn" @click="canclePaCvrSelection()">NO</button>
      </div>
    </div>
  </div>
</div>
<div class="idvOverlay" v-if="changeIDV">
  <div class="p-3 overlay_container">
    <div class="d-flex align-items-center justify-content-between header-idv">
      <h4 class="mb-0 ml-0">IDV COVER (INSURED VALUE)</h4>
      <button class="btn px-0 bg-transparent" @click="closemodal"><span class="closeModal" style="font-size: 22px;"
          @click="cleareIDV()">&times;</span></button>
    </div>

    <!-- Add toggle button for Need IDV -->
    <div class="d-flex align-items-center justify-content-between mb-4 mt-2">
      <strong>Need IDV</strong>
      <div class="toggle-container">
        <span class="ml-2">{{ needIDV ? 'YES' : 'NO' }}</span>
        <label class="switch">
          <input type="checkbox" v-model="needIDV">
          <span class="slider round m-0"></span>
        </label>
      </div>
    </div>

    <!-- Show IDV options only if needIDV is true -->
    <div v-if="needIDV">
      <div class="d-flex gap-2 align-items-center radio_selector-idv mb-3">
        <input type='radio' id="minIDV" name="idvCovers" value="minimum" v-model="idvSelector"
          @change="handleIdvSelection('minimum', this.minIDV)" />
        <label for="minIDV">Minimum IDV</label>
        <p class="mb-0">&#8377; {{formatIndianCurrency(this.minIDV)}}</p>
      </div>
      <div class="d-flex gap-2 align-items-center radio_selector-idv mb-3">
        <input type='radio' id="maxIDV" name="idvCovers" value="maximum" v-model="idvSelector"
          @change="handleIdvSelection('maximum', this.maxIDV)" />
        <label for="maxIDV">Maximum IDV</label>
        <p class="mb-0">&#8377; {{formatIndianCurrency(this.maxIDV)}}</p>
      </div>
      <div class="d-flex gap-2 align-items-center radio_selector-idv">
        <input type='radio' id="customIDV" name="idvCovers" value="custom" v-model="idvSelector"
          @change="handleIdvSelection('custom', this.selectedIDV)" />
        <label for="customIDV">Choose IDV</label>
        <p class="mb-0">&#8377; {{formatIndianCurrency(this.selectedIDV || 0)}}</p>
      </div>
      <input type="number" class="form-control p-2 mt-3" placeholder="Enter your IDV" v-if="idvSelector=='custom'" step="1" @keydown="e => (e.key === '.' || e.key==='e' || e.key==='E' || e.key==='+' || e.key==='-') && e.preventDefault()" v-model="this.selectedIDV" :minValue="this.minIDV" :maxValue="this.maxIDV" @keyup="handleChoosenIDV($event)" />
      <small class="error-text mt-1 mb-0 idvError" v-if="idvSelector=='custom'"></small>
      <div class="accordion mt-4" id="accordionExample" v-if="this.quoteCategory != 'New'">
        <div class="accordion-item">
          <h2 class="accordion-header" id="headingOne">
            <button class="accordion-button py-2 collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
              What should be my IDV?
            </button>
          </h2>
          <div id="collapseOne" class="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
            <div class="accordion-body">
              <p>Your IDV should be at least 10% less than your previous year policy's IDV. This would be mentioned in your previous policy.</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Show message if needIDV is false -->
    <div v-else class="text-center py-3">
      <p class="mb-0">Your IDV value will be as recommended by the insurer.</p>
    </div>

    <div class="d-flex gap-2 align-items-center justify-content-end mt-4">
      <button class="btn ApplyButton" @click="applyIDV()">Update IDV</button>
    </div>
  </div>
</div>
</div>
</div>
<div class="fixed-bottom container-fluid" v-if="compareList.length > 0 && showCompareFooter">
  <div class="comparefooter">
    <div class="row align-items-center justify-content-center">
      <div class="col-md-auto comparefooter-col" v-for="(item, index) in this.compareList" :key="index">
        <div class="comparebox">
          <img class="compboxlogo" :src="
              resolveImagePath(item?.supportingData?.insCompanyLogo)
              " />
          <label class="compprodname">
            {{ item.productDetails.planOption.planName }}
          </label>
          <img class="cancel" :id="index" v-on:click="removeFromFilter(item.multi_quote_response_id)"
            src="~@/assets/images/cancel.png" />
        </div>
      </div>

      <div class="col-md-auto comparefooter-col" v-if="compareList.length < 3">
        <div class="addmorebox">
          <label class="addmore">Select More Plans</label>
        </div>
      </div>
      <div class="col-md-auto comparefooter-btn">
        <div>
          <button type="button" class="comparebtn" @click="openCompareQuote()" :disabled="compareList.length < '2'">
            Compare
            <!-- <img src="~@/assets/images/next-arrow.png" /> -->
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
  <Disclaimer :page="'MQ'"/>
<CompareQuote v-if="CompareQuoteFlag" @closeCompareQuote='closeCompareQuote' :compareList=compareList
  :motorCovers="motorCovers" @getPolicydetails=getPolicydetails :requestId="requestId" @handleQuotePDF="handleQuotePDF" :isDownloadStart="isDownloadStart" :isSendQuotes="isSendQuotes"></comparequote>
<editDetailsModal v-if="showeditmodal" @close-Editmodal="closeEditmodal" :formCodesForVehicle="formCodesForVehicle"></editDetailsModal>
<AmountBreakupSq v-if="this.openAmountBreakupflag" @emitClose="emitClose()" :selectedPlanData="this.selectedPlanData"
  :plansWithAddons="this.plansWithAddons" @getPolicydetails="getPolicydetails" :requestId="requestId" />
</template>
<script>
// import RangeSlider from "@/components/multiQuote/priceRangeSlider.vue";
import FilterAccordian from "@/components/multiQuote/filterAccordian.vue";
import Loading from "@/components/uiResuable/Loading.vue"
import editDetailsModal from "@/modals/editDetailsModal.vue";
import CompareQuote from "@/modals/comparequote.vue"
// import loading from "../pageLoaders/pageLoader.vue";
import pageLoader from "../pageLoaders/pageLoader.vue";
import alasql from 'alasql';
import MultiquoteLoader from "../pageLoaders/multiquoteLoader.vue";
import { SkeletonLoader } from "vue3-loading-skeleton";
import { getDistributer, getProductSelection, getLazyLoadingConfig } from '@/mixins/common';
import { getSpFieldsForCommunicationPayload } from '@/mixins/utils';
import AmountBreakupSq from "@/modals/amountBreakupSq.vue";
import Disclaimer from "@/components/uiResuable/Disclaimer.vue"
import { stripHtml } from '@/utils/inputSanitizer';
import { shouldSkipGodigitKycOvd } from '@/utils/godigitKycOvdSkip';


export default {
  components: {
    // RangeSlider,
    FilterAccordian,
    editDetailsModal,
    pageLoader,
    MultiquoteLoader,
    SkeletonLoader,
    CompareQuote,
    AmountBreakupSq,
    Disclaimer,
    Loading
  },
  mixins: [getDistributer, getProductSelection, getLazyLoadingConfig],
  data() {
    return {
      sortOrder: 1,
      openAmountBreakupflag: false,
      selected_plan_data: null,
      quote_request: null,
      apiCallinginterval: '',
      rmData: null,
      changeIDV: false,
      actualDeclaredIDVValue: 0,
      info: "What is the No Claim Bonus (NCB%) in your current policy?",
      idvSelector: '',
      changeNCB: false,
      compareList: [],
      CompareQuoteFlag: false,
      errorListFlag: false,
      uniqueAddons: [],
      selectedUniqueAddons: JSON.parse(sessionStorage.getItem("selectedUniqueAddons")) || [],
      plansWithAddons: [],
      showAll: false,
      showAllCardAddons: false,
      distributorID: '',
      policyExpand: true,
      addonExpand: true,
      title1: "Policy Types",
      policyTypes: [],
      policyTypesSelected: [],
      onMountFlag: true,
      changeIDV: false,
      copySuccess: false,
      insuredDeclaredValue: 0,
      actualDeclaredIDVValue: 0,
      insuredDeclaredValues: [],
      selectedItem: null,
      title: "NCB",
      info: "What is the No Claim Bonus (NCB%) in your current policy?",
      selectedIDV: 0,
      maxIDV: 0,
      minIDV: 0,
      suggestedIDV: 0,
      productCodes: [],
      apiCallinginterval: '',
      loadingMsg: "Please wait while we are fetching the data",
      loading: true,
      loading2: true,
      responseData: [],
      responseData1: [],
      requestId: "",
      requestBody: {},
      pollapiflag: true,
      screenWidth: window.innerWidth,
      showContent: false,
      idvVisibilityFlag: false,
      refetchIDVonClick: false,
      userData: {},
      rmData: {},
      quoteCategory: '',
      previousPolicyTpStartDatenew: '',
      previousPolicyTpExpiryDatenew: '',
      breakTheLoop: false,
      displayErrorMessages: "",
      showeditmodal: false,
      compareErrror: "",
      totalAddonsPremium: 0,
      totalPremiumWithAddons: 0,
      totalAddonsTax: 0,
      activePolicyType: "",
      groupedErrors: [],
      errors: [],
      // idvSelector: '',
      changeNCB: false,
      addonsMQ: [],
      selectedPlanData: {},
      policyHolderType: sessionStorage.getItem('user-type') ? JSON.parse(sessionStorage.getItem('user-type')) : "individual",
      errorContainerAndOthers: [],
      vehicleAge: 0,
      registrationYear: 0,
      motorCoversSQ: [],
      displayErrors: [],
      showSQErrors: false,
      apiReqData: {},
      motorCovers: [],
      isChangeFilter: false,
      modifyDate: "",
      modifyDateValue: "",
      setDateText: "",
      dateError: "",
      categorySelectAllStates: {},
      showCompareFooter: false,
      needIDV: true,
      handleAccidentalCoverDropDown: false,
      formCodesForVehicle: {
        rtoCode: "",
        city: ""
      },
      paOwnerDriverSelection: [
        {
          name: 'No Valid Driving Licence',
          code: 'NOVALIDDRVLIC'
        },
        {
          name: 'Other Motor Policy with CPA Cover',
          code: 'OTHERMOTORPOLICYPA'
        },
        {
          name: 'Have Standalone CPA with SI',
          code: 'STANDALONEPA'
        }
      ],
      paOwnerDriverSelectionModel: sessionStorage.getItem("reasonForPaCvr") ? JSON.parse(sessionStorage.getItem("reasonForPaCvr"))?.code : "",
      isRefreshButtonDisabled: false,
      currentZeroDep: sessionStorage.getItem('prevPolicyHasZeroDep') ? JSON.parse(sessionStorage.getItem('prevPolicyHasZeroDep')) : true,
      ownershipTransferFlag: sessionStorage.getItem("ownershipTransferCheck") ? JSON.parse(sessionStorage.getItem("ownershipTransferCheck")) : "false",
      downloadStatus: "Please click to download.",
      isDownloadStart: false,
      currentQuotePdfBase64: '',
      insurerInfo: null
    };
  },
  mounted() {
    this.distributorID = getDistributer()["distributerID"];
    this.loading2 = true;
    sessionStorage.removeItem("rtoCode");
    if (sessionStorage.getItem("idvValues")) {
      let selectedIDVInSession = JSON.parse(sessionStorage.getItem("idvValues"));
      this.selectedIDV = selectedIDVInSession.selectedIDV;
      this.idvSelector = this.userData.idvSelector;
    }
    //get Interval 
    this.apiCallinginterval = parseInt(getLazyLoadingConfig()['inerval']);
    this.quoteCategory = this.$store.state.quoteCategory;
    this.activePolicyType = (this.motorProductType == '4W-Pvt' && this.quoteCategory == 'Roll-Over') ? "Package(1+1)" : (this.motorProductType == '4W-Pvt' && this.quoteCategory == 'New') ? "Bundled(1+3)" : (this.motorProductType == '2W-Pvt' && this.quoteCategory == 'Roll-Over') ? "Package(1+1)" : (this.motorProductType == '2W-Pvt' && this.quoteCategory == 'New') ? "StandaloneTP(5)" : "Bundled(1+5)";
    this.addonsMQ = this.$store.state.configData.ADDONS_MASTER[this.motorProductType];

    // Initialize addons from session storage
    if (sessionStorage.getItem("selectedUniqueAddons")) {
      this.selectedUniqueAddons = JSON.parse(sessionStorage.getItem("selectedUniqueAddons")) || [];

      // Make sure all selectedUniqueAddons are objects with the correct structure
      this.selectedUniqueAddons = this.selectedUniqueAddons.filter(
        item => typeof item !== 'string' && item !== null && typeof item === 'object'
      );

      // Synchronize the errorContainerAndOthers for text and select inputs
      if (this.selectedUniqueAddons.length > 0) {
        this.selectedUniqueAddons.forEach(addon => {
          if (addon.type === 'Text' || addon.type === 'Single-Select') {
            let obj = {
              name: addon.optionName,
              checked: true,
              policyType: addon.policyType,
              enteredValue: addon.temp_price || addon.default,
              hasValue: (addon.temp_price || addon.default) ? true : false,
              errorMessage: addon.category != 'Accessories' ? "" : `ENTER ${addon.optionName?.toUpperCase()} VALUE`,
              errorText: `ENTER ${addon.optionName?.toUpperCase()} VALUE`
            };

            // Check if this addon is already in the error container
            const existingIndex = this.errorContainerAndOthers.findIndex(
              item => item.name === addon.optionName && item.policyType === addon.policyType
            );

            if (existingIndex === -1) {
              this.errorContainerAndOthers.push(obj);
            }
          }
        });
      }

      // --- FIX: Re-evaluate error state for text/select addons on mount ---
      this.selectedUniqueAddons.forEach(addon => {
        if (addon.type === 'Text' || addon.type === 'Single-Select') {
          const errorObj = this.errorContainerAndOthers.find(
            item => item.name === addon.optionName && item.policyType === addon.policyType
          );
          if (errorObj) {
            const value = addon.temp_price || addon.default;
            errorObj.hasValue = !!value;
            errorObj.enteredValue = value;
            errorObj.errorMessage = value
              ? ""
              : (addon.category !== 'Accessories'
                  ? ""
                  : `ENTER ${addon.optionName?.toUpperCase()} VALUE`);
          }
        }
      });
      // --- END FIX ---
    }

    // Format addons into categories for display
    this.formatMqAddonsInCategory();

    //get Multi quote
    // Update screenWidth on resize
    window.addEventListener("resize", this.updateScreenWidth);
    if (sessionStorage.getItem("userData")) {
      this.userData = JSON.parse(sessionStorage.getItem("userData"));
      if (this.userData.TpDate) {
        this.previousPolicyTpStartDatenew = this.userData.TpDate === "" ? this.calculatePreviousPolicyTpStartDate(this.userData.OdDate) : this.calculatePreviousPolicyTpStartDate(this.userData.TpDate);
        this.previousPolicyTpExpiryDatenew = this.userData.TpDate === "" ? this.previousPolicyTpExpiryDate(this.userData.OdDate) : this.userData.TpDate;
      }
      else {
        this.previousPolicyTpStartDatenew = null,
          this.previousPolicyTpExpiryDatenew = null
      }
      this.userData.idvSelector = sessionStorage.getItem('userData') && JSON.parse(sessionStorage.getItem('userData')).idvSelector != undefined ? JSON.parse(sessionStorage.getItem('userData')).idvSelector : '';
      sessionStorage.setItem('userData', JSON.stringify(this.userData));
    }
    if (this.userData) {
      this.registrationYear = new Date(this.userData.RegDate).getFullYear();
    }
    this.rmData = JSON.parse(sessionStorage.getItem("rm_data"));
    if (sessionStorage.getItem("motor_covers")) {
      this.motorCovers = JSON.parse(sessionStorage.getItem('motor_covers'))
    }
    if(sessionStorage.getItem("motorCovers")){
      this.motorCovers = JSON.parse(sessionStorage.getItem("motorCovers"));
    }
    this.policyTypes = getProductSelection()[this.motorProductType][this.$store.state.quoteCategory];
    this.getMultiQuote(this.selectedIDV);
    this.idvVisibilityFlag = true;
    // sessionStorage.removeItem('idvValues');
    this.setUserType();
    this.checkODDateMoreThan90Days();
    this.previousExpiryDateManage();
    delete this.userData.ckycRes;
    sessionStorage.removeItem("filledData");
    sessionStorage.setItem('userData', JSON.stringify(this.userData));
    sessionStorage.removeItem("isOvdFlow");
    this.insurerInfo = {
      insurerList: this.$store.state.configData?.PREVIOUS_INSURER_LIST,
      policyType: this.motorProductType === '4W-Pvt' ? this.$store.state.configData?.PREVIOUS_POLICY_TYPE?.PRPOLTYP : this.$store.state.configData?.PREVIOUS_POLICY_TYPE?.PRPOLTYP2
    }
  },
  beforeUnmount() {
    // Remove event listener on component destroy
    window.removeEventListener("resize", this.updateScreenWidth);
  },
  methods: {
    stripHtml,
    errorMsgHtml(msg) {
      return stripHtml(msg ?? '');
    },
    premiumRound(amount){
      return Math.round(amount);
    },
    policylengthcheck(responseData, activePolicyType) {
      let data = responseData.filter(data => data.insuranceAndProducts.policyType == activePolicyType);
      if (data.length > 0) {
        return null;
      }
      else {
        return "No Data Found"
      }
    },
    handleCompareVisibility(item) {
      let visible = true;
      if (this.compareList.length > 0) {
        let policyType = this.compareList[0]?.insuranceAndProducts?.policyType;
        if (policyType == item?.insuranceAndProducts?.policyType) {
          visible = true;
          if(this.compareList?.length == 3 && this.compareList.find(insurer => insurer.insuranceAndProducts.productCode == item.insuranceAndProducts.productCode) == undefined){
            visible = false;
          }
        } else {
          visible = false
        }
      }
      return visible;
    },
    sortArray(order) {
      this.responseData.filter(data => data.insuranceAndProducts.policyType == this.activePolicyType).sort((a, b) => {
        const getValue = (item) =>
          parseFloat(item?.productDetails?.totalPremiumDetails?.[0]?.totalPremiumWithTax || 0);

        const valA = getValue(a);
        const valB = getValue(b);

        return order === 'asc' ? valA - valB : valB - valA;
      });
    },
    sortByLowestPremium() {
      this.sortOrder = 1;
    },

    sortByHighestPremium() {
      this.sortOrder = 2;
    },
    calculateTotalPremium(item) {
      const basicODPremium = Number(
        item.productDetails.basicOwnDamagePremiumForEachPolicyTerm.premiumForEachPolicyTerm[0].premiumForEachPPO[0].premiumForEachPPF[0].basicODPremiumValue
      );

      const basicTPPremium = Number(
        item.productDetails.thirdPartyPremiumForEachPolicyTerm.premiumForEachPolicyTerm[0].premiumForEachPPO[0].premiumForEachPPF[0].basicTPPremiumValue
      );

      const motorNCBPremium = Number(
        item.productDetails.motorNCBPremium[0].premiumForEachPolicyTerm[0].premiumForEachPPO[0].premiumForEachPPF[0].premiumValue
      );

      const addonsPremium = this.calculateAddonsPremium(item);

      const totalPremium = (basicODPremium + basicTPPremium - motorNCBPremium + addonsPremium);

      const totalWithGST = totalPremium * 0.18 + totalPremium;

      return totalWithGST;
    },
    calculateAddonsPremium(item) {
      const excludedAddons = ["volDed", "autoasso", "antiThft", "payAsDrv"];

      // Find the corresponding plan from plansWithAddons
      const plan = this.plansWithAddons.find(plan => plan.productCode === item.insuranceAndProducts.productCode);

      if (!plan) return 0; // If no matching plan, return 0

      console.log("Plan:", plan);

      // Calculate the total premium of excluded addons
      const excludedPremium = plan.addons
        .filter(addonn => excludedAddons.includes(addonn.addonName.optionSelected))
        .reduce((total, addon) => {
          console.log("addon, addons", addon)
          return total + addon.premium;
        }, 0);

      console.log("Excluded Premium:", excludedPremium, "Final Addons Premium:", plan.totalAddonsPremium);
      //subtracting excludedPremium twice because 1st. it is added as addon premium and 2nd added time as it is a discount
      const finalpremium = plan.totalAddonsPremium - plan.totalAddonsTax - excludedPremium * 2;
      console.log("finalpremium", finalpremium)
      // If no excluded addons are present, return totalAddonsPremium; otherwise, subtract excludedPremium
      return excludedPremium > 0 ? finalpremium : plan.totalAddonsPremium - plan.totalAddonsTax;
    },
    setUserType(isChangeFilter = false) {
      if (this.policyHolderType == 'individual') {
        sessionStorage.setItem('user-type', JSON.stringify('individual'))
        this.handlePaCvrSelection();
        this.filterPlansWithAddons();
        this.manageLegalLiability();
      } else if (this.policyHolderType == 'corporate') {
        sessionStorage.setItem('user-type', JSON.stringify('corporate'));
        this.selectedUniqueAddons = this.selectedUniqueAddons.filter(
          i => i.optionSelected !== 'paCvr'
        );
        this.motorCovers = this.motorCovers.filter(
          i => i.optionSelected !== 'paCvr'
        );
        this.filterPlansWithAddons();
        this.manageCngCovers();
      }
      this.isChangeFilter = isChangeFilter;
    },
    manageCngCovers() {
      const isPresentTpCngCover = this.selectedUniqueAddons.some(item => item.optionSelected === "tpCngCvr");
      const isPresentCngCover = this.selectedUniqueAddons.some(item => item.optionSelected === "cngCvr");
      if (isPresentTpCngCover && !isPresentCngCover) {
        this.motorCovers = this.motorCovers.filter(item => item.optionSelected !== "tpCngCvr");
        this.selectedUniqueAddons = this.selectedUniqueAddons.filter(item => item.optionSelected !== "tpCngCvr");
      }
    },
    manageLegalLiability() {
      const isPresent = this.selectedUniqueAddons.some(item => item.optionSelected === "legLibEm");
      if (isPresent) {
        this.motorCovers = this.motorCovers.filter(item => item.optionSelected !== "legLibEm");
        this.selectedUniqueAddons = this.selectedUniqueAddons.filter(item => item.optionSelected !== "legLibEm");
      }
    },
    toggleSQErrors() {
      this.showSQErrors = !this.showSQErrors;
    },
    getPremiumIncludedFlag(item, optionSelected) {
      const cover = item.productDetails.motorCovers?.find(cover => cover.optionSelected === optionSelected);
      return cover && (cover.premiumIncludedFlag === "Yes" || cover.premiumIncludedFlag === "1");
    },
    hasValidPremium(addons) {
      return (
        addons?.premiumForEachPolicyTerm?.length > 0 &&
        addons.premiumForEachPolicyTerm[0]?.premiumForEachPPO?.length > 0 &&
        addons.premiumForEachPolicyTerm[0].premiumForEachPPO[0]?.premiumForEachPPF?.length > 0 &&
        this.showPrimium(
            addons.premiumForEachPolicyTerm[0].premiumForEachPPO[0].premiumForEachPPF[0].premiumValue,
            addons.premiumIncludedFlag
        ) > 0
      );
    },
    showPrimium(amount, premiumIncludedFlag) {
      if (premiumIncludedFlag === "Yes" || premiumIncludedFlag === "1") {
        return "Included"
      }
      else {
        return amount
      }
    },
    expansionAddons(item, productCode, policyType) {
      let code = productCode.toLowerCase().split('(')[0].replace(/[^a-z0-9]/g, '_');
      let pType = policyType.toLowerCase().split('(')[0].replace(/[^a-z0-9]/g, '_');
      let shortString = `${code}_${pType}`;
      const button = document.querySelector(`#btn-${shortString}`);

      item.addonView = !item.addonView;

      if (item.addonView) {
        button.textContent = 'Show Less';
      } else {
        button.textContent = 'Show More';
      }
    },
    expandAddons(item){
      item.addonView = !item.addonView;
    },

    // Add helper method to check if an addon is selected
    isAddonSelected(addon) {
      return this.selectedUniqueAddons.some(
        selectedAddon =>
          selectedAddon.optionName === addon.optionName &&
          selectedAddon.policyType === addon.policyType
      );
    },

    setDateModifyDate(modifyDate, modifyDateValue, setDateText) {
      this.modifyDate = modifyDate;
      this.modifyDateValue = modifyDateValue;
      this.setDateText = setDateText;
    },
    displayODSection() {
      this.vehicleAge = this.currentYearCalculated - this.registrationYear;
      if (this.motorProductType === '2W-Pvt') {
        return this.vehicleAge <= 5.10 || this.vehicleAge > 5.10;
      } else if (this.motorProductType === '4W-Pvt') {
        return this.vehicleAge <= 3.10 || this.vehicleAge > 3.10;
      }
      return false;
    },
    isPackagePolicy() {
      return this.userData?.prevPolicyType?.toLowerCase() === 'package(1+1)';
    },
    displayTPSection() {
      this.vehicleAge = this.currentYearCalculated - this.registrationYear;
      if (this.motorProductType === '2W-Pvt') {
        
        return this.vehicleAge <= 5.10 && !this.isPackagePolicy();
      } else if (this.motorProductType === '4W-Pvt') {
        return this.vehicleAge <= 3.10 && !this.isPackagePolicy();
      }
      return false;
    },
    checkODDateMoreThan90Days() {
      if (this.userData["OdDate"] && !this.userData["TpDate"] && this.isPreviousExpiryDate()) return true;

      let sessionODDate = this.userData["OdDate"];
      if (!sessionODDate) return false; // Ensure it exists

      const givenDate = new Date(sessionODDate); // Convert string to Date object
      if (isNaN(givenDate.getTime())) return false; // Validate date
      givenDate.setHours(0, 0, 0, 0);

      const currentDate = new Date();
      currentDate.setHours(0, 0, 0, 0);
      const differenceInTime = currentDate.getTime() - givenDate.getTime();
      const differenceInDays = differenceInTime / (1000 * 60 * 60 * 24);
      const greaterThan90Days = differenceInDays > 90;

      this.userData.prePolicyGreaterThan90Days = greaterThan90Days;
      if (this.userData.prePolicyGreaterThan90Days) {
        this.userData.applicablePercentage = '0%'
      }
      sessionStorage.setItem('userData', JSON.stringify(this.userData));

      return greaterThan90Days;
    },
    previousExpiryDateManage() {
      let policyExpired = this.isPreviousExpiryDate();
      let dateString = this.userData["OdDate"];
      if (!policyExpired || !dateString) return false;

      const givenDate = new Date(dateString);
      if (isNaN(givenDate.getTime())) return false;
      const currentDate = new Date();
      const differenceInTime = currentDate.getTime() - givenDate.getTime();
      const differenceInDays = differenceInTime / (1000 * 60 * 60 * 24);
      const greaterThan90Days = differenceInDays > 90;
      this.userData.prePolicyGreaterThan90Days = greaterThan90Days;
      if (this.userData.prePolicyGreaterThan90Days) {
        this.userData.applicablePercentage = '0%'
      }
      sessionStorage.setItem('userData', JSON.stringify(this.userData));
      return greaterThan90Days;
    },

    isPreviousExpiryDate() {
      this.vehicleAge = this.currentYearCalculated - this.registrationYear;
      if (this.motorProductType === "2W-Pvt") {
        return this.vehicleAge > 5.1;
      } else if (this.motorProductType === "4W-Pvt") {
        return this.vehicleAge > 3.1;
      }
      return false;
    },
    formatAddons() {
      const result = {};
      let formatedPolicyTypes = this.policyTypes.map(obj1 => obj1.name);
      for (const [policyType, addons] of Object.entries(this.filterPolicies(this.addonsMQ, formatedPolicyTypes))) {
        result[policyType] = this.categorizeAddons(addons);
      }
      // this.uniqueAddons = result;
      this.restructureJson(this.removeBiFuelKitIfCNG(result));
    },
    removeBiFuelKitIfCNG(data) {
      let fuelType = (this.userData.fuelType).toLowerCase();
      if (fuelType === "diesel" || fuelType === "cng" || fuelType === "lpg" || fuelType === "electric") {
        Object.keys(data).forEach(policyType => {
          if (data[policyType].Accessories) {
            data[policyType].Accessories.addons = data[policyType].Accessories.addons.filter(
              addon => addon.optionSelected !== "cngCvr"
            );
          }
        });
      }
      return data;
    },
    restructureJson(apiData) {
      const result = {};
      // Store current expand states before restructuring
      const currentExpandStates = {};
      if (this.uniqueAddons) {
        Object.keys(this.uniqueAddons).forEach(category => {
          if (this.uniqueAddons[category]) {
            currentExpandStates[category.toLowerCase()] = this.uniqueAddons[category].expand;
          }
        });
      }

      Object.values(apiData).forEach(policyData => {

        Object.entries(policyData).forEach(([category, data]) => {
          const normalizedCategory = category.toLowerCase();

          if (!result[normalizedCategory]) {
            // Use stored expand state if available, otherwise use data.expand or default to false
            const expandState = currentExpandStates[normalizedCategory] !== undefined
              ? currentExpandStates[normalizedCategory]
              : (data.expand || false);

            result[normalizedCategory] = {
              addon: [],
              expand: expandState,
              selectAll: this.categorySelectAllStates[normalizedCategory] || false
            };
          }

          if (data.addons && Array.isArray(data.addons)) {
            data.addons.forEach(addon => {
              const existingAddon = result[normalizedCategory].addon.find(
                existing => existing.optionSelected === addon.optionSelected
              );
              if (!existingAddon) {
                result[normalizedCategory].addon.push(addon);
              }
            });
          }
        });
      });

      // After creating the structure, check if we need to update the selectedUniqueAddons
      // based on the restored selectAll states
      Object.keys(result).forEach(categoryName => {
        if (result[categoryName].selectAll) {
          // If the category was previously "Select All", ensure all addons are selected
          result[categoryName].addon.forEach(addon => {
            const exists = this.selectedUniqueAddons.some(
              selected => selected.optionName === addon.optionName && selected.category === addon.category
            );
            if (!exists) {
              this.selectedUniqueAddons.push(addon);
            }
          });
        }
      });

      this.uniqueAddons = result;
    },
    handleFieldSelection(addon) {
      let errorContainer = this.errorContainerAndOthers.find(i => {
        return i.name == addon.optionName;
      });
      if (errorContainer) {
        if (!errorContainer.hasValue) {
          this.errorContainerAndOthers.find(i => i.name == addon.optionName).errorMessage = this.errorContainerAndOthers.find(i => i.name == addon.optionName).errorText
        } else {
          if (addon.min && Number(errorContainer.enteredValue) < Number(addon.min)) {
            this.errorContainerAndOthers.find(i => i.name == addon.optionName).errorMessage = `Enter a value greater than or equal to &#8377; ${this.formatIndianCurrency(addon.min)}`;
          } else if (addon.max && Number(errorContainer.enteredValue) > Number(addon.max)) {
            this.errorContainerAndOthers.find(i => i.name == addon.optionName).errorMessage = ` Enter a value less than or equal to &#8377; ${this.formatIndianCurrency(addon.max)}`;
          } else {
            this.errorContainerAndOthers.find(i => i.name == addon.optionName).errorMessage = "";
          }
        }

        // if(!addon.min && !addon.max){
        //   this.errorContainerAndOthers.find(i => i.name == addon.optionName).errorMessage = "";
        // }
      }
      this.isChangeFilter = true;
      // On blur, persist corrected value if this addon has no visible error and value is valid.
      const currentValue = errorContainer ? errorContainer.enteredValue : addon?.temp_price;
      if (!this.hasVisibleAddonInlineError(addon) && this.shouldPersistAddonInputToSession(addon, currentValue)) {
        sessionStorage.setItem('selectedUniqueAddons', JSON.stringify(this.selectedUniqueAddons));
        sessionStorage.setItem('motor_covers', JSON.stringify(this.motorCovers));
      }
    },
    hasVisibleAddonInlineError(targetAddon = null) {
      if (targetAddon) {
        if (targetAddon.type === 'Single-Select') {
          if (this.activePolicyType !== targetAddon.policyType) return false;
          const ec = this.errorContainerAndOthers.find(
            item => item?.name === targetAddon.optionName && item?.policyType === targetAddon.policyType
          );
          return !!(ec && ec.errorMessage);
        }
        const ec = this.errorContainerAndOthers.find(item => item?.name === targetAddon.optionName);
        return !!(ec && ec.errorMessage);
      }

      return this.selectedUniqueAddons.some(sel => {
        if (!sel || (sel.type !== 'Text' && sel.type !== 'Single-Select')) return false;
        if (sel.type === 'Single-Select') {
          if (this.activePolicyType !== sel.policyType) return false;
          const ec = this.errorContainerAndOthers.find(
            item => item?.name === sel.optionName && item?.policyType === sel.policyType
          );
          return !!(ec && ec.errorMessage);
        }
        const ec = this.errorContainerAndOthers.find(item => item?.name === sel.optionName);
        return !!(ec && ec.errorMessage);
      });
    },
    shouldPersistAddonInputToSession(addon, value) {
      if (addon.type !== 'Text' && addon.type !== 'Single-Select') return true;
      const raw = value === undefined || value === null ? '' : String(value).trim();
      const hasValue = raw !== '';
      if (hasValue && Number.isNaN(Number(raw))) return false;
      if (!hasValue) {
        if (addon.category === 'Accessories') return false;
        return true;
      }
      if (addon.min !== undefined && addon.min !== null && addon.min !== '' && Number(raw) < Number(addon.min)) return false;
      if (addon.max !== undefined && addon.max !== null && addon.max !== '' && Number(raw) > Number(addon.max)) return false;
      return true;
    },
    categorizeAddons(addons) {
      const categories = {};

      addons.forEach(addon => {
        const category = addon.category || 'Other';
        if (!categories[category]) {
          // Check if we have a stored expand state for this category
          const expandState = this.uniqueAddons && this.uniqueAddons[category] ? this.uniqueAddons[category].expand : false;
          categories[category] = { expand: expandState, addons: [], selectAll: false };
        }

        let selectedAddonFound = this.selectedUniqueAddons.find(i => i.optionName == addon.optionName);
        addon.temp_price = selectedAddonFound != undefined ? selectedAddonFound.temp_price : addon.default;
        categories[category].addons.push(addon);
      });

      return categories;
    },
    filterPolicies(data, allowedTypes) {
      const filteredData = {};
      for (const [policyType, policyData] of Object.entries(data)) {
        if (allowedTypes.includes(policyType)) {
          filteredData[policyType] = policyData;
        }
      }
      // console.log("Filtered data---------------", filteredData);
      return filteredData;
    },
    formatMqAddonsInCategory() {
      try {
        // Store current expand states
        const currentExpandStates = {};
        if (this.uniqueAddons) {
          Object.keys(this.uniqueAddons).forEach(category => {
            currentExpandStates[category] = this.uniqueAddons[category].expand;
          });
        }

        // this.motorProductType
        const parsedData = typeof this.addonsMQ === 'string' ? JSON.parse(this.addonsMQ) : this.addonsMQ;
        const packageKeys = Object.keys(parsedData);

        // Initialize empty category structure
        const categoryStructure = {};
        let packageFound = false;
        for (const packageKey of packageKeys) {
          if (parsedData[packageKey][this.activePolicyType]) {
            packageFound = true;
            parsedData[packageKey][this.activePolicyType].forEach(item => {
              const category = item.category || 'Other';
              // Dynamically create category if it doesn't exist
              if (!categoryStructure[category]) {
                // Use stored expand state if available
                const expandState = currentExpandStates[category] !== undefined ? currentExpandStates[category] : false;
                categoryStructure[category] = {
                  expand: expandState,
                  addons: [],
                  selectAll: false
                };
              }
              categoryStructure[category].addons.push(item);
            });
          }
        }
        if (!packageFound) {
          console.warn(`Package "${this.activePolicyType}" not found`);
          this.uniqueAddons = {};
          return this.uniqueAddons;
        }

        // Remove empty categories
        Object.keys(categoryStructure).forEach(key => {
          if (categoryStructure[key].addons.length === 0) {
            delete categoryStructure[key];
          } else {
            // Set the selectAll property based on whether all addons in this category are selected
            categoryStructure[key].selectAll = categoryStructure[key].addons.every(addon =>
              this.selectedUniqueAddons.some(selectedAddon =>
                selectedAddon.optionName === addon.optionName &&
                selectedAddon.category === addon.category
              )
            );
          }
        });

        this.uniqueAddons = categoryStructure;
        return this.uniqueAddons;
      } catch (error) {
        console.error('Error formatting package data:', error);
        this.uniqueAddons = {};
        return this.uniqueAddons;
      }
    },
    formatCategoryName(name) {
      // Convert camelCase or other formats to readable text
      // Example: "AdditionalAddon" becomes "Additional Addon"
      return name
        .replace(/([A-Z])/g, ' $1') // Add space before capital letters
        .replace(/^./, str => str.toUpperCase()) // Capitalize first letter
        .trim()
        .toUpperCase();
    },
    toggleCategory(categoryName) {
      if (this.uniqueAddons[categoryName]) {
        this.uniqueAddons[categoryName].expand = !this.uniqueAddons[categoryName].expand;
      }
    },
    refetchPremium() {
      let allAddonSelected = [];
      allAddonSelected = this.selectedUniqueAddons.map(item => {

        if (!item.optionValueSelected) {
          return {
            optionSelected: item.optionSelected || "",
            optionValue: [
              {
                optionValueSelected: "",
                optionValueInput: ""
              }
            ],
            varFields: [
              {
                fieldName: "",
                fieldValue: ""
              }
            ]
          };
        } else {
          return {
            optionSelected: item.optionSelected || "",
            optionValue: [
              {
                optionValueSelected: item.optionValueSelected,
                optionValueInput: item.temp_price
              }
            ],
            varFields: [
              {
                fieldName: "",
                fieldValue: ""
              }
            ]
          };
        }

      });
      this.motorCovers = allAddonSelected;
    },
    closeNCB() {
      console.log("NCB modal closed")
      this.changeNCB = false;
    },
    handleIDV() {
      this.insuredDeclaredValue = "";
      if (this.actualDeclaredIDVValue == this.minIDV || this.actualDeclaredIDVValue == this.maxIDV || this.actualDeclaredIDVValue == this.suggestedIDV) {
        this.idvSelector = this.actualDeclaredIDVValue == this.suggestedIDV ? '' : this.actualDeclaredIDVValue == this.minIDV ? 'minimum' : this.actualDeclaredIDVValue == this.maxIDV ? 'maximum' : '';
      } else {
        this.idvSelector = '';
      }
      // Use the openIDVModal method for consistency
      this.openIDVModal();
    },
    syncActivePolicyTypeWithAvailableQuotes() {
      if (!Array.isArray(this.responseData) || this.responseData.length === 0) return;

      const availablePolicyTypes = this.policyTypes
        .map(policy => policy.name)
        .filter(name =>
          this.responseData.some(data => data.insuranceAndProducts.policyType === name)
        );

      if (availablePolicyTypes.length === 0) return;

      if (!availablePolicyTypes.includes(this.activePolicyType)) {
        this.activePolicyType = availablePolicyTypes[0];
      }
    },
    setPolicyType(policyType) {
      this.activePolicyType = policyType;
      // this.formatMqAddonsInCategory()
    },
    handleNCB() {
      this.changeNCB = true;
    },
    // sortedAddons(productCode) {
    //   const plan = this.plansWithAddons.find(plan => plan.productCode === productCode);
    //   if (!plan) return []; // Return an empty array if no plan matches

    //   // Sort add-ons: first by premium > 0 (non-zero premiums first), then by premium value (high to low)
    //   return plan.addons
    //     .slice()
    //     .sort((a, b) => (b.premium > 0) - (a.premium > 0) || b.premium - a.premium)
    // },
    sortedAddons(productCode, item = null) {
      const plan = this.plansWithAddons.find(plan => plan.productCode === productCode);
      let allAddons = [];

      // Get addons from plansWithAddons if plan exists
      if (plan && plan.addons) {
        allAddons = [...plan.addons];
      }

      // If item is provided, also include all addons from the product's motorCovers
      // This ensures all available addons are displayed, not just the selected ones
      if (item && item.productDetails && item.productDetails.motorCovers) {
        item.productDetails.motorCovers.forEach(motorCover => {
          // Check if this addon is already in allAddons
          const existingAddon = allAddons.find(
            addon => addon.addonName?.optionSelected === motorCover.optionSelected
          );

          if (!existingAddon) {
            // Get premium and tax from motorCover
            const addonPremium = motorCover.premiumForEachPolicyTerm?.[0]?.premiumForEachPPO?.[0]?.premiumForEachPPF?.[0]?.premiumValue || 0;
            const addonTax = motorCover.premiumForEachPolicyTerm?.[0]?.premiumForEachPPO?.[0]?.premiumForEachPPF?.[0]?.totalTax || 0;
            const totalAddonPremiumWithTax = addonPremium + addonTax;

            // Add the addon from motorCovers
            allAddons.push({
              addonName: {
                optionSelected: motorCover.optionSelected,
                optionName: motorCover.optionName,
                optionDescription: motorCover.optionDescription,
                category: motorCover.category,
                optionValue: motorCover.optionValue,
                optionValueSelected: motorCover.optionValueSelected,
                premiumIncludedFlag: motorCover.premiumIncludedFlag
              },
              premium: addonPremium,
              tax: addonTax,
              totalAddonPremiumWithTax: totalAddonPremiumWithTax
            });
          }
        });
      }

      if (allAddons.length === 0) return []; // Return an empty array if no addons

      // First, filter out duplicates based on optionSelected
      const uniqueAddons = allAddons
        .filter((addon, index, self) =>
          index === self.findIndex(a =>
            a.addonName?.optionSelected === addon.addonName?.optionSelected
          )
        );

      // Then sort add-ons: first by premium > 0 (non-zero premiums first), then by premium value (high to low)
      // console.log("uniqueAddons here: ", uniqueAddons)
      return uniqueAddons
        .sort((a, b) => (b.premium > 0) - (a.premium > 0) || b.premium - a.premium);
    },
    clearCompareList() {
      this.compareList = [];
    },
    copyToClipboard() {
      navigator.clipboard.writeText(this.requestId)
        .then(() => {
          this.copySuccess = true;
          setTimeout(() => {
            this.copySuccess = false;
          }, 2000);
        })
        .catch(err => console.error("Failed to copy text: ", err));
    },
    closeCompareQuoteMessage() {
      this.compareErrror = "";
    },
    openCompareQuote() {
      if (this.compareList.length < 2 || this.compareList.length > 3) {
        this.compareErrror = "Please select at least 2 plans for compare."
        return;
      }
      this.showCompareFooter = false;
      this.compareErrror = "";
      this.CompareQuoteFlag = true;
      document.body.style.overflow = "hidden";
    },
    openErrorList() {
      this.errorListFlag = !this.errorListFlag;
      if (this.errorListFlag == false) {
        this.groupedErrors.map(m => m.isOpen = false);
      }
    },
    closeErrorsContainer(e) {
      // e.stopPropagation();
      this.errorListFlag = false;
    },
    closeCompareQuote() {
      this.CompareQuoteFlag = false;
      this.showCompareFooter = true;
      document.body.style.overflow = "";
    },
    showAllAddons() {
      this.showAll = true;
    },
    showAllCardAddon() {
      this.showAllCardAddons = !this.showAllCardAddons;
    },
    hideAddons() {
      this.showAll = false;
    },

    //     filterPlansWithAddons() {
    //   // Initialize `plansWithAddons` to avoid accumulation of old data
    //   this.plansWithAddons = [
    //     { title: "Filtered Plans", plans: [] },
    //     { title: "Other Plans", plans: [] }
    //   ];

    //   // Loop through each plan in responseData
    //   this.responseData.forEach(plan => {
    //     const hasAllMatchingAddons = this.selectedUniqueAddons.every(selectedAddon =>
    //       plan.productDetails.motorCovers.some(addon => addon.optionDescription === selectedAddon)
    //     );

    //     if (hasAllMatchingAddons) {
    //       this.plansWithAddons[0].plans.push(plan); // Add to "Filtered Plans"
    //     } else {
    //       this.plansWithAddons[1].plans.push(plan); // Add to "Other Plans"
    //     }
    //   });
    // }
    // ,
    filterPlansWithAddons() {
      // Initialize `plansWithAddons` to avoid accumulation of old data
      this.plansWithAddons = [];

      // Loop through each plan in responseData
      this.responseData.forEach(plan => {
        const productCode = plan.insuranceAndProducts.productCode;

        // Filter out OD plans if Corporate is Selected
        this.plansWithAddons = this.plansWithAddons.map(planAddon => {
          if (this.policyHolderType === 'corporate' && planAddon.productCode.endsWith('OD')) {
            return {
              ...planAddon,
              addons: planAddon.addons.filter(item => item.addonName.optionSelected !== 'legLibEm')
            };
          }
          return planAddon;
        });

        // Remove paCover from GODIGIT OD plan
        this.plansWithAddons = this.plansWithAddons.map(planAddon => {
          if (planAddon.productCode == 'GO4WOD' || planAddon.productCode == 'GO2WOD') {
            return {
              ...planAddon,
              addons: planAddon.addons.filter(item => item.addonName.optionSelected !== 'paCvr' || item.addonName.optionName !== "Personal Accident Cover")
            };
          }
          return planAddon;
        });

        // Check if the productCode already exists in `plansWithAddons`
        let existingPlan = this.plansWithAddons.find(item => item.productCode === productCode);

        if (!existingPlan) {
          // If the productCode is not found, initialize it
          existingPlan = {
            productCode,
            addons: [],
            totalAddonsPremium: 0,
            matchingAddonsCount: 0, // Field to track matching add-ons count
            totalPremiumWithAddons: 0, // Field to track overall premium
            totalAddonsTax: 0,
          };
          this.plansWithAddons.push(existingPlan);
        }
        this.handleBundleAddon(productCode);
        // If corporate, ensure 'Legal Liability to Employees' is in motorCovers
        if (this.policyHolderType === 'corporate') {
          const legalLiabilityAddon = plan.productDetails.motorCovers.find(
            addon => addon.optionDescription === "Legal Liability to Employees"
          );

          if (legalLiabilityAddon) {
            const addonPremium = legalLiabilityAddon.premiumForEachPolicyTerm?.[0]?.premiumForEachPPO?.[0]?.premiumForEachPPF?.[0]?.premiumValue || 0;
            const addonTax = legalLiabilityAddon.premiumForEachPolicyTerm?.[0]?.premiumForEachPPO?.[0]?.premiumForEachPPF?.[0]?.totalTax || 0;

            // Check if the addon is already in the addons array
            const existingAddon = existingPlan.addons.find(
              addon => addon.addonName.optionName === "Legal Liability to Employees"
            );

            if (!existingAddon) {
              existingPlan.addons.push({
                addonName: legalLiabilityAddon,
                premium: addonPremium,
                tax: addonTax
              });

              existingPlan.totalAddonsPremium += addonPremium;
              if (addonPremium > 0) existingPlan.matchingAddonsCount += 1; // Increment matching add-ons count
            }
            // Check if the addon is already in selectedUniqueAddons
            const alreadyAdded = this.selectedUniqueAddons.some(
              addon => addon.optionDescription === "Legal Liability to Employees"
            );

            if (!alreadyAdded) {
              this.selectedUniqueAddons.push(legalLiabilityAddon);
              this.refetchPremium();
            }
          }
        }

        // Check for CNG Cover
        const cngCoverAddon = plan.productDetails.motorCovers.find(
          (addon) => addon.optionDescription === "Bi-Fuel Kit Cover",
        )
        const tpCngCoverAddon = plan.productDetails.motorCovers.find(
          (addon) => addon.optionDescription === "TP Bi-Fuel Kit Cover",
        )
        // Check if the addons are already in selectedUniqueAddons
        const cngCoverAlreadyAdded = this.selectedUniqueAddons.some(
          (addon) => addon.optionSelected === "cngCvr",
        )

        if (cngCoverAlreadyAdded && cngCoverAddon && tpCngCoverAddon) {
          const cngCoverPremium =
            cngCoverAddon.premiumForEachPolicyTerm?.[0]?.premiumForEachPPO?.[0]?.premiumForEachPPF?.[0]
              ?.premiumValue || 0
          const cngCoverTax =
            cngCoverAddon.premiumForEachPolicyTerm?.[0]?.premiumForEachPPO?.[0]?.premiumForEachPPF?.[0]?.totalTax || 0
          const tpCngCoverPremium =
            tpCngCoverAddon.premiumForEachPolicyTerm?.[0]?.premiumForEachPPO?.[0]?.premiumForEachPPF?.[0]
              ?.premiumValue || 0
          const tpCngCoverTax =
            tpCngCoverAddon.premiumForEachPolicyTerm?.[0]?.premiumForEachPPO?.[0]?.premiumForEachPPF?.[0]?.totalTax || 0

          // Check if the addons are already in the addons array
          const existingCngCover = existingPlan.addons.find((addon) => addon.addonName.optionName === "Bi-Fuel Kit Cover")
          const existingTpCngCover = existingPlan.addons.find(
            (addon) => addon.addonName.optionName === "TP Bi-Fuel Kit Cover",
          )
          console.log("existingCngCover", existingCngCover)
          // if (!existingCngCover) {
          //   existingPlan.addons.push({
          //     addonName: cngCoverAddon,
          //     premium: cngCoverPremium,
          //     tax: cngCoverTax,
          //   })
          //   existingPlan.totalAddonsPremium += cngCoverPremium
          //   if (cngCoverPremium > 0) existingPlan.matchingAddonsCount += 1
          // }
          console.log("existingCngCover1", existingCngCover)

          if (!existingTpCngCover) {
            existingPlan.addons.push({
              addonName: tpCngCoverAddon,
              premium: tpCngCoverPremium,
              tax: tpCngCoverTax,
            })
            existingPlan.totalAddonsPremium += tpCngCoverPremium
            if (tpCngCoverPremium > 0) existingPlan.matchingAddonsCount += 1
          }

          const tpCngCoverAlreadyAdded = this.selectedUniqueAddons.some(
            (addon) => addon.optionSelected === "tpCngCvr",
          )

          if (!cngCoverAlreadyAdded) {
            this.selectedUniqueAddons.push(cngCoverAddon)
          }
          if (!tpCngCoverAlreadyAdded) {
            this.selectedUniqueAddons.push(tpCngCoverAddon)
          }
          console.log("existingCngCover2", existingCngCover)

          if (!cngCoverAlreadyAdded || !tpCngCoverAlreadyAdded) {
            this.refetchPremium()
          }
        }

        // const presentCngCover = this.selectedUniqueAddons.find(
        //   addon => addon.optionSelected === "cngCvr"
        // );

        // const presentTpcngCover = plan.productDetails.motorCovers.find(
        //   addon => addon.optionSelected === "tpCngCvr"
        // );      

        // if (presentCngCover && presentTpcngCover) {
        //   // Get premium details for `cngCvr`
        //   const cngCoverPremium = presentCngCover.premiumForEachPolicyTerm?.[0]?.premiumForEachPPO?.[0]?.premiumForEachPPF?.[0]?.totalPremiumValue || 0;
        //   const cngCoverTax = presentCngCover.premiumForEachPolicyTerm?.[0]?.premiumForEachPPO?.[0]?.premiumForEachPPF?.[0]?.totalTax || 0;

        //   // Get premium details for `tpCngCvr`
        //   const tpcngCoverPremium = presentTpcngCover.premiumForEachPolicyTerm?.[0]?.premiumForEachPPO?.[0]?.premiumForEachPPF?.[0]?.totalPremiumValue || 0;
        //   const tpcngCoverTax = presentTpcngCover.premiumForEachPolicyTerm?.[0]?.premiumForEachPPO?.[0]?.premiumForEachPPF?.[0]?.totalTax || 0;

        //   // Ensure `cngCvr` is not already added
        //   const existingCngCover = existingPlan.addons.find(
        //     addon => addon.addonName.optionName === "cngCvr"
        //   );
        //   console.log("existingCngCover---------------->", existingCngCover);

        //   if (!existingCngCover) {
        //     existingPlan.addons.push({
        //       addonName: { optionName: presentCngCover.optionDesc },
        //       premium: cngCoverPremium,
        //       tax: cngCoverTax
        //     });

        //     existingPlan.totalAddonsPremium += cngCoverPremium;
        //     if (cngCoverPremium > 0) existingPlan.matchingAddonsCount += 1;
        //     this.plansWithAddons.push(existingCngCover);
        //     // this.selectedUniqueAddons.push(existingCngCover)
        //   }

        //   // Ensure `tpCngCvr` is not already added
        //   const existingTpcngCover = existingPlan.addons.find(
        //     addon => addon.addonName.optionName === "tpCngCvr"
        //   );
        //   console.log("existingTpcngCover---------------->", existingTpcngCover);


        //   if (!existingTpcngCover) {
        //     existingPlan.addons.push({
        //       addonName: { optionName: presentTpcngCover.optionDescription },
        //       premium: tpcngCoverPremium,
        //       tax: tpcngCoverTax
        //     });

        //     existingPlan.totalAddonsPremium += tpcngCoverPremium;
        //     if (tpcngCoverPremium > 0) existingPlan.matchingAddonsCount += 1;
        //     this.plansWithAddons.push(existingTpcngCover);
        //     // this.selectedUniqueAddons.push(existingTpcngCover)
        //   }
        // }

        // Process only addons present in the product's motorCovers
        this.selectedUniqueAddons.forEach(selectedAddon => {
          // Find the addon in the current plan's motorCovers
          const matchingAddon = plan.productDetails.motorCovers.find(
            addon => addon.optionDescription === selectedAddon.optionName || selectedAddon.optionDescription
          );

          if (matchingAddon) {
            // Determine the premium for the addon
            const addonPremium = matchingAddon.premiumForEachPolicyTerm?.[0]?.premiumForEachPPO?.[0]?.premiumForEachPPF?.[0]?.premiumValue || 0;
            const addonTax = matchingAddon.premiumForEachPolicyTerm?.[0]?.premiumForEachPPO?.[0]?.premiumForEachPPF?.[0]?.totalTax || 0;
            const totalAddonPremiumWithTax = addonPremium + addonTax


            // Check if the addon is already in the addons array
            const existingAddon = existingPlan.addons.find(
              addon => addon.addonName.optionName === selectedAddon.optionName
            );

            if (!existingAddon) {
              selectedAddon.premiumIncludedFlag = matchingAddon.premiumIncludedFlag;
              // Push the addon details to the addons array
              existingPlan.addons.push({
                addonName: selectedAddon,
                premium: addonPremium,
                tax: addonTax,
                totalAddonPremiumWithTax: totalAddonPremiumWithTax
              });

              // Accumulate the total premium for the product
              existingPlan.totalAddonsPremium += totalAddonPremiumWithTax;
              existingPlan.totalAddonsTax += addonTax;
              if (totalAddonPremiumWithTax > 0)
                existingPlan.matchingAddonsCount += 1; // Increment matching add-ons count
            }
          }
        });

        // Calculate the overall premium for the plan, including base premiums
        existingPlan.totalPremiumWithAddons =
          Number(
            plan.productDetails.basicOwnDamagePremiumForEachPolicyTerm.premiumForEachPolicyTerm[0].premiumForEachPPO[0].premiumForEachPPF[0].totalBasicODPremiumValue
          ) +
          Number(
            plan.productDetails.thirdPartyPremiumForEachPolicyTerm.premiumForEachPolicyTerm[0].premiumForEachPPO[0].premiumForEachPPF[0].totalBasicTPPremiumValue
          ) -
          Number(
            plan.productDetails.motorNCBPremium[0].premiumForEachPolicyTerm[0].premiumForEachPPO[0].premiumForEachPPF[0].totalPremiumValue
          ) +
          existingPlan.totalAddonsPremium; // Include add-ons premium
      });

      // Sort the plans by matching add-ons count first, then by premium in descending order
      this.plansWithAddons.sort((a, b) => {
        if (b.matchingAddonsCount !== a.matchingAddonsCount) {
          return b.matchingAddonsCount - a.matchingAddonsCount; // More matching add-ons come first
        }
        return a.totalAddonsPremium - b.totalAddonsPremium; // Higher premium comes first among equals
      });
      // Update responseData order based on the sorted plansWithAddons
      this.responseData = this.plansWithAddons.map(planWithAddon =>
        this.responseData.find(
          plan => plan.insuranceAndProducts.productCode === planWithAddon.productCode
        )
      );  // Update session storage and log the results
      sessionStorage.setItem("plansWithAddons", JSON.stringify(this.plansWithAddons));
      this.selectedUniqueAddons = this.selectedUniqueAddons.filter(
        item => typeof item !== "string" && item !== null && typeof item === "object"
      );
      this.refetchPremium();
    },
    handleBundleAddon(productCode) {
      if (productCode.startsWith("GO")) {
        this.responseData.forEach(plan => {
          if (plan.insuranceAndProducts.productCode === productCode) {
            this.plansWithAddons.forEach(element => {
              const motorCovers = plan.productDetails.motorCovers || [];
              motorCovers.forEach(cover => {
                if (cover.optionSelected === 'legLibEm' && this.policyHolderType == 'individual') return;
                const addon = {
                  addonName: {
                    max: "",
                    min: "",
                    type: "none",
                    values: [],
                    default: "1",
                    category: "Addons",
                    multipleOf: "",
                    optionDesc: cover.optionDescription || "",
                    optionName: cover.optionDescription || "",
                    policyType: "",
                    temp_price: cover?.optionValue[0]?.optionValueInput || "",
                    inbuiltFeature: cover.inbuiltInPlan === "Yes" ? 1 : 0,
                    optionSelected: cover.optionSelected || "",
                    premiumDetails: cover.premiumForEachPolicyTerm || [],
                    addOnSumAssured: null,
                    optionValueSelected: cover?.optionValue[0]?.optionValueSelected || "",
                    premiumIncludedFlag: cover.premiumIncludedFlag || 0,
                    optionValueDescription: cover.optionValue.optionValueDescription || ""
                  },
                  premium: this.getTotalPremium(cover),
                  tax: this.getTotalTax(cover),
                  totalAddonPremiumWithTax: this.getTotalPremiumWithTax(cover)
                };
                if (this.motorProductType == '4W-Pvt') {
                  if (element.productCode.startsWith("GO")) {
                    if (element.productCode == 'GO4WCI' || element.productCode == 'GO4WOD') {
                      element.addons.push(addon);
                    }
                  }
                }
                if (this.motorProductType == '2W-Pvt') {
                  if (element.productCode.startsWith("GO")) {
                    if (element.productCode == 'GO2WCI' || element.productCode == 'GO2WOD')
                      element.addons.push(addon);
                  }
                }
              });
            });
          }
        });
      }

      let hasTppdInReliance = this.responseData.some(plan => {
        const motorCovers = plan.productDetails.motorCovers || [];
        return motorCovers.some(cover => cover.optionSelected === 'tppd');
      });

      if (productCode.startsWith("RGI") && hasTppdInReliance) {
        this.responseData.forEach(plan => {
          if (plan.insuranceAndProducts.productCode === productCode) {
            const motorCovers = plan.productDetails.motorCovers || [];
            const tppdCover = motorCovers.find(cover => cover.optionSelected === 'tppd');

            if (!tppdCover) return;
            const addon = {
              addonName: {
                max: "",
                min: "",
                type: "none",
                values: [],
                default: "1",
                category: "Addons",
                multipleOf: "",
                optionDesc: tppdCover.optionDescription || "",
                optionName: tppdCover.optionDescription || "",
                policyType: "",
                temp_price: tppdCover?.optionValue[0]?.optionValueInput || "",
                inbuiltFeature: tppdCover.inbuiltInPlan === "Yes" ? 1 : 0,
                optionSelected: tppdCover.optionSelected || "",
                premiumDetails: tppdCover.premiumForEachPolicyTerm || [],
                addOnSumAssured: null,
                optionValueSelected: tppdCover?.optionValue[0]?.optionValueSelected || "",
                premiumIncludedFlag: tppdCover.premiumIncludedFlag || 0,
                optionValueDescription: tppdCover.optionValue.optionValueDescription || ""
              },
              premium: this.getTotalPremium(tppdCover),
              tax: this.getTotalTax(tppdCover),
              totalAddonPremiumWithTax: this.getTotalPremiumWithTax(tppdCover)
            };

            this.plansWithAddons.forEach(element => {
              // Push the tppd addon for relevant reliance plan
              if (
                (this.motorProductType === '4W-Pvt' && (element.productCode === 'RGI4WCI' || element.productCode === 'RGI4WTP' || element.productCode ==='RGI4WBD' || element.productCode ==='RGI4WTP3')) ||
                (this.motorProductType === '2W-Pvt' && (element.productCode === 'RGI2WCI' || element.productCode === 'RGI2WTP' || element.productCode ==='RGI2WBD' || element.productCode ==='RGI2WTP3' || element.productCode=='RGI2WTP5'))
              ) {
                element.addons.push(addon);
              }else if(element.productCode ==='RGI4WOD'){
                  element.addons.filter(cover => cover.addon.optionSelected != 'tppd')
              }
            });
          }
        });
      }
    },
    getTotalPremium(cover) {
      try {
        return cover.premiumForEachPolicyTerm[0]
          .premiumForEachPPO[0]
          .premiumForEachPPF[0]
          .premiumValue || 0;
      } catch (e) {
        return 0;
      }
    },
    getTotalTax(cover) {
      try {
        return cover.premiumForEachPolicyTerm[0]
          .premiumForEachPPO[0]
          .premiumForEachPPF[0]
          .totalTax || 0;
      } catch (e) {
        return 0;
      }
    },

    getTotalPremiumWithTax(cover) {
      try {
        return cover.premiumForEachPolicyTerm[0]
          .premiumForEachPPO[0]
          .premiumForEachPPF[0]
          .totalPremiumValue || 0;
      } catch (e) {
        return 0;
      }
    },
    selectAllAddons(data, name, isChecked) {
      this.isChangeFilter = true;
      // Save the state in our categorySelectAllStates object
      this.categorySelectAllStates[name.toLowerCase()] = isChecked;

      data.addon.forEach(element => {
        if (isChecked) {
          const exists = this.selectedUniqueAddons.some(
            i => i.optionName === element.optionName && i.category === element.category
          );
          if (!exists) {
            // Set temporary price based on whether it's an accessory or not
            element.temp_price = element.category !== 'Accessories' ? element.default : "";

            this.selectedUniqueAddons.push(element);

            // Handle the error container object for each addon
            if (element.type === 'Text' || element.type === 'Single-Select') {
              let obj = {
                name: element.optionName,
                checked: true,
                policyType: element.policyType,
                enteredValue: element.default || element.temp_price,
                hasValue: (element.default || element.temp_price) !== '' ? true : false,
                errorMessage: element.category !== 'Accessories' ? "" : `ENTER ${element.optionName?.toUpperCase()} VALUE`,
                errorText: `ENTER ${element.optionName?.toUpperCase()} VALUE`
              };

              // Check if this addon is already in the error container
              const existingIndex = this.errorContainerAndOthers.findIndex(
                item => item.name === element.optionName && item.policyType === element.policyType
              );

              if (existingIndex === -1) {
                this.errorContainerAndOthers.push(obj);
              }
            }
          }
        } else {
          this.selectedUniqueAddons = this.selectedUniqueAddons.filter(
            i => i.optionName !== element.optionName || i.category !== element.category
          );
          this.motorCovers = this.motorCovers.filter(
            i => i.optionSelected !== element.optionSelected
          );

          // Remove from error container when deselected
          const index = this.errorContainerAndOthers.findIndex(
            addon => addon.name === element.optionName && addon.policyType === element.policyType
          );

          if (index !== -1) {
            this.errorContainerAndOthers.splice(index, 1);
          }
        }

        this.handleAddonSelection(data, element, isChecked, "");
      });

      this.filterPlansWithAddons();
      this.refetchPremium();
    },
    limitYear(event) {
      const value = event.target.value;
      if (value) {
        const [year, month, day] = value.split('-');

        if (year.length > 4) {
          const trimmedYear = year.slice(0, 4); // Only 4 digits
          const correctedDate = `${trimmedYear}-${month}-${day}`;
          this.modifyDateValue = correctedDate;
        } else {
          this.modifyDateValue = value; // Keep as is
        }
      }
    },
    ownershipTransferChange(){
      this.isChangeFilter = true;
      let userData = JSON.parse(sessionStorage.getItem("userData"));
      if(this.ownershipTransferFlag == 'true'){
        this.userData.applicablePercentage = '0%'
        userData.applicablePercentage = '0%'
      }
      sessionStorage.setItem("ownershipTransferCheck", JSON.stringify(this.ownershipTransferFlag));
    },
    zeroDepCurrentChange(){
      let prevPolicyHasZeroDep;
      this.isChangeFilter = true;
      prevPolicyHasZeroDep = this.currentZeroDep;
      sessionStorage.setItem("prevPolicyHasZeroDep", JSON.stringify(prevPolicyHasZeroDep));

      this.motorCovers = this.motorCovers.map(cover => {
        if (cover.optionSelected === 'zeroDep') {
          return {
            ...cover,
            optionValue: cover.optionValue.map(val => ({
              ...val,
              optionValueSelected: val.optionValueSelected,
              optionValueInput: String(this.currentZeroDep)
            }))
          };
        }
        return cover;
      });
      this.plansWithAddons.forEach(plan => {
        plan.addons.forEach(addon => {
          if (addon.addonName.optionSelected === 'zeroDep') {
            addon.addonName.temp_price = String(this.currentZeroDep);
          }
        });
      });
      sessionStorage.setItem("plansWithAddons", JSON.stringify(this.plansWithAddons));
      sessionStorage.setItem("motorCovers", JSON.stringify(this.motorCovers));
    },
    // Method to handle checkbox change
    handleAddonSelection(data, selectedAddon, isChecked, categoryName) {
      console.log("Selected Addons ->>>", selectedAddon);
      this.isChangeFilter = true;
      let obj = {
        name: "",
        checked: "",
        policyType: "",
        enteredValue: "",
        hasValue: "",
        errorMessage: "",
        errorText: ""
      }
      console.log(isChecked, ">>>>>>>>>>>>>>>>", selectedAddon)
      // Handling for Personal Accident Cover
      if (selectedAddon.optionSelected == 'paCvr' && !isChecked) {
        this.handleAccidentalCoverDropDown = true;
      }

      if (selectedAddon.optionSelected == 'paCvr' && isChecked) {
        sessionStorage.setItem('paCoverSelection', JSON.stringify({
          isChecked: true,
        }))
      }

      if(selectedAddon.optionSelected == "zeroDep" && this.quoteCategory == 'New'){
        let prevPolicyHasZeroDep;
        this.currentZeroDep = !this.currentZeroDep;
        prevPolicyHasZeroDep = this.currentZeroDep;
        sessionStorage.setItem("prevPolicyHasZeroDep", JSON.stringify(prevPolicyHasZeroDep));

        this.motorCovers = this.motorCovers.map(cover => {
          if (cover.optionSelected === 'zeroDep') {
            return {
              ...cover,
              optionValue: cover.optionValue.map(val => ({
                ...val,
                optionValueSelected: val.optionValueSelected,
                optionValueInput: String(this.currentZeroDep)
              }))
            };
          }
          return cover;
        });
        this.plansWithAddons.forEach(plan => {
          plan.addons.forEach(addon => {
            if (addon.addonName.optionSelected === 'zeroDep') {
              addon.addonName.temp_price = String(this.currentZeroDep);
            }
          });
        });
        
        sessionStorage.setItem("plansWithAddons", JSON.stringify(this.plansWithAddons));
        sessionStorage.setItem("motorCovers", JSON.stringify(this.motorCovers));
      }
      
      if (isChecked) {
        selectedAddon.temp_price = selectedAddon.category != 'Accessories' ? selectedAddon.default : "";
        // Check if the add-on is already in the list
        const alreadyExists = this.selectedUniqueAddons.some(
          addon => addon.optionName === selectedAddon.optionName && addon.policyType === selectedAddon.policyType
        );
        console.log("Existing-------------  ", alreadyExists, isChecked, selectedAddon.optionName);


        if (!alreadyExists) {
          // Add the add-on to the selected list only if it's not already present
          this.selectedUniqueAddons.push(selectedAddon);
          obj.name = selectedAddon.optionName;
          obj.checked = true;
          obj.policyType = selectedAddon.policyType;
          obj.enteredValue = selectedAddon.default || selectedAddon.temp_price;
          obj.hasValue = obj.enteredValue != '' ? true : false;
          obj.errorMessage = selectedAddon.category != 'Accessories' ? "" : `ENTER ${selectedAddon.optionName?.toUpperCase()} VALUE`,
            obj.errorText = `ENTER ${selectedAddon.optionName?.toUpperCase()} VALUE`
          this.errorContainerAndOthers.push(obj)
        }
        if (categoryName) {
          this.uniqueAddons[categoryName].selectAll = this.uniqueAddons[categoryName].addon.every(uniqueAddon =>
            this.selectedUniqueAddons.some(selected =>
              selected.optionName === uniqueAddon.optionName &&
              selected.category === uniqueAddon.category
            )
          );

        }
      } else {
        // Remove the addon from the selected list
        this.selectedUniqueAddons = this.selectedUniqueAddons.filter(
          addon => !(addon.optionName === selectedAddon.optionName && addon.policyType === selectedAddon.policyType)
        );

        data.selectAll = false;
        const index = this.errorContainerAndOthers.findIndex(
          addon => addon.name == selectedAddon.optionName && addon.policyType == selectedAddon.policyType
        );
        if (index !== -1) {
          this.errorContainerAndOthers.splice(index, 1);
        }
      }

      // Clean up the selectedUniqueAddons array
      this.selectedUniqueAddons = this.selectedUniqueAddons.filter(item => typeof item !== 'string' && item !== null && typeof item === 'object');

      // Special handling for CNG cover
      if (selectedAddon.optionSelected == 'cngCvr') {
        const isPresent = this.selectedUniqueAddons.some(item => item.optionSelected === "cngCvr");
        if (!isPresent) {
          this.motorCovers = this.motorCovers.filter(item => item.optionSelected !== "tpCngCvr");
          this.selectedUniqueAddons = this.selectedUniqueAddons.filter(item => item.optionSelected !== "tpCngCvr");
        } else {
          if (!this.motorCovers.find(cover => cover.optionSelected === 'cngCvr')) {
            this.motorCovers.push({
              "optionSelected": "tpCngCvr",
              "optionValue": [
                {
                  "optionValueSelected": "addOnSumAssured",
                  "optionValueInput": "10000"
                }
              ],
              "varFields": [
                {
                  "fieldName": "",
                  "fieldValue": ""
                }
              ]
            });
            this.selectedUniqueAddons.push({
              max: "50000",
              min: "10000",
              type: "Text",
              values: [],
              default: "10000",
              category: "Accessories",
              multipleOf: "",
              optionDesc: "TP Bi-Fuel Kit Cover",
              optionName: "TP Bi-Fuel Kit Cover",
              policyType: "Package(1+1)",
              temp_price: "10000",
              inbuiltFeature: 0,
              optionSelected: "tpCngCvr",
              premiumDetails: [],
              addOnSumAssured: null,
              optionValueSelected: "addOnSumAssured",
              premiumIncludedFlag: this.selectedPlanData?.productDetails?.motorCovers.find(cover => cover.optionSelected == 'tpCngCvr')?.premiumIncludedFlag,
              optionValueDescription: "Insured Amount"
            })
          }
        }
      }

      // Update plans and recalculate
      if (!this.hasVisibleAddonInlineError()) {
        sessionStorage.setItem('selectedUniqueAddons', JSON.stringify(this.selectedUniqueAddons));
        sessionStorage.setItem('motor_covers', JSON.stringify(this.motorCovers));
      }
      if (!(selectedAddon.optionSelected === 'paCvr' && !isChecked)) {
        this.filterPlansWithAddons();
      }

      // Update motor_covers with the current selected addons
      this.refetchPremium();

      // Save to sessionStorage

      console.log("this.selectedUniqueAddons", this.selectedUniqueAddons);

      // Recalculate filtered plans and premiums
    },
    // setAddonInputValue(addon, value) {
    //   const found = this.motorCovers.find(
    //     i => i.optionSelected === addon.optionSelected
    //   );
    //   if (found) {
    //     this.motorCovers.find(i => i.optionSelected === addon.optionSelected).optionValue[0].optionValueInput = value;
    //     console.log("Value Found: ", value, this.motorCovers);
    //   }
    // },
    restrictSpecialChars(e) {
      // Block anything except 0-9
      if (!/[0-9]/.test(e.key)) {
        e.preventDefault();
      }
    },
    setAddonInputValue(addon, value) {
      const index = this.motorCovers.findIndex(
        i => i.optionSelected == addon.optionSelected
      );
      const uniqueAddonIndex = this.selectedUniqueAddons.findIndex(
        i => i.optionName == addon.optionName
      );

      let changeAddonTempValue = this.uniqueAddons[addon.category.toLowerCase()];
      if (changeAddonTempValue.addon.length > 0) {
        let tempValue = changeAddonTempValue.addon.find(i => i.optionName == addon.optionName);
        if (tempValue) {
          changeAddonTempValue.expand = false;
          setTimeout(() => {
            changeAddonTempValue.expand = true;
          }, 10);
          changeAddonTempValue.addon.find(i => i.optionName == addon.optionName).temp_price = value
        }
      }

      if (index !== -1) {
        // Create a new object to trigger reactivity
        const updatedCover = { ...this.motorCovers[index] };
        updatedCover.optionValue = [
          {
            ...updatedCover.optionValue[0],
            optionValueInput: value
          }
        ];
        // Use Vue.set to ensure reactivity
        console.log("Covers......... ", updatedCover);
        this.motorCovers[index] = updatedCover;
        // self.$set(this.motorCovers, index, updatedCover);
        console.log("Updated covers, ", this.motorCovers, index, updatedCover);
      }

      if (uniqueAddonIndex !== -1) {
        this.selectedUniqueAddons[uniqueAddonIndex].temp_price = value;
      }

      let errorContainer = this.errorContainerAndOthers.find(i => i.name == addon.optionName);
      if (errorContainer) {
        errorContainer.enteredValue = value;
        errorContainer.hasValue = !value ? false : true;
      }

      // Save only when no inline error is showing and current value is valid.
      if (!this.hasVisibleAddonInlineError(addon) && this.shouldPersistAddonInputToSession(addon, value)) {
        sessionStorage.setItem('selectedUniqueAddons', JSON.stringify(this.selectedUniqueAddons));
        sessionStorage.setItem('motor_covers', JSON.stringify(this.motorCovers));
      }

      this.isChangeFilter = true;
    },
    canclePaCvrSelection() {
      this.handlePaCvrSelection();
      if(this.isChangeFilter){
        this.isChangeFilter = true;
      }else{
        this.isChangeFilter = false;
      }

      this.handleAccidentalCoverDropDown = false;
      this.selectedUniqueAddons.push({
        max: 1500000,
        min: 100000,
        type: "none",
        values: [],
        default: "1500000",
        category: "Accidental Covers",
        multipleOf: "100000",
        optionDesc: "An accident cover which provides financial assistance to the car's owner in case of disablement or death due to an accident. Every individual vehicle owner must opt for this cover as per IRDAI guidelines, except for those without a driving license or having an existing Personal Accident cover of at least Rs. 15 lakh",
        optionName: "Personal Accident Cover",
        policyType: this.quoteCategory == 'New' ? "Bundled(1+3)" : "Package(1+1)",
        temp_price: "1",
        inbuiltFeature: 0,
        optionSelected: "paCvr",
        premiumDetails: [],
        addOnSumAssured: null,
        optionValueSelected: "paOption",
        premiumIncludedFlag: this.quoteCategory == 'New' ? "0" : "No",
        optionValueDescription: ""
      })
      this.motorCovers = this.motorCovers.filter(coverr => coverr.optionSelected != 'paCvr')
      this.motorCovers.push({
        "optionSelected": "paCvr",
        "optionValue": [
          {
            "optionValueSelected": "paOption",
            "optionValueInput": "1"
          }
        ],
        "varFields": [
          {
            "fieldName": "",
            "fieldValue": ""
          }
        ]
      })
      sessionStorage.setItem("motor_covers", JSON.stringify(this.motorCovers));
    },    
    handlePaCvrReason(){
      sessionStorage.setItem("reasonForPaCvr", JSON.stringify({
        code: this.paOwnerDriverSelectionModel,
        name: this.paOwnerDriverSelection.find(obj => obj.code == this.paOwnerDriverSelectionModel).name
      }))
    },
    submitPaCvrSelection() {
      sessionStorage.setItem('paCoverSelection', JSON.stringify({
        isChecked: false,
      }))
      this.motorCovers = this.motorCovers.filter(coverr => coverr.optionSelected != 'paCvr')
      this.motorCovers.push({
        "optionSelected": "paCvr",
        "optionValue": [
          {
            "optionValueSelected": "paOption",
            "optionValueInput": this.paOwnerDriverSelectionModel
          }
        ],
        "varFields": [
          {
            "fieldName": "",
            "fieldValue": ""
          }
        ]
      })
      // Update motor_covers with the current selected addons
      this.getMultiQuote();
      // this.selectedUniqueAddons.push({
      //   max: 1500000,
      //   min: 100000,
      //   type: "none",
      //   values: [],
      //   default: "1500000",
      //   category: "Accidental Covers",
      //   multipleOf: "100000",
      //   optionDesc: "An accident cover which provides financial assistance to the car's owner in case of disablement or death due to an accident. Every individual vehicle owner must opt for this cover as per IRDAI guidelines, except for those without a driving license or having an existing Personal Accident cover of at least Rs. 15 lakh",
      //   optionName: "Personal Accident Cover",
      //   policyType: "Package(1+1)",
      //   temp_price: "1500000",
      //   inbuiltFeature: 0,
      //   optionSelected: "paCvr",
      //   premiumDetails: [],
      //   addOnSumAssured: null,
      //   optionValueSelected: "paOption",
      //   premiumIncludedFlag: "No",
      //   optionValueDescription: ""
      // })
      sessionStorage.setItem("motor_covers", JSON.stringify(this.motorCovers));
      this.handleAccidentalCoverDropDown = false;
    },
    handlePaCvrSelection() {
      this.paOwnerDriverSelectionModel = "";
      this.motorCovers.push({
        "optionSelected": "paCvr",
        "optionValue": [
          {
            "optionValueSelected": "paOption",
            "optionValueInput": "1"
          }
        ],
        "varFields": [
          {
            "fieldName": "",
            "fieldValue": ""
          }
        ]
      })
      this.selectedUniqueAddons.push({
        max: 1500000,
        min: 100000,
        type: "none",
        values: [],
        default: "1500000",
        category: "Accidental Covers",
        multipleOf: "100000",
        optionDesc: "An accident cover which provides financial assistance to the car's owner in case of disablement or death due to an accident. Every individual vehicle owner must opt for this cover as per IRDAI guidelines, except for those without a driving license or having an existing Personal Accident cover of at least Rs. 15 lakh",
        optionName: "Personal Accident Cover",
        // policyType: this.quoteCategory == 'New' ? "Bundled(1+3)" : "Package(1+1)",
        policyType: (this.motorProductType == '2W-Pvt' && this.quoteCategory == 'New') ? "Bundled(1+5)" : (this.motorProductType == '4W-Pvt' && this.quoteCategory == 'New') ? "Bundled(1+3)" : "Package(1+1)",
        temp_price: "1",
        inbuiltFeature: 0,
        optionSelected: "paCvr",
        premiumDetails: [],
        addOnSumAssured: null,
        optionValueSelected: "paOption",
        premiumIncludedFlag: this.quoteCategory == 'New' ? "0" : "No",
        optionValueDescription: ""
      })
      // let motorCovers = JSON.parse(sessionStorage.getItem("motor_covers"));

    },
    handleTppdCover(){
      const foundTppdCover = this.selectedUniqueAddons.find(cover => cover.optionSelected == 'tppd');
      if(foundTppdCover){
        foundTppdCover.optionValueSelected = "addOnSumAssured";
        foundTppdCover.temp_price = this.motorProductType == '4W-Pvt' ? "750000" : "100000";

        this.motorCovers = this.motorCovers.map(cover => {
          if(cover.optionSelected == 'tppd'){
            cover.optionValue[0].optionValueInput = this.motorProductType == '4W-Pvt' ? "750000" : "100000";
            cover.optionValue[0].optionValueSelected = "addOnSumAssured";
          }
          return cover;
        }) 
      }
      sessionStorage.setItem("motorCovers", JSON.stringify(this.motorCovers));
      sessionStorage.setItem("motor_covers", JSON.stringify(this.motorCovers));
    },
    getAddonInputValue(addon) {
      const found = this.motorCovers.find(
        i => i?.optionSelected === addon.optionName
      );
      return found?.optionValue[0]?.optionValueInput || '';
    },

    openEditmodal() {
      this.showeditmodal = true
    },
    closeEditmodal() {
      this.showeditmodal = false
    },
    // Reload IDV slider Container
    reloadIDVcontainer() {
      this.idvVisibilityFlag = true;
      setTimeout(() => {
        this.idvVisibilityFlag = false;
      }, 500);
    },
    // Date fromatting to DD-MM-YYYY Fromat
    formatDate(date) {
      const dateObj = new Date(date);
      const day = String(dateObj.getDate()).padStart(2, '0');
      const month = String(dateObj.getMonth() + 1).padStart(2, '0');
      const year = dateObj.getFullYear();
      const formattedDate = `${day}-${month}-${year}`;
      return formattedDate;
    },
    formatDateToMonthString(dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-GB', { day: '2-digit', month: 'short', year: 'numeric' })
        .replace(/ /g, '-').toUpperCase();
    },
    //Clear Policy Filter
    clearPolicyFilter() {
      this.responseData = this.responseData1;
      this.policyTypesSelected = this.policyTypes.map(obj1 => obj1.name);
    },

    //Apply Policy Type Filter
    applyPolicyType() {
      this.clearCompareList()
      this.responseData = this.responseData1.filter(item => this.policyTypesSelected.includes(item.insuranceAndProducts.policyType));
    },
    //Cleare IDV

    //Cleare IDV
    cleareIDV() {
      // Ensure product.idvDetails exists
      if (!this.requestBody.product) {
        this.requestBody.product = {};
      }
      if (!this.requestBody.product.idvDetails) {
        this.requestBody.product.idvDetails = { insuredDeclaredValue: 0 };
      }

      // Reset all IDV-related values when clearing
      const currentIDV = this.requestBody.product.idvDetails.insuredDeclaredValue || 0;
      this.selectedIDV = currentIDV;
      this.needIDV = currentIDV === 0 ? false : true;

      // Reset idvSelector based on current value
      if (currentIDV === this.minIDV) {
        this.idvSelector = 'minimum';
      } else if (currentIDV === this.maxIDV) {
        this.idvSelector = 'maximum';
      } else if (currentIDV > 0) {
        this.idvSelector = 'custom';
      } else {
        this.idvSelector = '';
      }

      this.changeIDV = false;
    },
    // Add closemodal method to handle closing without applying changes
    closemodal() {
      // Ensure product.idvDetails exists
      if (!this.requestBody.product) {
        this.requestBody.product = {};
      }
      if (!this.requestBody.product.idvDetails) {
        this.requestBody.product.idvDetails = { insuredDeclaredValue: 0 };
      }

      // Reset all IDV-related values when closing without applying
      const currentIDV = this.requestBody.product.idvDetails.insuredDeclaredValue || 0;
      this.selectedIDV = currentIDV;
      this.needIDV = currentIDV === 0 ? false : true;

      // Reset idvSelector based on current value
      if (currentIDV === this.minIDV) {
        this.idvSelector = 'minimum';
      } else if (currentIDV === this.maxIDV) {
        this.idvSelector = 'maximum';
      } else if (currentIDV > 0) {
        this.idvSelector = 'custom';
      } else {
        this.idvSelector = '';
      }

      this.changeIDV = false;
    },
    //Apply IDV
    applyIDV() {
      // Ensure product.idvDetails exists
      if (!this.requestBody.product) {
        this.requestBody.product = {};
      }
      if (!this.requestBody.product.idvDetails) {
        this.requestBody.product.idvDetails = { insuredDeclaredValue: 0 };
      }

      if (this.needIDV) {
        // Only validate IDV if needIDV is true
        if (this.selectedIDV < this.minIDV || this.selectedIDV > this.maxIDV) {
          return;
        }
        // Apply the selected IDV to the request body
        this.requestBody.product.idvDetails.insuredDeclaredValue = this.selectedIDV;
      } else {
        // Set IDV to 0 if needIDV is false
        this.requestBody.product.idvDetails.insuredDeclaredValue = 0;
        this.selectedIDV = 0;
      }

      sessionStorage.setItem('quote_request', JSON.stringify(this.requestBody));
      this.clearCompareList();
      this.changeIDV = false;
      this.breakTheLoop = true;
      this.pollapiflag = false;
      this.idvVisibilityFlag = true;
      this.refetchIDVonClick = true;
      this.loading2 = true;
      this.userData.idvSelector = this.needIDV ? this.idvSelector : '';
      sessionStorage.setItem('userData', JSON.stringify(this.userData));
      // Pass 0 if needIDV is false, otherwise pass the selected IDV
      this.getMultiQuote(this.needIDV ? this.selectedIDV : 0);
    },
    //Handel Selected Item
    handleSelectedItem(value) {
      this.userData = JSON.parse(sessionStorage.getItem("userData"));
      this.selectedItem = value; // Update the parent component's data
      this.pollapiflag = false;
      this.getMultiQuote(this.selectedIDV);
    },
    resolveImagePath(variable) {
      return variable || "";
    },
    // Get Selected IDV all API
    // getSelectedIDV() {
    //   //product.idvDetails.insuredDeclaredValue
    //   this.insuredDeclaredValue = this.selectedIDV
    //   // this.minIDV = this.selectedIDV;
    // },
    // Handle IDV Selection on Range
    handleIdvSelection(selected, idvValueSelected) {
      // Only process selection if needIDV is true
      if (!this.needIDV) return;

      // Store which option was selected (minimum, maximum, or custom)
      this.idvSelector = selected;

      // Only update the temporary selectedIDV value based on which option was selected
      if (selected === 'minimum') {
        this.selectedIDV = Number(this.minIDV);
      } else if (selected === 'maximum') {
        this.selectedIDV = Number(this.maxIDV);
      } else if (selected === 'custom') {
        // For custom, we'll use the existing selectedIDV or current insuredDeclaredValue
        this.selectedIDV = Number(idvValueSelected || this.insuredDeclaredValue);
      }

      // Validate the selected IDV
      if (this.selectedIDV >= this.minIDV && this.selectedIDV <= this.maxIDV) {
        document.querySelector('.idvError').style.display = 'none';
        document.querySelector('.idvError').innerHTML = "";
      } else {
        document.querySelector('.idvError').style.display = 'block';
        document.querySelector('.idvError').innerHTML = `Enter IDV value between &#8377;&nbsp;${this.formatIndianCurrency(this.minIDV)} and &#8377;&nbsp;${this.formatIndianCurrency(this.maxIDV)}`;
      }

      // Store in session storage but don't apply to the request body yet
      sessionStorage.setItem('idvValues', JSON.stringify({
        selectedIDV: this.selectedIDV,
        declaredIDV: this.insuredDeclaredValue
      }));
    },

    // handleIdvSelection(selected) {
    //   if (selected == 'minimum') {
    //     this.selectedIDV = this.minIDV;
    //   } else if (selected == 'maximum') {
    //     this.selectedIDV = this.maxIDV;
    //   } else if (selected == 'suggested') {
    //     this.selectedIDV = this.suggestedIDV;
    //   } else if (selected == 'custom') {
    //     // this.insuredDeclaredValue = this.selectedIDV;
    //     // this.suggestedIDV = this.selectedIDV;
    //   }
    //   if (this.selectedIDV >= this.minIDV && this.selectedIDV <= this.maxIDV) {
    //     document.querySelector('.idvError').style.display = 'none'
    //     document.querySelector('.idvError').innerHTML = ""
    //   } else {
    //     document.querySelector('.idvError').style.display = 'block';
    //     document.querySelector('.idvError').innerHTML = `Enter IDV value between &#8377;${this.minIDV} and &#8377;${this.maxIDV}`;
    //   }
    //   this.requestBody.product.idvDetails.insuredDeclaredValue = this.selectedIDV;
    //   sessionStorage.setItem('quote_request', JSON.stringify(this.requestBody))
    //   sessionStorage.setItem('idvValues', JSON.stringify({
    //     selectedIDV: this.selectedIDV,
    //     declaredIDV: this.insuredDeclaredValue
    //   }));
    // },
    handleChoosenIDV(e) {
      // Only process input if needIDV is true
      if (!this.needIDV) return;

      // Update the selectedIDV with the entered value
      this.selectedIDV = Number(e.target.value);

      // Validate the entered IDV
      if (this.selectedIDV >= this.minIDV && this.selectedIDV <= this.maxIDV) {
        document.querySelector('.idvError').style.display = 'none';
        document.querySelector('.idvError').innerHTML = "";
      } else {
        document.querySelector('.idvError').style.display = 'block';
        document.querySelector('.idvError').innerHTML = `Enter IDV value between &#8377;&nbsp;${this.formatIndianCurrency(this.minIDV)} and &#8377;&nbsp;${this.formatIndianCurrency(this.maxIDV)}`;
      }

      // Only update the temporary value, not the actual insuredDeclaredValue yet
      // The insuredDeclaredValue will be updated in applyIDV() when the user clicks Apply
      sessionStorage.setItem('idvValues', JSON.stringify({
        selectedIDV: this.selectedIDV,
        declaredIDV: this.insuredDeclaredValue
      }));
    },
    //Convert in Thousand with K
    convertToThousandsWithKorL(number) {
      const number1 = parseFloat(number);
      if (number1 >= 100000) {
        // 1 lakh (100,000) or more
        return (number1 / 100000).toFixed(1) + 'L';
      } else if (number1 >= 1000) {
        // 1 thousand (1,000) or more
        return (number1 / 1000).toFixed(1) + 'k';
      }
      return number1.toString();
    },

    //Extract USP Array
    extractUSP(obj) {
      const uspArray = [];
      for (let key in obj) {
        if (key.startsWith('usp') && obj[key] && obj[key] !== null && obj[key] !== undefined) {
          uspArray.push(obj[key]);
        }
      }
      return uspArray;
    },
    getPolicydetails(data) {
      this.loading = true;
      this.pollapiflag = false;
      sessionStorage.setItem("selectedUniqueAddons", JSON.stringify(this.selectedUniqueAddons))
      sessionStorage.setItem("selected_plan_data", JSON.stringify(data))
      this.pollapiflag = false;
      this.setUpSQ(data);
    },
    //Get Polling Data
    pollData() {
      // this.disableButtons = true;
      if (this.pollapiflag == true) {
        this.getMotorProduct();
      } else {
        this.loading2 = false;
        if (this.responseData?.length == 0) {
          this.erMsg = 'No products found as per your selected filter. Please change the filters.';
        }
        this.beforeDestroy();
      }
    },
    //Get Polling Data
    pollDataSQ() {
      if (this.pollapiflagSQ == true) {
        this.getMotorProductSQ();
      } else {
        this.loading2 = false;
        if (this.responseData?.length == 0) {
          this.erMsg = 'No products found as per your selected filter. Please change the filters.';
        }
        this.beforeDestroy();
      }
    },
    //Cleare Interval
    beforeDestroy() {
      this.disableButtons = false;
    },
    //Convert Currency 
    currency(amt) {
      const tmpAmt = parseFloat(amt).toFixed(2);
      return tmpAmt.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    formatIndianCurrency(num) {
      // Handle undefined, null, or non-numeric values
      if (num === undefined || num === null || isNaN(num)) {
        num = 0;
      }

      // Convert to string and split into integer and decimal parts
      let [integerPart, decimalPart] = num.toString().split(".");
      let lastThree = integerPart.slice(-3);
      let rest = integerPart.slice(0, -3);

      if (rest !== '') {
        rest = rest.replace(/\B(?=(\d{2})+(?!\d))/g, ",");
      }
      let formattedDecimal = decimalPart ? "." + parseFloat("0." + decimalPart).toFixed(2).split(".")[1] : "";
      return rest !== '' ? rest + ',' + lastThree + formattedDecimal : lastThree + formattedDecimal;
    },
    sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    },
    //Polling API
    async getMotorProduct() {
      // Store current expand states before API call
      const currentExpandStates = {};
      this.displayErrorMessages = "";
      if (this.uniqueAddons) {
        Object.keys(this.uniqueAddons).forEach(category => {
          currentExpandStates[category] = this.uniqueAddons[category].expand;
        });
      }

      this.activePolicyType = (this.motorProductType == '4W-Pvt' && this.quoteCategory == 'Roll-Over') ? "Package(1+1)" : (this.motorProductType == '4W-Pvt' && this.quoteCategory == 'New') ? "Bundled(1+3)" : (this.motorProductType == '2W-Pvt' && this.quoteCategory == 'Roll-Over') ? "Package(1+1)" : (this.motorProductType == '2W-Pvt' && this.quoteCategory == 'New') ? "StandaloneTP(5)" : "Bundled(1+5)";
      this.loading2 = true;

      // this.suggestedIDV = 0;
      let headers = { "Authorization": `Bearer ${this.$store.state.token}` };
      let reqData = [this.requestId];
      const startTime = Date.now();
      const maxPollingTime = 3 * 60 * 1000;
      while (this.pollapiflag && (Date.now() - startTime) < maxPollingTime) {
        try {
          if (this.$route.path !== "/policy-quote") {
            this.pollapiflag = false;
            break;
          }
          // if(this.breakTheLoop){
          //   break;
          // }
          // console.log("Inside Get Motor Product misssing")
          const response = await this.backendApi("quotationPoll", reqData, headers, "get");
          if (response?.data?.data?.quote?.length > 0) {
            const quotes = response?.data?.data?.quote;
            if (this.refetchIDVonClick) {
              this.idvVisibilityFlag = true;
              for (let i = 0; i < quotes?.length; i++) {
                const suggestedIDV = quotes[i]?.supportingData?.insuredDeclaredValue?.suggestedIDV;
                if (suggestedIDV) {
                  this.onMountFlag = false;
                  this.idvVisibilityFlag = false;
                  this.reloadIDVcontainer();
                  this.refetchIDVonClick = false;
                  break;
                }
                if (suggestedIDV == 0 && quotes.length == 1) {
                  this.suggestedIDV = suggestedIDV;
                  // this.insuredDeclaredValue = suggestedIDV;
                  // this.selectedIDV = suggestedIDV;
                  this.onMountFlag = false;
                  this.idvVisibilityFlag = false;
                  this.reloadIDVcontainer();
                  this.refetchIDVonClick = false;
                  break;
                }
              }
            }
            if (this.onMountFlag) {
              for (let j = 0; j < quotes?.length; j++) {
                const suggestedIDV = quotes[j]?.supportingData?.insuredDeclaredValue?.suggestedIDV;
                if (suggestedIDV) {
                  this.suggestedIDV = suggestedIDV;
                  // this.insuredDeclaredValue = suggestedIDV;
                  // this.selectedIDV = suggestedIDV;
                  this.onMountFlag = false;
                  this.idvVisibilityFlag = false;
                  this.reloadIDVcontainer();
                  this.refetchIDVonClick = false;
                  break;
                }
                if (suggestedIDV == 0 && quotes.length == 1) {
                  this.suggestedIDV = suggestedIDV;
                  // this.insuredDeclaredValue = suggestedIDV;
                  // this.selectedIDV = suggestedIDV;
                  this.onMountFlag = false;
                  this.idvVisibilityFlag = false;
                  this.reloadIDVcontainer();
                  this.refetchIDVonClick = false;
                  break;
                }
              }
            }
            response?.data?.data?.quote?.forEach((ele) => {
              if (!this.productCodes.includes(ele.insuranceAndProducts.productCode)) {
                this.productCodes.push(ele.insuranceAndProducts.productCode);

                // Calculate the premium value
                const premiumValue =
                  Number(
                    ele.productDetails.basicOwnDamagePremiumForEachPolicyTerm.premiumForEachPolicyTerm[0].premiumForEachPPO[0].premiumForEachPPF[0].totalBasicODPremiumValue
                  ) +
                  Number(
                    ele.productDetails.thirdPartyPremiumForEachPolicyTerm.premiumForEachPolicyTerm[0].premiumForEachPPO[0].premiumForEachPPF[0].totalBasicTPPremiumValue
                  ) -
                  Number(
                    ele.productDetails.motorNCBPremium[0].premiumForEachPolicyTerm[0].premiumForEachPPO[0].premiumForEachPPF[0].totalPremiumValue

                  );

                // Add the calculated premium value to the item for sorting purposes
                ele.premiumValue = premiumValue;
                ele.addonView = false;
                this.responseData.push(ele);
              }
            });
            this.responseData.sort((a, b) => a.premiumValue - b.premiumValue);
          }
          if(this.$store.state.configData && this.$store.state.configData.HIDE_INSPECTION && this.$store.state.configData.HIDE_INSPECTION.length > 0){
            const hideInspectionList = this.$store.state.configData.HIDE_INSPECTION;
            this.responseData = this.responseData.filter((quote) => {
              if (hideInspectionList.includes(quote.insuranceAndProducts.insuranceCompanyCode)) {
                return quote.productDetails.inspectionDetails.isInspectionRequired == false;
              }
              return true;
            });
          }
          const values = this.responseData.map(quote => quote.supportingData.insuredDeclaredValue);
          const values1 = values.filter(obj => Object.values(obj).some(value => value != null ? value.toString().trim() != "" : 0))
          this.insuredDeclaredValues = values1.map(obj => Object.fromEntries(Object.entries(obj).map(([key, value]) => [key, Number(value)]))).filter(item => item.minimumIDV !== 0);
          // AlaSQL query to find the minimum maximumIDV
          const maxIDV1 = alasql('SELECT MAX(maximumIDV) AS minMaxIDV FROM ?', [this.insuredDeclaredValues]);
          // this.maxIDV = this.convertToThousandsWithKorL(maxIDV1[0].minMaxIDV);
          this.maxIDV = isNaN(maxIDV1[0].minMaxIDV) ? 0 : parseInt(maxIDV1[0].minMaxIDV);
          const minIDV1 = alasql('SELECT MIN(minimumIDV) AS minimumIDV FROM ?', [this.insuredDeclaredValues]);
          // this.minIDV =this.convertToThousandsWithKorL(minIDV1[0].minimumIDV);
          this.minIDV = isNaN(minIDV1[0].minimumIDV) ? 0 : parseInt(minIDV1[0].minimumIDV);
          // Extract policyType values
          const policyTypes1 = this.responseData.map(item => {
            return {
              name: item.insuranceAndProducts.policyType,
              description: item.insuranceAndProducts.policyTypeDesc
            }
          });
          document.querySelectorAll(".remove-expand").forEach(element => {
            element.classList.remove("expand")
          });
          // this.filterPolicies(this.addonsMQ, this.policyTypes);
          this.formatAddons();
          this.policyTypesSelected = JSON.parse(JSON.stringify(this.policyTypes.map(obj1 => obj1.name)))
          this.syncActivePolicyTypeWithAvailableQuotes();
          let sessionIDVs = JSON.parse(sessionStorage.getItem('idvValues'));
          if (sessionStorage.getItem("motor_covers")) {
            this.motorCovers = JSON.parse(sessionStorage.getItem('motor_covers'))
          }
          if (sessionStorage.getItem('plansWithAddons')) {
            this.plansWithAddons = JSON.parse(sessionStorage.getItem('plansWithAddons'))
            // console.log("inside planswithAddons in quote call")
            this.filterPlansWithAddons();
            this.manageCngCovers();
          }
          if (sessionIDVs) {
            // this.selectedIDV = sessionIDVs.selectedIDV;
            // this.actualDeclaredIDVValue = sessionIDVs.declaredIDV
          } else {
            // this.selectedIDV = this.suggestedIDV;
            this.actualDeclaredIDVValue = this.suggestedIDV
          }
          // Stop Polling
          if (response.data.data.isPollComplete == true) {
            this.loading2 = false;
            this.pollapiflag = false;
            this.idvVisibilityFlag = false;
            // this.reloadIDVcontainer();
            this.beforeDestroy();
            this.errors.length = 0;
            response.data.errors.forEach(errObj => this.errors.push(errObj));
            this.groupErrors();
            this.filterPlansWithAddons();
            // After polling is complete, ensure the Select All checkbox states are properly applied
            if (this.uniqueAddons) {
              Object.keys(this.uniqueAddons).forEach(categoryName => {
                // Restore expand state
                if (currentExpandStates[categoryName] !== undefined) {
                  this.uniqueAddons[categoryName].expand = currentExpandStates[categoryName];
                }

                if (this.categorySelectAllStates[categoryName]) {
                  this.uniqueAddons[categoryName].selectAll = this.categorySelectAllStates[categoryName];

                  // Ensure all addons in this category are selected
                  if (this.uniqueAddons[categoryName].selectAll) {
                    this.uniqueAddons[categoryName].addon.forEach(addon => {
                      const exists = this.selectedUniqueAddons.some(
                        selected => selected.optionName === addon.optionName && selected.category === addon.category
                      );
                      if (!exists) {
                        this.selectedUniqueAddons.push(addon);
                      }
                    });
                  }
                }
              });
            }
            this.handlePaCoverForGodigit();
            break;
          }
          if (response.data.errors.length > 0) {
            if (response.data.errors[0].errorIdentifier == "INVALID_REQUEST_ID") {
              this.pollapiflag = false;
              break;
            }
          }
          await this.sleep(1000);
        } catch (error) {
          console.log('error msg block', error);
          this.loading = false;
        }
      };
      if ((Date.now() - startTime) >= maxPollingTime) {
        this.pollapiflag = false;
        this.loading2 = false;
        this.loading = false;
      }
    },
    handlePaCoverForGodigit(){
      // Remove paCover from GODIGIT OD plan
      this.plansWithAddons = this.plansWithAddons.map(planAddon => {
        if (planAddon.productCode == 'GO4WOD' || planAddon.productCode == 'GO2WOD') {
          return {
            ...planAddon,
            addons: planAddon.addons.filter(item => item.addonName.optionSelected !== 'paCvr' || item.addonName.optionName !== "Personal Accident Cover")
          };
        }
        return planAddon;
      });
    },
    removeDuplicatesByOptionSelected(covers) {
      const seen = new Set();
      return covers.filter(item => {
        if (!item.optionSelected) return true;
        if (seen.has(item.optionSelected)) {
          return false;
        }
        seen.add(item.optionSelected);
        return true;
      });
    },
    //Get Multi quote Data
    getMultiQuote(selectedIDV = this.suggestedIDV) {
      let formAllData = JSON.parse(sessionStorage.getItem("formAlldata"));
      let rtoCodeEntry  = formAllData.find(item => item.rtoCode);
      let cityEntry  = formAllData.find(item => item.city);
      let rtoCodeInFormData = rtoCodeEntry ? rtoCodeEntry.rtoCode[0] : null;
      let cityInFormData = cityEntry ? cityEntry.city[0] : null;
      this.formCodesForVehicle.rtoCode = rtoCodeInFormData;
      this.formCodesForVehicle.city = cityInFormData;
      // Hide the refresh button after it's clicked
      this.zeroDepCurrentChange();
      this.isChangeFilter = false;
      this.checkODDateMoreThan90Days();
      this.previousExpiryDateManage();
      // Save the state of Select All checkboxes before fetching data
      if (this.uniqueAddons) {
        Object.keys(this.uniqueAddons).forEach(categoryName => {
          this.categorySelectAllStates[categoryName] = this.uniqueAddons[categoryName].selectAll;
        });
      }

      this.responseData = [];
      this.productCodes = [];
      this.pollapiflag = false;

      // Reset date modification UI
      this.modifyDate = "";
      this.modifyDateValue = "";
      this.dateError = "";

      // Send Personal Accident Cover by default for the first time (individual only; corporate must not carry paCvr)
      const paCvrAddedFirstTimeFlag = JSON.parse(sessionStorage.getItem("paCvrAddedFirstTime"));
      if (!paCvrAddedFirstTimeFlag && ['individual'].includes(this.policyHolderType)) {
        this.handlePaCvrSelection();
        sessionStorage.setItem("paCvrAddedFirstTime", JSON.stringify(true));
      }
      this.handleTppdCover();

      let fuelType = (this.userData.fuelType).toLowerCase();
      if (fuelType === "cng" || fuelType === "lpg") {
        if (!this.motorCovers.find(cover => cover.optionSelected === 'cngCvr')) {
          this.motorCovers.push({
            "optionSelected": "cngCvr",
            "optionValue": [
              {
                "optionValueSelected": "addOnSumAssured",
                "optionValueInput": ""
              }
            ],
            "varFields": [
              {
                "fieldName": "",
                "fieldValue": ""
              }
            ]
          })
          this.motorCovers.push({
            "optionSelected": "tpCngCvr",
            "optionValue": [
              {
                "optionValueSelected": "addOnSumAssured",
                "optionValueInput": ""
              }
            ],
            "varFields": [
              {
                "fieldName": "",
                "fieldValue": ""
              }
            ]
          })
          this.selectedUniqueAddons.push({
            max: "50000",
            min: "10000",
            type: "Text",
            values: [],
            default: "",
            category: "Accessories",
            multipleOf: "",
            optionDesc: "Bi-Fuel Kit Cover",
            optionName: "Bi-Fuel Kit Cover",
            policyType: "Package(1+1)",
            temp_price: "",
            inbuiltFeature: 0,
            optionSelected: "cngCvr",
            premiumDetails: [],
            addOnSumAssured: null,
            optionValueSelected: "addOnSumAssured",
            premiumIncludedFlag: 1,
            optionValueDescription: "Insured Amount"
          })
        }
      } else {
        this.motorCovers.push({
          "optionSelected": "",
          "optionValue": [
            {
              "optionValueSelected": "addOnSumAssured",
              "optionValueInput": "100"
            }
          ],
          "varFields": [
            {
              "fieldName": "",
              "fieldValue": ""
            }
          ]
        })
      }
      sessionStorage.setItem("selectedUniqueAddons", JSON.stringify(this.selectedUniqueAddons));
      if(sessionStorage.getItem("motorCovers")){
        this.motorCovers = JSON.parse(sessionStorage.getItem("motorCovers"));
      }
      this.motorCovers = this.removeDuplicatesByOptionSelected(this.motorCovers);
      sessionStorage.setItem("motor_covers", JSON.stringify(this.motorCovers));
      var self = this;
      self.loading2 = true;
      self.idvVisibilityFlag = true;
      this.previousPolicyTpExpiryDatenew = this.userData.TpDate;
      const vahanData = sessionStorage.getItem("vahanData") ? JSON.parse(sessionStorage.getItem("vahanData")) : "";

      this.requestBody =
      {
        "typeOfQuote": "Multi-Quote",
        "quoteCategory": this.quoteCategory,
        "alternateFreqRequired": "No",
        "outOfBoundConfig": "No",
        "additionalSetup": {
          "currency": "",
          "userGeoLocation": {
            "latitude": null,
            "longitude": null
          },
          "userCountry": null,
          "userRegion": null,
          "userLanguage": null,
          "userIP": null,
          "userAgent": null
        },
        "distributor": {
          "distributorID": getDistributer()["distributerID"],
          "salesChannel": "Online",
          "agentID": this.getAgentIdFromRmData(this.rmData),
          "channelType": this.rmData.RoleId !== "1" ? "B2B" : "B2C",
          "varFields": [
            {
              "fieldName": "string",
              "fieldValue": "string"
            }
          ]
        },
        "personalInformation": {
          "individualDetails": [
            {
              "memberType": "Proposer",
              "memberSequenceNumber": 1,
              "nomineeRelWithInsured": null,
              "title": null,
              "firstName": null,
              "middleName": null,
              "lastName": null,
              "gender": "Male",
              "dateOfBirth": null,
              "age": null,
              "maritalStatus": null,
              "qualification": "Graduate",
              "occupation": "Salaried",
              "annualIncome": null,
              "email": this.userData.email,
              "mobileNumber": parseInt(this.userData.mobileNumber),
              "zipCode": this.userData.pinCode || "400001",
              "state": null,
              "city": null,
              "address1": null,
              "address2": null,
              "address3": null,
              "smoker": false,
              "residentStatus": null,
              "ownerBelongsToOrganizationFlag": this.policyHolderType == 'individual' ? false : true,
              "memberGST": null,
              "drivingLicenseNumber": null,
              "drivingExperienceYears": null,
              "varFields": [
                {
                  "fieldName": "string",
                  "fieldValue": "string"
                }
              ]
            }
          ]
        },
        "product": {
          "productType": "motor",
          "motorProductType": this.motorProductType,
          "insuranceAndProducts": [
            {
              "insuranceCompanyCode": "",
              "policyType": "",
              "productCode": [
                ""
              ]
            }
          ],
          "policyTerm": 1,
          "policyTermUnit": null,
          "premiumPaymentOption": null,
          "premiumPaymentTerm": null,
          "premiumPaymentFrequency": null,
          "planOption": {
            "planId": null
          },
          "registrationDetails": {
            "registrationNumber": this.quoteCategory != 'New'  ? this.userData?.vehicleNumber : "New",
            "registrationDate": this.userData.RegDate,
            "registrationYear": null,
            "registrationMonth": null,
            "registrationDay": null,
            "manufacturingMonth": null,
            "manufacturingYear": (this.userData.MfgYear).toString(),
            "dateOfPurchase": this.userData.RegDate,
            "autoMembershipFlag": null,
            "autoMembershipNumber": null,
            "pucDeclaration": null,
            "pucNumber": null,
            "pucExpiryDate": null
          },
          "rtoLocationCode": this.userData.rtoCode || rtoCodeInFormData,
          "vehicleDetails": {
            "vehicleUniqueCode": vahanData?.vehicleDetails?.vehicleUniqueCode || String(this.userData.vehicleKey) || String(JSON.parse(sessionStorage.getItem("vehicleKey"))),
            "vehicleMakeCode": this.userData.carMake.makeCode,
            "vehicleModelCode": this.userData.model.modelCode,
            "vehicleVariantCode": this.userData.variant.variantCode,
            "vehicleFuelType": this.userData.fuelType,
            "vehicleSeatingCapacity": null,
            "vehicleCubicCapacity": null,
            "vehicleColor": null,
            "vehicleEngineNumber": null,
            "vehicleChassisNumber": null,
            "vehicleEnergyType": null,
            "vehicleWheelsChairAccess": null,
            "vehicleEmissionStandard": null,
            "vehicleWheelsCount": null,
            "vehicleCargoVolume": null
          },
          "idvDetails": {
            "insuredDeclaredValue": this.selectedIDV,
            "sideCarInsuredDeclaredValue": null
          },
          "ncbDetails": {
            "claimLastYearFlag": (this.ownershipTransferFlag) ? true : this.userData.prePolicyGreaterThan90Days ? true : this.userData.previous_year_claim,
            "numberOfClaims": (this.ownershipTransferFlag) ? 1 : this.userData.prePolicyGreaterThan90Days ? 1 : this.userData.previous_year_claim ? 1 : 0,
            "ncbPercentageLastYear": (this.ownershipTransferFlag) ? 0 : parseInt(this.userData.previous_year_claim ? 0 : this.userData.applicablePercentage)
          },
          "previousPolicyDetails": {
            "previousCoverageType": this.userData?.prevPolicyType || "",
            "IsPreviousPolicyExpired": this.userData.OdDate ? (this.userData.OdDate < this.currentDate ? true : false) : null,
            "previousPolicyEndDate": this.userData.OdDate === "" ? null : this.userData.OdDate,
            "previousPolicyStartDate": this.userData.OdDate === "" ? null : this.calculatePreviousPolicyStartDate(this.userData.OdDate),
            "previousPolicyInsurer": this.userData?.prevInsurerName?.toUpperCase() || null,
            "previousPolicyNumber": null,
            "previousPolicyOdStartDate": this.userData.OdDate === "" ? null : this.calculatePreviousPolicyStartDate(this.userData.OdDate),
            "previousPolicyOdExpiryDate": this.userData.OdDate === "" ? null : this.userData.OdDate,
            "previousPolicyOdInsurer": null,
            "previousPolicyOdNumber": null,
            "previousPolicyTpStartDate": this.displayTPSection() ? this.previousPolicyTpStartDatenew : null,
            "previousPolicyTpExpiryDate": this.displayTPSection() ? this.previousPolicyTpExpiryDatenew : null,
            "previousPolicyTpInsurer": this.userData?.tpInsurerName ? this.userData?.tpInsurerName : null,
            "previousPolicyTpNumber": null
          },
          // "motorCovers": this.motorCovers
        }
      }
      let paCoverSelection = JSON.parse(sessionStorage.getItem('paCoverSelection'));
      const cngCvr = this.motorCovers.find(cover => cover.optionSelected === 'cngCvr');
      const tpCngCvr = this.motorCovers.find(cover => cover.optionSelected === 'tpCngCvr');
      if (cngCvr && tpCngCvr && cngCvr.optionValue.length > 0 && tpCngCvr.optionValue.length > 0) {
        tpCngCvr.optionValue[0].optionValueInput = cngCvr.optionValue[0].optionValueInput;
      }
      if (paCoverSelection && paCoverSelection.isChecked) {
        // First remove any existing paCvr entries to avoid duplicates
        this.motorCovers = this.motorCovers.filter(coverr => coverr.optionSelected != 'paCvr');

        // Then add the paCvr entry with the correct structure
        this.motorCovers.push({
          "optionSelected": "paCvr",
          "optionValue": [
            {
              "optionValueSelected": "paOption",
              "optionValueInput": "1"
            }
          ],
          "varFields": [
            {
              "fieldName": "",
              "fieldValue": ""
            }
          ]
        });
        // const existingAddon = this.selectedUniqueAddons.find(addon => addon.optionSelected === 'paCvr');
        // if (!existingAddon) {
        //   this.selectedUniqueAddons.push({
        //     max: 1500000,
        //     min: 100000,
        //     type: "none",
        //     values: [],
        //     default: "1500000",
        //     category: "Accidental Covers",
        //     multipleOf: "100000",
        //     optionDesc: "An accident cover which provides financial assistance to the car's owner in case of disablement or death due to an accident. Every individual vehicle owner must opt for this cover as per IRDAI guidelines, except for those without a driving license or having an existing Personal Accident cover of at least Rs. 15 lakh",
        //     optionName: "Personal Accident Cover",
        //     policyType: "Package(1+1)",
        //     temp_price: "1500000",
        //     inbuiltFeature: 0,
        //     optionSelected: "paCvr",
        //     premiumDetails: [],
        //     addOnSumAssured: null,
        //     optionValueSelected: "paOption",
        //     premiumIncludedFlag: "No",
        //     optionValueDescription: ""
        //   });
        // }
      }

      this.motorCovers = this.motorCovers.filter(
        cover => !(cover.optionSelected === 'payAsDrv' && this.quoteCategory === 'New')
      );

      // Handle NCB body
      console.log("this.userData?.previous_year_claim", this.userData?.previous_year_claim, this.requestBody.product.ncbDetails.numberOfClaims)
      if(this.requestBody){
        if(this.userData?.previous_year_claim){
          this.requestBody.product.ncbDetails.claimLastYearFlag = true;
          this.requestBody.product.ncbDetails.numberOfClaims = 1;
        }else{
          delete this.requestBody.product.ncbDetails.claimLastYearFlag;
          this.requestBody.product.ncbDetails.numberOfClaims = 0;
          this.requestBody.product.ncbDetails.ncbPercentageLastYear = Number(
            String(this.userData.applicablePercentage).replace("%", "")
          );
        }
      }


      this.requestBody.personalInformation.individualDetails[0].isOwnerTransfer = this.ownershipTransferFlag=="false" ? false : this.ownershipTransferFlag=="true" ? true : null;

      if(this.requestBody.personalInformation.individualDetails[0].isOwnerTransfer){
        this.requestBody.product.ncbDetails.claimLastYearFlag = true;
        this.requestBody.product.ncbDetails.numberOfClaims = 1;
      }else{
        if(this.userData?.previous_year_claim){
          this.requestBody.product.ncbDetails.claimLastYearFlag = true;
          this.requestBody.product.ncbDetails.numberOfClaims = 1;
        }else{
          delete this.requestBody.product.ncbDetails.claimLastYearFlag;
          this.requestBody.product.ncbDetails.numberOfClaims = 0;
          this.requestBody.product.ncbDetails.ncbPercentageLastYear = Number(
            String(this.userData.applicablePercentage).replace("%", "")
          );
        }
      }

      if(this.userData?.previousPolicyExpired == 'true'){
        let dateBefore91Days = new Date(new Date().setDate(new Date().getDate() - 91)).toISOString().split('T')[0];

        this.requestBody.product.ncbDetails.claimLastYearFlag = true;
        this.requestBody.product.ncbDetails.ncbPercentageLastYear = 0;
        this.requestBody.product.ncbDetails.numberOfClaims = 1;
        this.requestBody.product.previousPolicyDetails.previousCoverageType = "Package(1+1)";
        this.requestBody.product.previousPolicyDetails.IsPreviousPolicyExpired = true;
        this.requestBody.product.previousPolicyDetails.previousPolicyEndDate = dateBefore91Days;
        this.requestBody.product.previousPolicyDetails.previousPolicyOdExpiryDate = dateBefore91Days;
        this.requestBody.product.previousPolicyDetails.previousPolicyTpExpiryDate = dateBefore91Days;
      }

      sessionStorage.setItem("quote_request", JSON.stringify(this.requestBody));
      this.compareList = [];
      this.displayErrorMessages = "";
      sessionStorage.setItem('motor_covers', JSON.stringify(this.motorCovers));
      if (this.motorProductType === '2W-Pvt' && this.policyHolderType === 'corporate') {
        this.motorCovers = this.motorCovers.filter(item => item.optionSelected !== "legLibEm");
        this.selectedUniqueAddons = this.selectedUniqueAddons.filter(item => item.optionSelected !== "legLibEm");
      }
      // Align with ownerBelongsToOrganizationFlag: individual (flag false) always sends paCvr; corporate/org (flag true) never does
      const ownerBelongsToOrganizationFlag = !['individual'].includes(this.policyHolderType);
      if (ownerBelongsToOrganizationFlag) {
        this.motorCovers = this.motorCovers.filter(item => item.optionSelected !== 'paCvr');
      } else if (!this.motorCovers.some(cover => cover.optionSelected === 'paCvr')) {
        this.motorCovers.push({
          optionSelected: 'paCvr',
          optionValue: [
            {
              optionValueSelected: 'paOption',
              optionValueInput: '1'
            }
          ],
          varFields: [
            {
              fieldName: '',
              fieldValue: ''
            }
          ]
        });
      }
      sessionStorage.setItem('motor_covers', JSON.stringify(this.motorCovers));
      sessionStorage.setItem('motorCovers', JSON.stringify(this.motorCovers));
      this.requestBody.product.motorCovers = this.motorCovers;
      this.backendApi("quotationApi", this.requestBody, { "Authorization": `Bearer ${this.$store.state.token}` }, "post")
        .then((response) => {
          if (response.data.errors.length > 0) {
            this.loading = false;
            if (response.data.errors[0].errorDisplayMessage !== "") {
              let ck = 1; // Move counter outside the loop
              for (let i = 0; i < response.data.errors.length; i++) {
                this.displayErrorMessages += ck + ". " + stripHtml(response.data.errors[i]["errorDisplayMessage"]) + "<br/>";
                ck++; // Increment properly
              }
              this.loading2 = false;
              this.idvVisibilityFlag = false;
            }
          } else if (response && response.data) {
            this.requestId = response.data.reqId;
            sessionStorage.setItem("journey_id", JSON.stringify(response.data.data.journey_id));
            this.loading = false;
            if (response?.data?.data?.quote?.length > 0) {
              // this.suggestedIDV = response?.data?.data?.quote[0]?.supportingData?.insuredDeclaredValue?.suggestedIDV;
              // this.insuredDeclaredValue = this.suggestedIDV;
              response?.data?.data?.quote?.forEach((ele) => {

                if (!this.productCodes.includes(ele.insuranceAndProducts.productCode)) {
                  this.productCodes.push(ele.insuranceAndProducts.productCode)
                  this.responseData.push(ele)

                }
              });
            }
            // const insuredDeclaredValues = this.responseData.map(quote => quote.supportingData.insuredDeclaredValue);
            // // AlaSQL query to find the minimum maximumIDV
            // const maxIDV1 = alasql('SELECT MAX(maximumIDV) AS minMaxIDV FROM ?', [insuredDeclaredValues]);
            // // this.maxIDV = this.convertToThousandsWithKorL(maxIDV1[0].minMaxIDV);
            // this.maxIDV = isNaN(maxIDV1[0].minMaxIDV) ? 0 : parseInt(maxIDV1[0].minMaxIDV);
            // const minIDV1 = alasql('SELECT MIN(minimumIDV) AS minimumIDV FROM ?', [insuredDeclaredValues]);
            // // this.minIDV =this.convertToThousandsWithKorL(minIDV1[0].minimumIDV);
            // this.minIDV = isNaN(minIDV1[0].minimumIDV) ? 0 : parseInt(minIDV1[0].minimumIDV);
            if (response?.data?.errors?.length == 0) {
              this.responseData = [];
              this.productCodes = [];
              setTimeout(function () {
                self.pollapiflag = true;
                self.pollData();
              }, 1000);
            }
            else {
              this.loading2 = false;
              if (this.responseData.length == 0) {
                this.erMsg = 'No products found as per your selected filter. Please change the filters.';
                this.beforeDestroy();
              }
            }
          }

        }).catch((error) => {
          console.log('error msg block dp', error);
          const msg = "Service is Unavailable, Please try again later.";
          this.$router.push({ path: '/error-page', query: { backUrl: 'form-Wizard', msg: msg } });
        })
    },
    async handleQuotePDF(items, isMail = false) {
      const item = Array.isArray(items) ? items : [items];
      try {
        const payload = {
          "distributor": {
            "distributorID": getDistributer()["distributerID"],
            "salesChannel": "Online",
            "agentID": this.getAgentIdFromRmData(this.rmData),
            "channelType": this.rmData.RoleId !== "1" ? "B2B" : "B2C",
            "varFields": [
              {
                "fieldName": "string",
                "fieldValue": "string"
              }
            ]
          },
          "request": this.requestBody,
          "quote": item,
          "comparePlanId": ""
        }
        this.downloadStatus = "Download is in progress."
        this.isDownloadStart = true;
        const response = await this.backendApi("getCompareData", payload, { "Authorization": `Bearer ${this.$store.state.token}` }, "post");
        if (response && response.data && response.data.errors && response.data.errors.length > 0) {
          this.displayErrors = [];
          for (let i = 0; i < response.data.errors.length; i++) {
            this.displayErrors.push(response.data.errors[i]["errorDisplayMessage"])
          }
        } else {
          const base64Pdf = response.data.data;
          this.currentQuotePdfBase64 = base64Pdf;
          if(isMail){
            await this.sendCompareEmail();
          }
          this.openPdf(base64Pdf);
          this.downloadStatus = "Please click to download.";
          this.isDownloadStart = false;
        }
      } catch (error) {

      }
    },
    async sendCompareEmail() {
      try {
        const reqBody = {
          "distributor": {
            "distributorID": getDistributer()["distributerID"],
            "salesChannel": "Online",
            "agentID": this.getAgentIdFromRmData(this.rmData),
            "channelType": this.rmData.RoleId !== "1" ? "B2B" : "B2C",
            "varFields": [
              {
                "fieldName": "string",
                "fieldValue": "string"
              }
            ]
          },
          "eventName": "sendCompare",
          "application": "INS",
          "comparePlanId": "",
          "data": [
            {
              "emailId": this.userData.email,
              "channel": "email",
              "vehicleNumber": this.userData.vehicleNumber ? this.userData.vehicleNumber : "New",
              "attachment": this.currentQuotePdfBase64,
              "fileType": "pdf",
              "fileName": "Compare_quote",
              "fullName": "",
              ...getSpFieldsForCommunicationPayload()
            }
          ]
        }
        const response = await this.backendApi("sendEmailandSMS", reqBody, { "Authorization": `Bearer ${this.$store.state.token}` }, "post");
        if (response && response.data && response.data.errors && response.data.errors.length > 0) {
          this.displayErrors = [];
          for (let i = 0; i < response.data.errors.length; i++) {
            this.displayErrors.push(response.data.errors[i]["errorDisplayMessage"])
          }
        } else {
          // this.$toast.success("Email sent successfully.");
        }
      } catch (error) {

      }
    },
    openPdf(base64Pdf) {
      const byteCharacters = atob(base64Pdf);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/pdf' });

      const blobUrl = URL.createObjectURL(blob);
      window.open(blobUrl);
    },
    updateScreenWidth() {
      this.screenWidth = window.innerWidth;
    },
    toggleContent() {
      this.showContent = !this.showContent;
    },
    showBreakupmodal(selectedPlanData) {
      console.log("clicked-------");
      this.selectedPlanData = selectedPlanData;
      this.openAmountBreakupflag = true;
    },
    emitClose() {
      this.selectedPlanData = {};
      this.openAmountBreakupflag = false;
    },
    calculatePreviousPolicyStartDate(odDateString) {
      let dateBeforeOneYear91Days = new Date(new Date(new Date().setFullYear(new Date().getFullYear() - 1)).setDate(new Date().getDate() - 90)).toISOString().split('T')[0];
      
      if(this.userData?.previousPolicyExpired == 'true'){
        return dateBeforeOneYear91Days;
      }else{
        let odDate = new Date(odDateString);
        odDate.setFullYear(odDate.getFullYear() - 1);
        odDate.setDate(odDate.getDate() + 1);
        let previousPolicyStartDate = odDate.toISOString().split('T')[0];
        return previousPolicyStartDate;
      }
    },
    previousPolicyTpExpiryDate(odDateString) {
      let dateBeforeOneYear91Days = new Date(new Date(new Date().setFullYear(new Date().getFullYear() - 1)).setDate(new Date().getDate() - 90)).toISOString().split('T')[0];

      if(this.userData?.previousPolicyExpired == 'true'){
        return dateBeforeOneYear91Days;
      }else{
        let odDate = new Date(odDateString);
        odDate.setFullYear(odDate.getFullYear() + 1);
        odDate.setDate(odDate.getDate() - 1);
        let previousPolicyStartDate = odDate.toISOString().split('T')[0];
        return previousPolicyStartDate;
      }
    },
    calculatePreviousPolicyTpStartDate(tpDateString) {
      if (tpDateString) {
        let tpDate = new Date(tpDateString);
        if (this.motorProductType == "2W-Pvt") {
          tpDate.setFullYear(tpDate.getFullYear() - 5);
        }
        else
          tpDate.setFullYear(tpDate.getFullYear() - 3);
        tpDate.setDate(tpDate.getDate() + 1);
        let previousPolicyTpStartDate = tpDate?.toISOString().split('T')[0];
        return previousPolicyTpStartDate;
      }
    },
    groupErrors() {
      const grouped = this.errors.reduce((acc, error) => {
        if (!acc[error.manufacturerId]) {
          acc[error.manufacturerId] = {
            id: error.manufacturerId,
            isOpen: false,
            products: []
          }
        }
        acc[error.manufacturerId].products.push({
          productId: error.productId,
          errorMessage: stripHtml(error.listOfErrors[0].errorDisplayMessage || error.listOfErrors[0].errorMessage)
        })
        return acc
      }, {})

      this.groupedErrors = Object.values(grouped)
    },
    toggleManufacturer(manufacturerId) {
      const manufacturer = this.groupedErrors.find(m => m.id === manufacturerId)
      if (manufacturer) {
        manufacturer.isOpen = !manufacturer.isOpen
      }
    },
    remainErrorsOpen() {
      return;
    },
    async setUpSQ(data) {
      //mounted sq data
      if (sessionStorage.getItem("userData")) {
        this.userData = JSON.parse(sessionStorage.getItem("userData"));
        console.log(this.userData, "userData")
      }
      this.apiCallinginterval = parseInt(getLazyLoadingConfig()['inerval']);
      this.selected_plan_data = JSON.parse(sessionStorage.getItem("selected_plan_data"));
      let spdetail_flag = process.env.VUE_APP_SPDETAIL_ONESB;
      if (spdetail_flag == 1) {
        if (sessionStorage.getItem("rm_data")) {
          this.rmData = JSON.parse(sessionStorage.getItem("rm_data"));
          await this.getSPDetailsOneSB(this.rmData.UserId, this.selected_plan_data.insuranceAndProducts.insuranceCompanyCode);
        }
      }
      this.apiReqData = JSON.parse(sessionStorage.getItem("quote_request"));
      this.apiReqData.product.idvDetails.insuredDeclaredValue = this.selected_plan_data.supportingData.insuredDeclaredValue.suggestedIDV;

      //setupData
      this.apiReqData.typeOfQuote = "Single Quote";
      this.apiReqData.product.policyTerm = 1;
      this.apiReqData.product.insuranceAndProducts[0].insuranceCompanyCode = this.selected_plan_data.insuranceAndProducts.insuranceCompanyCode;
      this.apiReqData.product.insuranceAndProducts[0].policyType = this.selected_plan_data.insuranceAndProducts.policyType;
      this.apiReqData.product.planOption.planId = this.selected_plan_data.productDetails.planOption.planId
      this.apiReqData.product.insuranceAndProducts[0].productCode[0] = this.selected_plan_data.insuranceAndProducts.productCode
      this.apiReqData.product.previousPolicyDetails.previousCoverageType = this.selected_plan_data.productDetails.previousPolicyDetails.previousCoverageType;
      this.apiReqData.product.idvDetails.insuredDeclaredValue = this.selected_plan_data.supportingData.insuredDeclaredValue.suggestedIDV
      this.apiReqData.journey_id = JSON.parse(sessionStorage.getItem("journey_id"));
      // this.apiReqData.product.motorCovers=this.selected_plan_data.productDetails.motorCovers;
      // this.apiReqData.product.motorCovers=[];
      this.apiReqData.product.policyTerm = parseInt(this.selected_plan_data.productDetails.policyTerm);
      this.apiReqData.product.premiumPaymentFrequency = this.selected_plan_data.productDetails.premiumPaymentFrequency;

      this.apiReqData.product.motorCovers = [];
      // Get the plan from plansWithAddons for reference (to get temp_price and optionValueSelected if available)
      const plan = this.plansWithAddons.find(plan => plan.productCode === this.selected_plan_data.insuranceAndProducts.productCode);
      
      // Iterate through ALL motorCovers from the selected plan, not just those in plan.addons
      // This ensures all addons with premium > 0 or premiumIncludedFlag are included, including tpCngCvr
      this.selected_plan_data.productDetails.motorCovers.forEach(cover => {
        // Get premium value from motorCover
        const addonPremium = cover.premiumForEachPolicyTerm?.[0]?.premiumForEachPPO?.[0]?.premiumForEachPPF?.[0]?.premiumValue || 0;
        const premiumIncludedFlag = cover.premiumIncludedFlag;
        
        // Check if addon should be included: has premium > 0 OR is included in plan, AND is not mandatory
        const shouldInclude = (addonPremium > 0 || premiumIncludedFlag == '1' || premiumIncludedFlag == 'Yes') 
          && (cover.mandatoryInProduct == 'No' || cover.mandatoryInProduct == '0');
        
        if (shouldInclude) {
          // Check if this addon exists in plan.addons (to get temp_price and optionValueSelected if user modified it)
          const foundAddon = plan?.addons?.find(addon => addon.addonName?.optionSelected === cover.optionSelected);
          
          // Check if already added to motorCoversSQ (avoid duplicates)
          const alreadyAdded = this.motorCoversSQ.find(mc => mc.optionSelected === cover.optionSelected);
          if (alreadyAdded) return;
          
          if (foundAddon && foundAddon.addonName?.optionValue && foundAddon.addonName.optionValue.length > 0) {
            // Use values from plan.addons if available (user may have modified them)
            this.motorCoversSQ.push({
              optionSelected: cover.optionSelected || "",
              optionValue: [
                {
                  optionValueSelected: foundAddon.addonName.optionValueSelected || foundAddon.addonName.optionValue[0].optionValueSelected,
                  optionValueInput: String(foundAddon.addonName.temp_price || foundAddon.addonName.optionValue[0].optionValueInput)
                }
              ],
              varFields: [
                {
                  fieldName: "",
                  fieldValue: ""
                }
              ]
            });
          } else if (foundAddon && foundAddon.addonName?.optionValueSelected) {
            // Use optionValueSelected from plan.addons if available
            this.motorCoversSQ.push({
              optionSelected: cover.optionSelected || "",
              optionValue: [
                {
                  optionValueSelected: foundAddon.addonName.optionValueSelected || "",
                  optionValueInput: foundAddon.addonName.temp_price || cover.optionValue?.[0]?.optionValueInput || ""
                }
              ],
              varFields: [
                {
                  fieldName: "",
                  fieldValue: ""
                }
              ]
            });
          } else if (cover.optionValue && cover.optionValue.length > 0) {
            // Use values directly from motorCover
            this.motorCoversSQ.push({
              optionSelected: cover.optionSelected || "",
              optionValue: [
                {
                  optionValueSelected: cover.optionValue[0].optionValueSelected || "",
                  optionValueInput: cover.optionValue[0].optionValueInput || ""
                }
              ],
              varFields: [
                {
                  fieldName: "",
                  fieldValue: ""
                }
              ]
            });
          } else {
            // Fallback: add with empty/default values
            this.motorCoversSQ.push({
              optionSelected: cover.optionSelected || "",
              optionValue: [
                {
                  optionValueSelected: "",
                  optionValueInput: ""
                }
              ],
              varFields: [
                {
                  fieldName: "",
                  fieldValue: ""
                }
              ]
            });
          }
        }
      });

      let paCoverSelection = JSON.parse(sessionStorage.getItem('paCoverSelection'));
      this.motorCoversSQ = this.motorCoversSQ.filter(coverr => coverr.optionSelected != 'paCvr');
      if (this.selected_plan_data && !this.selected_plan_data.insuranceAndProducts.productCode.endsWith('OD')) {
        if (paCoverSelection && paCoverSelection.isChecked) {
          this.motorCoversSQ.push({
            "optionSelected": "paCvr",
            "optionValue": [
              {
                "optionValueSelected": "paOption",
                "optionValueInput": "1"
              }
            ],
            "varFields": [
              {
                "fieldName": "",
                "fieldValue": ""
              }
            ]
          })
        } else {
          this.motorCoversSQ.push({
            "optionSelected": "paCvr",
            "optionValue": [
              {
                "optionValueSelected": "paOption",
                "optionValueInput": this.paOwnerDriverSelectionModel || '1'
              }
            ],
            "varFields": [
              {
                "fieldName": "",
                "fieldValue": ""
              }
            ]
          })
        }
      }

      // this.motorCoversSQ = this.motorCovers;
      const cngCvr = this.motorCoversSQ.find(cover => cover.optionSelected === 'cngCvr');
      const tpCngCvr = this.motorCoversSQ.find(cover => cover.optionSelected === 'tpCngCvr');
      if (cngCvr && tpCngCvr && cngCvr.optionValue.length > 0 && tpCngCvr.optionValue.length > 0) {
        tpCngCvr.optionValue[0] = cngCvr.optionValue[0];
      }
      this.apiReqData.product.motorCovers = this.motorCoversSQ;
      this.handleZeroDepInCurrentPolicy(this.motorCoversSQ);


      this.rmData = JSON.parse(sessionStorage.getItem("rm_data"));
      this.apiReqData.distributor.channelType = this.rmData.RoleId !== "1" ? "B2B" : "B2C";
      sessionStorage.setItem("quote_request", JSON.stringify(this.apiReqData));
      await this.goToPolicyDetails(data);
      this.getSingleQuote();
    },
    handleZeroDepInCurrentPolicy(motorCoversSQ) {
      motorCoversSQ.forEach(element => {
        if (element.optionSelected === 'zeroDep') {
          element.optionValue[0].optionValueInput = String(this.currentZeroDep);
        }
      });
    },

    async goToPolicyDetails(data) {
      this.beforeDestroy();
      data.productDetails.premiumPaymentFrequency = this.premiumPaymentFrequency;
      sessionStorage.setItem("selected_plan_data", JSON.stringify(data));
      let breakJourney = false;
      sessionStorage.setItem("breakJourney", JSON.stringify(breakJourney));
      let request_data = [JSON.parse(sessionStorage.getItem("journey_id")), data.multi_quote_response_id];
      let headers = {};
      this.loading = true;
      const response = await this.backendApi("setProductSelection", {}, headers, "post", request_data)
      if (response?.errors?.length > 0) {
        let msg = ['Product Selection failed to update']
        this.$router.push({ path: '/networkalert', query: { backUrl: 'policy-quote', msg: msg } });
      } else {
        this.pollapiflag = true;
      }
    },
    //get single quote
    getSingleQuote() {
      var self = this;
      self.loading2 = true;
      console.log("this.requestBody", this.apiReqData)
      this.apiReqData.personalInformation.individualDetails[0].isOwnerTransfer = this.ownershipTransferFlag=="false" ? false : this.ownershipTransferFlag=="true" ? true : null;
      sessionStorage.setItem("quote_request", JSON.stringify(this.apiReqData));
      console.log("this.motorCovers SIngle quote", this.motorCovers);
      if(this.quoteCategory == "New"){
        delete this.apiReqData.product.ncbDetails.claimLastYearFlag;
        this.apiReqData.product.ncbDetails.numberOfClaims = 0;
      }
      if(this.policyHolderType == 'corporate'){
        this.apiReqData.product.motorCovers = this.apiReqData.product.motorCovers.filter(cover => cover.optionSelected != 'paCvr');
      }
      
      this.backendApi("quotationApi", this.apiReqData, { "Authorization": `Bearer ${this.$store.state.token}` }, "post")
        .then((response) => {
          if (response.data.errors.length > 0) {
            this.loading = false;
            for (let i = 0; i < response.data.errors.length; i++) {
              this.displayErrors.push(response.data.errors[i]["errorDisplayMessage"])
            }
            this.$router.push("/policy-quote");
          } else if (response && response.data) {

            this.requestIdSQ = response.data.reqId;
            // this.loading = false;
            if (response?.data?.data?.quote?.length > 0) {
              // this.responseData.push(response.data.data.quote)

            }
            if (response.data.errors.length == 0) {
              setTimeout(function () {
                self.pollapiflagSQ = true;
                self.pollDataSQ();
              }, 1000);
            }
            else {
              this.loading2 = false;
              if (this.responseData.length == 0) {
                this.erMsg = 'No products found as per your selected filter. Please change the filters.';
                self.beforeDestroy();
              }
            }
          }

        }).catch((error) => {
          console.log('error msg block dp', error);
          const msg = "Service is Unavailable, Please try again later.";
          this.displayErrors.push(msg)
          this.$router.push("/policy-quote");
        })
    },
    async getSPDetailsOneSB(rm_code, man_code) {
      let reqData = [man_code];
      let headers = {};

      try {
        const response = await this.backendApi("getSPDetailsOneSB", reqData, headers, "get");

        if (response === 'error') {
          this.apiError = true;
          return;
        }

        if (response && response.data) {
          console.log('response sp details:', response.data);

          if (response.data.status === "failed") {
            let msg = ['SP details are not available'];
            // this.$router.push({ path: '/networkalert', query: { backUrl: 'multi-quote', msg } });
            return;
          }

          this.spdata = response.data.data;
          sessionStorage.setItem("sp_details_data", JSON.stringify(this.spdata));
          this.spdataFlagForSQ = true;
          if(this.apiReqData?.distributor?.agentID){
            this.apiReqData.distributor.agentID = this.spdata.spCode;
          }

          for (let attr in this.spdata.attributes) {
            try {
              let varfield = {
                fieldName: attr,
                fieldValue: this.spdata.attributes[attr]
              };
              this.apiReqData.distributor.varFields.push(varfield);
            } catch (err) {
              console.log("varfield assignment failed", err);
            }
          }

          // Optional next step:
          // this.quotationSQcall();
        }

      } catch (error) {
        console.log('error msg block spdetailOneSB API', error);
        let msg = ['SP details are not available'];
        // this.$router.push({ path: '/networkalert', query: { backUrl: 'multi-quote', msg } });
      }
    },
    async getMotorProductSQ() {
      console.log(" inside getMotorProductSQ")
      this.loading2 = true;
      const startTime = Date.now();
      const maxPollingTime = 3 * 60 * 1000;
      let headers = { "Authorization": `Bearer ${this.$store.state.token}` };
      let reqData = [this.requestIdSQ];

      while (this.pollapiflagSQ && (Date.now() - startTime) < maxPollingTime) {
        try {
          if (this.$route.path !== "/policy-quote") {
            this.pollapiflagSQ = false;
            break;
          }
          const response = await this.backendApi("quotationPoll", reqData, headers, "get");
          if (response.data.errors.length > 0) {
            this.loading = false;
            for (let i = 0; i < response.data.errors.length; i++) {
              this.displayErrors.push(response.data.errors[i]["errorDisplayMessage"])
            }
            this.$router.push("/policy-quote");
          }
          if (response?.data?.data?.quote?.length > 0) {
            this.loading2 = false;
            this.suggestedIDV = response?.data?.data?.quote[0].supportingData.insuredDeclaredValue.suggestedIDV;
            this.responseData = response.data.data.quote;
            sessionStorage.setItem("selected_plan_data", JSON.stringify(this.responseData[0]));
            // if(this.addFilterdataInSession){
            //   this.responseData[0].productDetails.motorCovers=this.filteredOptions
            //   this.addFilterdataInSession=false;
            // }
            sessionStorage.setItem("quoteSingleData", JSON.stringify(this.responseData));
            sessionStorage.setItem("motor_covers", JSON.stringify(this.motorCovers));
            sessionStorage.setItem('fromDashboard', JSON.stringify(false));
            sessionStorage.removeItem('kycdata');
            if (shouldSkipGodigitKycOvd(this.responseData[0])) {
              sessionStorage.setItem("isUploadDocRequired", JSON.stringify(false));
              sessionStorage.removeItem("kyc_response");
              this.$router.push({ path: "/process-wizard" });
            } else {
              const isKyc = this.$store.state.configData['KYCMODE'];
              if (isKyc && isKyc[this.responseData[0]?.insuranceAndProducts?.insuranceCompanyCode] && isKyc[this.responseData[0]?.insuranceAndProducts?.insuranceCompanyCode] === 'PRE') {
                this.$router.push('/ckyc-form');
              } else {
                sessionStorage.setItem("isUploadDocRequired", JSON.stringify(true));
                sessionStorage.removeItem("kyc_response");
                this.$router.push({ path: "/process-wizard" });
              }
            }
          }
          if (response.data.data.isPollComplete == true) {
            this.loading2 = false;
            this.pollapiflagSQ = true;
            this.beforeDestroy();
            break;
          }
          if (response.data.errors.length > 0) {
            if (response.data.errors[0].errorIdentifier == "INVALID_REQUEST_ID") {
              this.pollapiflagSQ = true;
            }
          }
          await this.sleep(1000);
        } catch (err) {
          console.log('error msg block', err);
          this.loading = false;
        }
      };
      if ((Date.now() - startTime) >= maxPollingTime) {
        this.pollapiflagSQ = false;
        this.loading2 = false;
        this.loading = false;
      }
    },
    handleDateChange(dateValue, name, text) {
      this.modifyDate = name;
      this.modifyDateValue = dateValue;
      this.setDateText = text;
      this.dateError = "";
    },
    notEditingDate() {
      // Reset the date modification UI
      this.modifyDateValue = "";

      // Reload userData from session storage to discard any unsaved changes
      this.userData = JSON.parse(sessionStorage.getItem("userData"));

      // Clear any error messages
      this.dateError = "";

      // Close the date modification UI without changing any values
      this.modifyDate = "";

      // Make sure we don't trigger the refresh button
      this.isChangeFilter = false;
    },
    dateChangeOnMQ(e) {
      this.modifyDateValue = e.target.value;
      this.userData[this.modifyDate] = this.modifyDateValue;

      // Disable the Refresh Button based on Date
      const validDatePattern = /^\d{4}-\d{2}-\d{2}$/;
      const isValidDate = validDatePattern.test(e.target.value);

      if (this.modifyDate == "RegDate") {
        this.handleDateValidation(e);

        // If valid date, update manufacturing year options like in vehicleDetails.vue
        if (!this.dateError && isValidDate) {
          const selectedYear = new Date(this.modifyDateValue).getFullYear();

          // Set registration year for vehicle age calculations
          this.registrationYear = selectedYear;

          // Update userData with registration date
          this.userData = JSON.parse(sessionStorage.getItem("userData"));
          this.userData["RegDate"] = this.modifyDateValue;

          // Save to sessionStorage
          sessionStorage.setItem("userData", JSON.stringify(this.userData));

          // Update vehicle age calculations
          this.vehicleAge = this.currentYearCalculated - this.registrationYear;

          // Set change filter flag to trigger showing refresh button
          this.isChangeFilter = true;

          // Auto-close the date picker after valid selection
          // this.modifyDate = "";
        }
      } else if (this.modifyDate == "OdDate") {
        this.validateOdDate(e);

        if (!this.dateError && isValidDate) {
          // Update userData with OD date
          this.userData = JSON.parse(sessionStorage.getItem("userData"));
          this.userData["OdDate"] = this.modifyDateValue;

          // Save to sessionStorage
          sessionStorage.setItem("userData", JSON.stringify(this.userData));

          // Set change filter flag to trigger showing refresh button
          this.isChangeFilter = true;

          // Auto-close the date picker after valid selection
          // this.modifyDate = "";
        }
      } else if (this.modifyDate == "TpDate") {
        this.validateTpDate(e);
        // Handle TP date validation if needed
        if (isValidDate) {
          // Update userData with TP date
          this.userData = JSON.parse(sessionStorage.getItem("userData"));
          this.userData["TpDate"] = this.modifyDateValue;

          // Save to sessionStorage
          sessionStorage.setItem("userData", JSON.stringify(this.userData));

          // Set change filter flag to trigger showing refresh button
          this.isChangeFilter = true;

          // Auto-close the date picker after valid selection
          // this.modifyDate = "";
        }
      }

      if (isValidDate) {
        this.isRefreshButtonDisabled = false;
      } else {
        this.isRefreshButtonDisabled = true;
      }
    },
    handleDateValidation(e) {
      let inputDate = new Date(e.target.value);
      let maxDate = new Date(this.calculateMaxDate());
      let minDate = new Date(this.calculateMinDate());

      if (this.quoteCategory == "New") {
        if (inputDate < minDate || inputDate > maxDate) {
          e.target.value = "";
          this.modifyDateValue = '';
          this.dateError = "Registration Date can be between current date and upto 30 days in future";
        }
        else {
          this.dateError = "";
          this.modifyDateValue = e.target.value;
          if (this.modifyDateValue) {
            this.userData = JSON.parse(sessionStorage.getItem("userData"));
            this.userData["RegDate"] = this.modifyDateValue;

            // Update registration year
            const selectedYear = new Date(this.modifyDateValue).getFullYear();
            this.registrationYear = selectedYear;

            sessionStorage.setItem("userData", JSON.stringify(this.userData));
          }
        }
      }
      else {
        if (inputDate > maxDate || inputDate < minDate) {
          e.target.value = "";
          this.modifyDateValue = '';
          if (this.quoteCategory == "Roll-Over") {
            // this.dateError = "Registration date cannot be less than 10 months in the past";
            this.dateError = "Registration date cannot be more than 25 years in the past";
          }
        } else {
          this.dateError = "";
          this.modifyDateValue = e.target.value;
          if (this.modifyDateValue) {
            this.userData = JSON.parse(sessionStorage.getItem("userData"));
            this.userData["RegDate"] = this.modifyDateValue;

            // Update registration year
            const selectedYear = new Date(this.modifyDateValue).getFullYear();
            this.registrationYear = selectedYear;

            sessionStorage.setItem("userData", JSON.stringify(this.userData));
          }
        }
      }
    },
    calculateMaxDate() {
      let today = new Date();
      let maxDate = new Date(today);
      if (this.quoteCategory == "Roll-Over") {
        maxDate.setMonth(maxDate.getMonth() - 10);
        let yyyy = maxDate.getFullYear();
        let mm = String(maxDate.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        let dd = String(maxDate.getDate()).padStart(2, '0');
        return `${yyyy}-${mm}-${dd}`;
      }
      if (this.quoteCategory == "New") {
        maxDate.setDate(maxDate.getDate() + 30);
        let yyyy = maxDate.getFullYear();
        let mm = String(maxDate.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        let dd = String(maxDate.getDate()).padStart(2, '0');
        return `${yyyy}-${mm}-${dd}`;
      }
    },

    calculateMinDate() {
      let today = new Date();
      if (this.quoteCategory == "New") {
        let yyyy = today.getFullYear();
        let mm = String(today.getMonth() + 1).padStart(2, '0'); // Months are zero-based
        let dd = String(today.getDate()).padStart(2, '0');
        return `${yyyy}-${mm}-${dd}`;
      }
      if (this.quoteCategory === "Roll-Over") {
        const minDate = new Date(today);
        minDate.setFullYear(today.getFullYear() - 25);
        let yyyy = minDate.getFullYear();
        let mm = String(minDate.getMonth() + 1).padStart(2, '0');
        let dd = String(minDate.getDate()).padStart(2, '0');
        return `${yyyy}-${mm}-${dd}`;
      }

      return `1950-10-11`;
    },
    minOdDate(){
      let today;
      if (this.userData?.RegDate) {
        today = new Date(this.userData?.RegDate);
      } else {
        today = new Date();
      }

      const minDate = new Date(today);
      minDate.setDate(today.getDate() - 60);
      return minDate.toISOString().split('T')[0];
    },
    validateOdDate(e) {
      const inputDate = new Date(e.target.value);
      const maxDate = new Date(this.maxOdTpDate());
      if (inputDate > maxDate) {
        e.target.value = this.maxOdTpDate();
        this.modifyDateValue = this.maxOdTpDate();
        this.dateError = "Expiry Date can not be greater than 60 days in future"
      } else {
        this.dateError = "";
        this.modifyDateValue = e.target.value;
      }
    },
    validateTpDate(e) {
      const inputDate = new Date(e.target.value);
      const maxDate = new Date(this.maxTpDate());
      if (inputDate > maxDate) {
        e.target.value = this.maxTpDate();
        this.modifyDateValue = this.maxTpDate();
        this.dateError = `TP Expiry Date cannot be more than ${this.motorProductType === '2W-Pvt' ? 5 : 3} years in future.`
      } else {
        this.dateError = "";
        this.modifyDateValue = e.target.value;
      }
    },
    maxOdTpDate() {
      const today = new Date();
      const maxDate = new Date(today);
      maxDate.setDate(today.getDate() + 60);
      return maxDate.toISOString().split('T')[0];
    },
    maxTpDate() {
      const today = new Date(this.userData.RegDate);
      const maxDate = new Date(today);
      let vehType = this.motorProductType === '2W-Pvt' ? 5 : 3;
      maxDate.setFullYear(today.getFullYear() + Number(vehType));
      return maxDate.toISOString().split('T')[0];
    },
    removeFromFilter(multi_quote_response_id) {
      this.compareList = this.compareList.filter(item => item.multi_quote_response_id !== multi_quote_response_id);
    },
    isInCompareList(item) {
      return this.compareList.some(i => i.multi_quote_response_id === item.multi_quote_response_id);
    },
    toggleCompare(item) {
      const index = this.compareList.findIndex(i => i.multi_quote_response_id === item.multi_quote_response_id);
      if (index === -1) {
        this.compareList.push(item);
      } else {
        this.compareList.splice(index, 1);
      }
      if (this.compareList.length > 0) {
        this.showCompareFooter = true;
      }
    },
    // Add method to open IDV modal
    openIDVModal() {
      // Ensure product.idvDetails exists
      if (this.loading2) {
        return;
      }
      if (!this.requestBody.product) {
        this.requestBody.product = {};
      }
      if (!this.requestBody.product.idvDetails) {
        this.requestBody.product.idvDetails = { insuredDeclaredValue: 0 };
      }

      // Initialize selectedIDV with the current insuredDeclaredValue
      const currentIDV = this.requestBody.product.idvDetails.insuredDeclaredValue || 0;
      this.selectedIDV = currentIDV;

      // Set needIDV based on current value (true if value > 0, false if 0)
      // If IDV is 0, we explicitly want needIDV to be false
      // If IDV is undefined or null, default to true
      // this.needIDV = currentIDV === 0 ? false : true;

      // Initialize idvSelector based on the current value
      if (currentIDV === this.minIDV) {
        this.idvSelector = 'minimum';
      } else if (currentIDV === this.maxIDV) {
        this.idvSelector = 'maximum';
      } else if (currentIDV > 0) {
        this.idvSelector = 'custom';
      } else {
        this.idvSelector = '';
      }
      this.needIDV = true;
      this.changeIDV = true;
    },
    isMobileView() {
      return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    },
    openDatePicker(id) {
      document.getElementById(id).click();
    },
  },
  computed: {
    currentYearCalculated() {
      return new Date().getFullYear();
    },
    // Add a computed property to determine if the IDV has a valid value
    hasValidIDV() {
      return this.requestBody?.product?.idvDetails?.insuredDeclaredValue > 0;
    },
    displayedAddons() {
      // Show all add-ons if `showAll` is true, otherwise only the first 6
      // return this.showAll ? this.uniqueAddons : this.uniqueAddons.slice(0, 6);
    },
    currentDate() {
      const today = new Date();
      const yyyy = today.getFullYear();
      const mm = String(today.getMonth() + 1).padStart(2, '0'); // Months are zero-based
      const dd = String(today.getDate()).padStart(2, '0');
      return `${yyyy}-${mm}-${dd}`;
    },
    checkAddonDisability() {
      if (this.errorContainerAndOthers.length == 0) return false;

      return this.errorContainerAndOthers.some(
        addon => addon.errorMessage !== ""
      );
    },
    motorProductType() {
      return this.$store.state.motorProductType;
    },
    idvValues() {
      return {
        min: this.minIDV,
        max: this.maxIDV,
        suggested: this.suggestedIDV,
        selected: this.selectedIDV
      };
    },
    filteredAndSortedData() {
      let filtered = this.responseData.filter(data => 
        data.insuranceAndProducts.policyType === this.activePolicyType
      );
      
      if (this.sortOrder === 1) {
        // Low to High
        filtered.sort((a, b) =>
          Number(a.productDetails.totalPremiumDetails[0].totalPremiumWithTax) -
          Number(b.productDetails.totalPremiumDetails[0].totalPremiumWithTax)
        ).filter((item, index, self) => {
          return index === self.findIndex(other =>
            other.insuranceAndProducts.productCode === item.insuranceAndProducts.productCode && other.productDetails.totalPremiumDetails[0].totalPremiumWithTax === item.productDetails.totalPremiumDetails[0].totalPremiumWithTax
          )
        })
      } else if (this.sortOrder === 2) {
        // High to Low
        filtered.sort((a, b) =>
          Number(b.productDetails.totalPremiumDetails[0].totalPremiumWithTax) -
          Number(a.productDetails.totalPremiumDetails[0].totalPremiumWithTax)
        ).filter((item, index, self) => {
          return index === self.findIndex(other =>
            other.insuranceAndProducts.productCode === item.insuranceAndProducts.productCode && other.productDetails.totalPremiumDetails[0].totalPremiumWithTax === item.productDetails.totalPremiumDetails[0].totalPremiumWithTax
          )
        })
      }
      
      return filtered;
    },
    isSendQuotes() {
      return getDistributer()["sendQuote"];
    }
  },
  watch: {
    needIDV(newValue) {
      // Clear idvSelector when needIDV is toggled off
      if (!newValue) {
        this.idvSelector = '';
      }
    }
  },
};
</script>
<style scoped lang="scss">
@import "../../assets/scss/components/multi-quotes.scss";
@import "../../assets/scss/components/filters.scss";
@import "../../assets/scss/components/select-card.scss";

.dark {
  .doticon {
    filter: invert(1);
  }
}

.container {
  display: flex;
  justify-content: space-between;
  flex-direction: row;
}

.fadeAndSlide-enter-from,
.fadeAndSlide-leave-to {
  opacity: 0;
}

.fadeAndSlide-enter-active,
.fadeAndSlide-leave-active {
  transition: opacity 0.3s ease-in-out;
}

.price::before {
  content: '\20B9';
  margin-right: 5px;
}

.idvError {
  margin-top: 8px !important;
  // color: #07b154 !important;
  color: $error-txt !important;
  opacity: 1 !important;
  font-size: 14px;
}

.request_Id {
  position: relative;
  font-size: 14px;
  color: $commonColorDark;
  border-radius: 8px;
  border: 1px solid $border-color;
  align-items: center;
  box-shadow: 2px 2px 4px 0 rgba(0, 0, 0, 0.08);

  img {
    margin-left: auto;
    cursor: pointer;
    border: none;
    width: 20px;
    height: 20px;
  }
  .copy_container {
    position: relative;

    img {
      width: 20px !important;
      border: none;
    }

    .copy-icon {
      transform: scale(1.5);
      height: 16px !important;
    }

    .copy-icon-tick {
      transform: scale(1);
      margin-left: auto !important;
    }

    .copy_tooltip {
      opacity: 0;
      visibility: hidden;
      position: absolute;
      top: -26px;
      left: -12px;
      font-size: 14px;
      color: $commonColor;
      background-color: $cardBackgroundDark;
    }

    &:hover {
      .copy_tooltip {
        visibility: visible;
        opacity: 1;
      }
    }
  }

  strong {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}

.sq_errors-container {
  border-color: $error-txt !important;
  border-bottom: 1px solid $heading-darkColor !important;
  span {
    color: $error-txt !important;
  }
}

 .ownership_transfer_container{
    .form-check-label{
      font-size: 14px !important;
    }
    .form-check-input{
      transform: scale(1.5);
    }
  }


.navigation-policytypes-wrapper {
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  -ms-overflow-style: none;
  scrollbar-width: none;
  border-radius: 0px;

  &::-webkit-scrollbar {
    display: none;
  }
}
.policyTypes_wrapper{
  border-bottom: 1px solid $active;
}
.custom-dropdown .dropdown-toggle {
  background-color: transparent;
  border: none;
  color: $base-text;
  box-shadow: none;
  padding: 0;
  &:focus{
    background-color: transparent;
  }
}

.custom-dropdown .dropdown-toggle::after {
  display: none;
}

.custom-dropdown .dropdown-menu {
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  .highlight-sorting{
    background-color: $input-border !important;
  }
}

.custom-dropdown .dropdown-item {
  color: $base-text;
}

.custom-dropdown .dropdown-item:hover {
  background-color: $base-dark-text;
}

.zeroDep_Selection{ 
  .form-switch{
    padding-left: 0;
    transform: scale(0.8);
    transform-origin: left;
  }
}

.idvOverlay{
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.1);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 100;
    backdrop-filter: blur(4px);

  .overlay_container {
    max-width: 420px;
    width: 90%;
    background-color: $commonColor;
    border-radius: 12px;

    .header-idv {
      border-bottom: 1px solid $table-td;
      margin-bottom: 12px;

    }

    h4 {
      font-size: 16px;
      opacity: 1;
      margin-left: none !important;
      color: $cardBackgroundDark;
    }

    .radio_selector-idv {
      input[type="radio"] {
        width: 18px;
        aspect-ratio: 1/1;
      }

      input[type="number"]{
        font-size: 16px !important;
      }

      p {
        font-size: 16px;
        opacity: 1;
        margin-left: auto !important;
        color: $active;
      }

    }

    label {
      color: $heading-color;
      font-size: 16px;
    }
    .accordion-item{
      .accordion-button{
        background-color: transparent !important;
        &:focus{
          outline: none;
        }
      }
    }
  }
}

.ncbOverlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
  backdrop-filter: blur(4px);

  .overlay_container {
    max-width: 400px;
    width: 90%;
    background-color: $commonColor;
    border-radius: 12px;

  }
}

.navigation-policytypes {
  border-radius: 0;
  white-space: nowrap;
  min-width: min-content;


  button {
    border-radius: 4px 4px 0 0;
    white-space: nowrap;
    flex: 0 0 auto;
    transition: background-color 0.3s ease;
    font-size: 14px;

    &.active {
      color: $commonColor;
      border: 1px solid;
      border-bottom: 2px solid $active;
      margin-bottom: -1px;
      background: $active;
    }
  }
  .nav-link-sorting{
    margin-left: auto !important;
  }

  .error-text {
    color: $error-txt !important;
    font-family: $fontFamily;
    font-size: 12px;
  }

  .errorField {
    border-color: #F00 !important;
  }
}

.dark {
  .navigation-policytypes {
    border-radius: 0;
    white-space: nowrap;
    min-width: min-content;
    border-bottom: 1px solid $active;

    button {
      border-radius: 4px 4px 0 0;
      white-space: nowrap;
      flex: 0 0 auto;
      transition: background-color 0.3s ease;
      font-size: 14px;

      &.active {
        color: $active;
        border: 1px solid;
        border-bottom: 2px solid $commonColorDark;
        margin-bottom: -1px;
      }
    }

    .error-text {
      color: $error-txt !important;
      font-family: $fontFamily;
      font-size: 12px;
    }

    .errorField {
      border-color: #F00 !important;
    }
  }
  .sq_errors-container {
    background-color: $cardBackgroundDark !important;
    border-bottom: 1px solid  $table-td !important;
  }
  .custom-dropdown .dropdown-toggle {
    background-color: transparent;
    color: $commonColor !important;
  }

  .has-breakin {
    // background: $header-dark-bg;
    font-size: 12px !important;
  }

  .headingcards .has-breakin span {
    color: #EC920F !important;
  }

  .idvOverlay,
  .ncbOverlay {
    .overlay_container {
      background-color: $cardBackgroundDark;
      border: 1px solid $heading-darkColor;

      .radio_selector-idv p {
        color: $active !important;
      }

      h4 {
        font-size: 16px;
        opacity: 1;
        margin-left: none !important;
        color: $heading-darkColor;
      }

      span,
      p,
      strong {
        color: $heading-darkColor;
        opacity: 1;
      }

      .closeModal {
        color: $heading-darkColor;
      }

      .radio_selector-idv label {
        color: $heading-darkColor;
      }
    }
  }

  .accordion-item{
    background-color: $heading-color !important;
    button{
      color: $commonColor !important;
      &::after{
        filter: brightness(4) !important;
      }
    }
    .accordion-item{
      border: none !important;
    }
  }
}

.show-breakup-link {
  font-size: 12px;
  // text-decoration: underline;
  cursor: pointer;
  transition: color 0.3s ease;
  color: $main-bg !important;
}

.dark .headingcards .show-breakup-link {
  color: $main-bg !important;
}

.expansion-button {
  font-size: 12px !important;
  display: block;
  color: $main-bg;
  text-decoration: underline;
  background: $border-color;
  padding: 3px 10px;
  border-radius: 50px;
}

.dark {
  .expansion-button {
    background: $cardBackgroundDark;
  }
}

.expand {
  overflow: hidden;
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  height: 30px;
}

.specifications {
  max-height: 25px;
}

.bottomalignment {
  padding: 5px;
  margin-top: 5px;
}

.idv_values_mq {
  strong {
    // color: $main-bg !important;
    font-size: 11px !important;
    font-weight: 600 !important;
  }
}

.downloadBroucher {
  border-radius: 50px;
  padding: 6px 8px;
  background: #f4f4f4;
}

.select-all {
  input[type="checkbox"] {
    width: 20px;
    height: 20px;
  }
}

.date_heading {
  font-size: 16px;
  font-weight: 800 !important;
}

.flip-container {
  position: relative;
  width: 100%;
  height: 360px;
  /* Adjust based on content */
  perspective: 1000px;
}

.flip-container-new{
  height: 130px !important;
}

.flip-container-tp{
  height: 480px !important;
}

.flip-inner {
  width: 100%;
  height: 100%;
  position: relative;
  transform-style: preserve-3d;
  transition: transform 0.6s ease-in-out;
  border-radius: 8px;
  .prev_insurer-detail {
    cursor: default;
    position: relative;

    &:hover .insurer_name {
      opacity: 1;
      visibility: visible;
    }

    .insurer_name {
      background-color: $commonColor;
      border-radius: 8px;
      padding: 6px 8px;
      position: absolute;
      top: -30%;
      right: 0%;
      transform: translateX(0%) translateY(-100%);
      width: 250px !important;
      text-align: center;
      opacity: 0;
      visibility: hidden; // fix from 'none'
      transition: all 0.2s ease-in-out;
      border: 1px solid $base-dark-text;
      box-shadow: 4px 4px 4px 0 rgba(0,0,0,0.1);
      font-size: 12px !important;
      // Prevent hover from triggering on this element
      pointer-events: none;
    }
  }
}

.flipped .flip-inner {
  transform: rotateY(180deg);
}

/* Front & Back Styles */
.front,
.back {
  position: absolute;
  width: 100%;
  height: 100%;
  backface-visibility: hidden;
}

.back {
  transform: rotateY(180deg);
}

.has-breakin {
  border-radius: 12px;
  // background: $base-dark-text;
  font-size: 12px !important;
  color: #EC920F !important;
  width: fit-content;
}

.individual-Addon {
  position: relative !important;
  border-radius: 4px;
  cursor: pointer;

  input[type="checkbox"] {
    width: 20px;
    height: 20px;
  }

  &>* {
    cursor: pointer;
  }

  &:hover {
    background: $heading-darkColor;

    .hover-dispaly {
      opacity: 1 !important;
      visibility: visible;
      top: 34px;
    }

    .set_hover-position {
      top: 80px;
    }
    .set_zeroDep {
      left: 20px;
      top: 132px;
    }
  }
  .personal_accident-reason{
    background: $heading-darkColor;
    strong{
      color: $success !important;
    }
  }
}

.idvValue {
  svg {
    cursor: pointer;
    width: 12px;
    height: 12px;
    fill: $main-bg !important;
  }
}

.ncb_Discount-Message{
  background-color: #FEFAE0 !important;
  border-radius: 8px;
  overflow: hidden;
  padding: 8px 12px;
  p{
    transform: translateY(20px);
    opacity: 0;
    visibility: hidden;
    color: #40220A !important;
    font-size: 14px !important;
    animation: slideIn 0.5s cubic-bezier(0.215, 0.610, 0.355, 1) forwards;
  }
}
@keyframes slideIn {
  0%{
    opacity: 0;
    visibility: hidden;
    transform: translateY(20px);
  }
  100%{
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
  }
}

.paCvrOverlay {
  position: fixed !important;
  top: 0 !important;
  left: 0 !important;
  width: 100vw;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;
  backdrop-filter: blur(4px);

  .overlay_container {
    overflow: hidden;
    border: 1px solid $text-darkColor !important;
    max-width: 480px;
    width: 90%;
    background-color: $commonColor;
    border-radius: 12px;

    .header-pacvr {
      border-top-left-radius: 12px;
      border-top-right-radius: 12px;
      background-color: $commonColorDark;
      padding: 6px 18px;

      .closeModal {
        color: $commonColor;
      }
    }


    strong {
      font-size: 16px;
      font-weight: 700;
      color: $commonColor;
    }

    p {
      font-size: 14px;
      line-height: 140%;
    }

    .btn {
      padding: 6px 24px;
      font-size: 14px;
      color: $base-text;

      &:disabled {
        max-width: 72px;
      }
    }

    .submit-btn {
      color: $commonColor;
      background-color: $main-bg;
    }

    .cancel-btn {
      border: 1px solid $base-text;
    }
  }
}

.hover-dispaly {
  position: absolute;
  top: 50px;
  left: 50px;
  width: 300px;
  opacity: 0 !important;
  visibility: hidden;
  background: $cardBg;
  border-radius: 4px;
  color: $text-color !important;
  box-shadow: 0px 4px 4px 0 rgba(0, 0, 0, 0.2);
  line-height: 155%;
  z-index: 10;
  transition: all 0.3s ease-in-out;
  transition: opacity 0.3s ease-out, top 0.3s ease-out, visibility 0.3s;

  &::after {
    content: "";
    position: absolute;
    bottom: 100%;
    left: 10%;
    transform: translateX(-50%);
    border-width: 6px;
    border-style: solid;
    border-color: transparent transparent $cardBackgroundDark transparent; // Triangle pointing down
  }
}

.errorMessage {
  color: $error-txt;
}

.dark .hover-dispaly {
  position: absolute;
  top: 50px;
  left: 50px;
  width: 300px;
  opacity: 0 !important;
  visibility: hidden;
  background: $cardBgDark;
  border-radius: 4px;
  color: $commonColor !important;
  box-shadow: 0px 4px 4px 0 rgba(0, 0, 0, 0.2);
  line-height: 155%;
  z-index: 10;
  transition: all 0.3s ease-in-out;
  transition: opacity 0.3s ease-out, top 0.3s ease-out, visibility 0.3s;

  &::after {
    content: "";
    position: absolute;
    bottom: 100%;
    left: 10%;
    transform: translateX(-50%);
    border-width: 6px;
    border-style: solid;
    border-color: transparent transparent $cardBackgroundDark transparent; // Triangle pointing down
  }
}

.dark .idv_values_mq {
  background: $cardBackgroundDark;
}

.apply-button {
  width: fit-content !important;
  font-size: 16px;
  margin-top: 120px;
}

.close_icon {
  cursor: pointer;
}

.set-page {
  position: absolute;
  top: -10px;
  bottom: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  z-index: 2;
  backdrop-filter: blur(4px);
}

@media (max-width: 768px) {
  input[type="date"] {
    position: relative;
    appearance: none;
    -webkit-appearance: none;
    -moz-appearance: textfield;
  }

  input[type="date"]::-webkit-calendar-picker-indicator {
    opacity: 0;
    position: absolute;
    width: 100%;
    height: 100%;
    cursor: pointer;
  }
}

.calender-img {
  position: absolute;
  top: 10px;
  right: 7px;
  bottom: 0;
  width: 15px;
  height: 15px;
  z-index: 1;
}

.data-placeholder {
  position: absolute;
  top: 9px;
  left: 12px;
  font-size: 0.813rem;
  z-index: 1;
}

.dark {
  .data-placeholder {
    color: white;
  }
  .personal_accident-reason{
    background: $cardBackgroundDark !important;
    strong{
      color: $success !important;
    }
  }
  .body-pacvr{
    background: $header-dark-bg !important;
    p{
      color: $commonColor;
    }
  }
  .paCvrOverlay{
    .cancel-btn {
      border: 1px solid $text-darkColorTransparent !important;
      color: $text-darkColorTransparent !important;
    }
  }
  .prev_insurer-detail{
    .insurer_name{
      background-color: $cardBackgroundDark !important;
      border: 1px solid $text-darkColor !important;
    }

  }
}
.dark .ncb_Discount-Message{
  background: $header-dark-bg !important;
  p{
    color: #EC9221 !important;
  }
}

/* Toggle Switch Styles */
.toggle-container {
  display: flex;
  align-items: center;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* Container around the slider */
.switch {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 22px;
  margin-left: 8px;
}

/* Slider background */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: 0.4s;
  border-radius: 34px;
}

/* The slider circle */
.slider:before {
  position: absolute;
  content: "";
  height: 16px;
  width: 16px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}

/* Toggle ON state */
input:checked+.slider {
  background-color: $main-bg;
}

input:checked+.slider:before {
  transform: translateX(18px);
}

.download_quote{
  cursor: pointer;
  img{
    border: none !important;
    width: 20px !important;
    height: 20px !important;
    border-radius: 0px !important;
  }
}
</style>